{
  "level": "mt04a",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:mt04a",
    "objects": "AREAS.E3:mt04a.e3",
    "mesh": "TREES.E3:mt04a.e3"
  },
  "spawn_point": {
    "position": [
      -660.2553738624192,
      -2712.9709329556495,
      784.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      -660.2553738624192,
      -2612.9709329556495,
      784.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -871.5,
      -2863.199951171875,
      760.0
    ],
    "bbox_max": [
      -567.0,
      -2625.0,
      830.0
    ],
    "vertex_count": 1962,
    "vertices": [
      [
        -808.0,
        -2730.0,
        760.0
      ],
      [
        -778.5,
        -2730.0,
        760.0
      ],
      [
        -685.5,
        -2730.0,
        760.0
      ],
      [
        -656.0,
        -2730.0,
        760.0
      ],
      [
        -685.5,
        -2730.0,
        760.0
      ],
      [
        -716.5,
        -2730.0,
        760.0
      ],
      [
        -747.5,
        -2730.0,
        760.0
      ],
      [
        -716.5,
        -2730.0,
        760.0
      ],
      [
        -778.5,
        -2730.0,
        760.0
      ],
      [
        -747.5,
        -2730.0,
        760.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        760.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        760.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        760.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        760.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        760.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        760.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        760.0
      ],
      [
        -871.5,
        -2715.0,
        760.0
      ],
      [
        -871.5,
        -2715.0,
        760.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        760.0
      ],
      [
        -840.5,
        -2708.11181640625,
        760.0
      ],
      [
        -838.5,
        -2708.11181640625,
        760.0
      ],
      [
        -838.5,
        -2708.11181640625,
        760.0
      ],
      [
        -839.0,
        -2707.51171875,
        760.0
      ],
      [
        -567.0,
        -2625.0,
        766.0
      ],
      [
        -567.0,
        -2675.0,
        766.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -716.5,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -747.5,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -654.0,
        -2633.0,
        766.0
      ],
      [
        -685.5,
        -2633.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2633.0,
        766.0
      ],
      [
        -778.5,
        -2633.0,
        766.0
      ],
      [
        -654.0,
        -2633.0,
        766.0
      ],
      [
        -610.0,
        -2633.0,
        766.0
      ],
      [
        -567.0,
        -2625.0,
        766.0
      ],
      [
        -607.0,
        -2625.0,
        766.0
      ],
      [
        -607.0,
        -2633.0,
        766.0
      ],
      [
        -607.0,
        -2625.0,
        766.0
      ],
      [
        -607.0,
        -2635.000244140625,
        760.0
      ],
      [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      [
        -656.0,
        -2730.0,
        764.0001220703125
      ],
      [
        -656.0,
        -2730.0,
        760.0
      ],
      [
        -567.0,
        -2675.0,
        766.0
      ],
      [
        -607.0,
        -2675.0,
        766.0
      ],
      [
        -654.0,
        -2667.0,
        766.0
      ],
      [
        -656.0,
        -2667.0,
        766.0
      ],
      [
        -656.0,
        -2665.0,
        760.0
      ],
      [
        -610.0,
        -2667.0,
        766.0
      ],
      [
        -654.0,
        -2667.0,
        766.0
      ],
      [
        -607.0,
        -2665.0,
        760.0
      ],
      [
        -607.0,
        -2675.0,
        766.0
      ],
      [
        -607.0,
        -2667.0,
        766.0
      ],
      [
        -586.0,
        -2665.01171875,
        760.0355224609375
      ],
      [
        -579.0,
        -2665.01171875,
        760.0355224609375
      ],
      [
        -579.5,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -585.5,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -586.0,
        -2665.01171875,
        760.0355224609375
      ],
      [
        -586.0,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -579.0,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -579.0,
        -2665.01171875,
        760.0355224609375
      ],
      [
        -585.5,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -585.5,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -585.699951171875,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -586.0,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -585.5,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -585.699951171875,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -579.300048828125,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -579.0,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -579.5,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -579.5,
        -2665.349853515625,
        761.0498657226562
      ],
      [
        -579.5,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -579.300048828125,
        -2666.439453125,
        764.3182373046875
      ],
      [
        -586.0,
        -2650.19677734375,
        766.0
      ],
      [
        -586.0,
        -2652.854248046875,
        766.0
      ],
      [
        -586.0,
        -2650.19677734375,
        766.0
      ],
      [
        -579.0,
        -2650.19677734375,
        766.0
      ],
      [
        -579.0,
        -2652.854248046875,
        766.0
      ],
      [
        -579.0,
        -2650.19677734375,
        766.0
      ],
      [
        -579.5,
        -2652.8544921875,
        766.0
      ],
      [
        -585.5,
        -2652.854248046875,
        766.0
      ],
      [
        -585.5,
        -2652.854248046875,
        766.0
      ],
      [
        -585.5,
        -2662.194091796875,
        766.0
      ],
      [
        -585.699951171875,
        -2662.194091796875,
        766.0
      ],
      [
        -586.0,
        -2652.854248046875,
        766.0
      ],
      [
        -585.5,
        -2662.194091796875,
        766.0
      ],
      [
        -585.699951171875,
        -2662.194091796875,
        766.0
      ],
      [
        -579.300048828125,
        -2662.1943359375,
        766.0
      ],
      [
        -579.0,
        -2652.854248046875,
        766.0
      ],
      [
        -579.5,
        -2662.1943359375,
        766.0
      ],
      [
        -579.5,
        -2652.8544921875,
        766.0
      ],
      [
        -579.5,
        -2662.1943359375,
        766.0
      ],
      [
        -579.300048828125,
        -2662.1943359375,
        766.0
      ],
      [
        -607.0,
        -2662.5,
        766.0
      ],
      [
        -607.0,
        -2637.5,
        766.0
      ],
      [
        -610.0,
        -2633.0,
        766.0
      ],
      [
        -610.0,
        -2637.5,
        766.0
      ],
      [
        -610.0,
        -2662.5,
        766.0
      ],
      [
        -610.0,
        -2667.0,
        766.0
      ],
      [
        -607.0,
        -2662.5,
        766.0
      ],
      [
        -610.0,
        -2662.5,
        766.0
      ],
      [
        -607.0,
        -2637.5,
        766.0
      ],
      [
        -610.0,
        -2637.5,
        766.0
      ],
      [
        -808.0,
        -2700.28564453125,
        766.0
      ],
      [
        -808.0,
        -2700.28564453125,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -808.0,
        -2728.199951171875,
        766.0
      ],
      [
        -808.0,
        -2730.0,
        760.0
      ],
      [
        -808.0,
        -2730.0,
        764.0001220703125
      ],
      [
        -812.4000244140625,
        -2633.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2667.0,
        766.0
      ],
      [
        -812.0,
        -2705.0,
        765.0
      ],
      [
        -812.0,
        -2701.0,
        765.0
      ],
      [
        -812.0,
        -2725.0,
        765.0
      ],
      [
        -812.0,
        -2705.0,
        765.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        765.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        765.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        765.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        765.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        765.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        765.0
      ],
      [
        -871.5,
        -2715.0,
        765.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        765.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        765.0
      ],
      [
        -871.5,
        -2715.0,
        765.0
      ],
      [
        -840.5,
        -2708.11181640625,
        765.0
      ],
      [
        -838.5,
        -2708.11181640625,
        765.0
      ],
      [
        -838.5,
        -2708.11181640625,
        765.0
      ],
      [
        -839.0,
        -2707.51171875,
        765.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        766.0
      ],
      [
        -860.38818359375,
        -2698.3701171875,
        766.0
      ],
      [
        -866.22802734375,
        -2727.72802734375,
        766.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        766.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        766.0
      ],
      [
        -866.22802734375,
        -2702.27197265625,
        766.0
      ],
      [
        -871.5,
        -2715.0,
        766.0
      ],
      [
        -870.1298828125,
        -2708.11181640625,
        766.0
      ],
      [
        -870.1298828125,
        -2721.88818359375,
        766.0
      ],
      [
        -871.5,
        -2715.0,
        766.0
      ],
      [
        -836.8701171875,
        -2708.11181640625,
        766.0
      ],
      [
        -825.0,
        -2708.5,
        766.0
      ],
      [
        -824.0,
        -2705.0,
        766.0
      ],
      [
        -821.5,
        -2700.0,
        766.0
      ],
      [
        -838.545654296875,
        -2708.05712890625,
        766.0
      ],
      [
        -839.0,
        -2707.51171875,
        766.0
      ],
      [
        -838.545654296875,
        -2708.05712890625,
        765.0
      ],
      [
        -824.0,
        -2705.0,
        766.0
      ],
      [
        -824.0,
        -2708.53271484375,
        765.0
      ],
      [
        -824.0,
        -2708.53271484375,
        766.0
      ],
      [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      [
        -824.0,
        -2719.10009765625,
        766.0
      ],
      [
        -824.0,
        -2725.0,
        766.0
      ],
      [
        -840.5,
        -2708.11181640625,
        766.0
      ],
      [
        -838.5,
        -2708.11181640625,
        766.0
      ],
      [
        -838.5,
        -2708.11181640625,
        766.0
      ],
      [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      [
        -825.0,
        -2710.89990234375,
        766.0
      ],
      [
        -825.0,
        -2719.10009765625,
        766.0
      ],
      [
        -824.0,
        -2719.10009765625,
        766.0
      ],
      [
        -812.0,
        -2666.666748046875,
        765.0
      ],
      [
        -808.0,
        -2665.0,
        760.0
      ],
      [
        -808.0,
        -2666.666748046875,
        765.0
      ],
      [
        -808.0,
        -2667.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2667.0,
        766.0
      ],
      [
        -806.0,
        -2667.0,
        766.0
      ],
      [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      [
        -782.0,
        -2667.0,
        766.0
      ],
      [
        -775.0,
        -2667.0,
        766.0
      ],
      [
        -777.0,
        -2688.0,
        766.0
      ],
      [
        -777.0,
        -2678.0,
        766.0
      ],
      [
        -777.0,
        -2688.0,
        766.0
      ],
      [
        -780.0,
        -2688.0,
        766.0
      ],
      [
        -751.0,
        -2667.0,
        766.0
      ],
      [
        -744.0,
        -2667.0,
        766.0
      ],
      [
        -746.0,
        -2688.0,
        766.0
      ],
      [
        -746.0,
        -2678.0,
        766.0
      ],
      [
        -746.0,
        -2688.0,
        766.0
      ],
      [
        -749.0,
        -2688.0,
        766.0
      ],
      [
        -720.0,
        -2667.0,
        766.0
      ],
      [
        -713.0,
        -2667.0,
        766.0
      ],
      [
        -715.0,
        -2688.0,
        766.0
      ],
      [
        -715.0,
        -2678.0,
        766.0
      ],
      [
        -715.0,
        -2688.0,
        766.0
      ],
      [
        -718.0,
        -2688.0,
        766.0
      ],
      [
        -682.0,
        -2667.0,
        766.0
      ],
      [
        -689.0,
        -2667.0,
        766.0
      ],
      [
        -684.0,
        -2688.0,
        766.0
      ],
      [
        -684.0,
        -2678.0,
        766.0
      ],
      [
        -687.0,
        -2678.0,
        766.0
      ],
      [
        -687.0,
        -2688.0,
        766.0
      ],
      [
        -684.0,
        -2688.0,
        766.0
      ],
      [
        -687.0,
        -2688.0,
        766.0
      ],
      [
        -658.0,
        -2667.0,
        766.0
      ],
      [
        -656.0,
        -2685.60009765625,
        766.0
      ],
      [
        -808.0,
        -2730.0,
        766.0
      ],
      [
        -656.0,
        -2730.0,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        760.0
      ],
      [
        -778.5,
        -2760.0,
        760.0
      ],
      [
        -685.5,
        -2760.0,
        760.0
      ],
      [
        -656.0,
        -2760.0,
        760.0
      ],
      [
        -685.5,
        -2760.0,
        760.0
      ],
      [
        -716.5,
        -2760.0,
        760.0
      ],
      [
        -747.5,
        -2760.0,
        760.0
      ],
      [
        -716.5,
        -2760.0,
        760.0
      ],
      [
        -778.5,
        -2760.0,
        760.0
      ],
      [
        -747.5,
        -2760.0,
        760.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        760.0
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        760.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        760.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        760.0
      ],
      [
        -871.5,
        -2775.0,
        760.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        760.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        760.0
      ],
      [
        -871.5,
        -2775.0,
        760.0
      ],
      [
        -778.5,
        -2857.0,
        766.0
      ],
      [
        -747.5,
        -2857.0,
        766.0
      ],
      [
        -685.5,
        -2857.0,
        766.0
      ],
      [
        -716.5,
        -2857.0,
        766.0
      ],
      [
        -747.5,
        -2857.0,
        766.0
      ],
      [
        -716.5,
        -2857.0,
        766.0
      ],
      [
        -778.5,
        -2857.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2857.0,
        766.0
      ],
      [
        -685.5,
        -2857.0,
        766.0
      ],
      [
        -640.0,
        -2857.0,
        766.0
      ],
      [
        -656.0,
        -2761.800048828125,
        766.0
      ],
      [
        -656.0,
        -2804.39990234375,
        766.0
      ],
      [
        -656.0,
        -2760.0,
        760.0
      ],
      [
        -656.0,
        -2760.0,
        764.0001220703125
      ],
      [
        -808.0,
        -2789.71435546875,
        766.0
      ],
      [
        -808.0,
        -2789.71435546875,
        766.0
      ],
      [
        -808.0,
        -2804.39990234375,
        766.0
      ],
      [
        -808.0,
        -2761.800048828125,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        764.0001220703125
      ],
      [
        -808.0,
        -2760.0,
        760.0
      ],
      [
        -812.4000244140625,
        -2823.0,
        766.0
      ],
      [
        -812.4000244140625,
        -2857.0,
        766.0
      ],
      [
        -812.0,
        -2789.0,
        765.0
      ],
      [
        -812.0,
        -2785.0,
        765.0
      ],
      [
        -812.0,
        -2785.0,
        765.0
      ],
      [
        -812.0,
        -2765.0,
        765.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        765.0
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        765.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        765.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        765.0
      ],
      [
        -871.5,
        -2775.0,
        765.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        765.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        765.0
      ],
      [
        -871.5,
        -2775.0,
        765.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        766.0
      ],
      [
        -866.22802734375,
        -2762.27197265625,
        766.0
      ],
      [
        -866.22802734375,
        -2787.72802734375,
        766.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        766.0
      ],
      [
        -825.0,
        -2781.5,
        766.0
      ],
      [
        -836.8701171875,
        -2781.88818359375,
        766.0
      ],
      [
        -821.5,
        -2790.0,
        766.0
      ],
      [
        -824.0,
        -2785.0,
        766.0
      ],
      [
        -824.0,
        -2781.46728515625,
        765.0
      ],
      [
        -824.0,
        -2785.0,
        766.0
      ],
      [
        -824.0,
        -2781.46728515625,
        766.0
      ],
      [
        -871.5,
        -2775.0,
        766.0
      ],
      [
        -870.1298828125,
        -2768.11181640625,
        766.0
      ],
      [
        -870.1298828125,
        -2781.88818359375,
        766.0
      ],
      [
        -871.5,
        -2775.0,
        766.0
      ],
      [
        -824.0,
        -2765.0,
        766.0
      ],
      [
        -824.0,
        -2770.89990234375,
        766.0
      ],
      [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      [
        -824.0,
        -2770.89990234375,
        766.0
      ],
      [
        -825.0,
        -2770.89990234375,
        766.0
      ],
      [
        -825.0,
        -2779.10009765625,
        766.0
      ],
      [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      [
        -808.0,
        -2804.39990234375,
        766.0
      ],
      [
        -777.0,
        -2812.0,
        766.0
      ],
      [
        -777.0,
        -2802.0,
        766.0
      ],
      [
        -780.0,
        -2802.0,
        766.0
      ],
      [
        -777.0,
        -2802.0,
        766.0
      ],
      [
        -746.0,
        -2812.0,
        766.0
      ],
      [
        -746.0,
        -2802.0,
        766.0
      ],
      [
        -749.0,
        -2802.0,
        766.0
      ],
      [
        -746.0,
        -2802.0,
        766.0
      ],
      [
        -715.0,
        -2812.0,
        766.0
      ],
      [
        -715.0,
        -2802.0,
        766.0
      ],
      [
        -718.0,
        -2802.0,
        766.0
      ],
      [
        -715.0,
        -2802.0,
        766.0
      ],
      [
        -684.0,
        -2812.0,
        766.0
      ],
      [
        -684.0,
        -2802.0,
        766.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -687.0,
        -2812.0,
        766.0
      ],
      [
        -687.0,
        -2802.0,
        766.0
      ],
      [
        -684.0,
        -2802.0,
        766.0
      ],
      [
        -656.0,
        -2804.39990234375,
        766.0
      ],
      [
        -808.0,
        -2760.0,
        766.0
      ],
      [
        -656.0,
        -2760.0,
        766.0
      ],
      [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      [
        -702.5,
        -2804.128173828125,
        810.5
      ],
      [
        -687.0,
        -2812.0,
        810.5
      ],
      [
        -687.0,
        -2808.98095703125,
        766.0
      ],
      [
        -687.0,
        -2804.126953125,
        810.5
      ],
      [
        -684.0,
        -2812.0,
        810.5
      ],
      [
        -684.0,
        -2804.126953125,
        810.5
      ],
      [
        -684.0,
        -2808.98095703125,
        766.0
      ],
      [
        -682.0,
        -2808.0,
        784.0
      ],
      [
        -682.0,
        -2808.981201171875,
        766.0
      ],
      [
        -658.0,
        -2808.0,
        784.0
      ],
      [
        -658.0,
        -2808.981201171875,
        766.0
      ],
      [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      [
        -606.3539428710938,
        -2805.818359375,
        795.0
      ],
      [
        -639.1815795898438,
        -2805.818359375,
        795.0
      ],
      [
        -635.6460571289062,
        -2805.818359375,
        795.0
      ],
      [
        -606.3539428710938,
        -2805.818359375,
        795.0
      ],
      [
        -635.6460571289062,
        -2805.818359375,
        795.0
      ],
      [
        -640.8173828125,
        -2804.1826171875,
        810.0
      ],
      [
        -634.7095947265625,
        -2804.1826171875,
        810.0
      ],
      [
        -607.2904052734375,
        -2804.1826171875,
        810.0
      ],
      [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      [
        -607.2904052734375,
        -2804.1826171875,
        810.0
      ],
      [
        -634.7095947265625,
        -2804.1826171875,
        810.0
      ],
      [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      [
        -640.8173828125,
        -2804.1826171875,
        810.0
      ],
      [
        -639.1815795898438,
        -2805.818359375,
        795.0
      ],
      [
        -746.0,
        -2812.0,
        810.5
      ],
      [
        -746.0,
        -2804.126953125,
        810.5
      ],
      [
        -746.0,
        -2808.98095703125,
        766.0
      ],
      [
        -777.0,
        -2812.0,
        810.5
      ],
      [
        -777.0,
        -2804.126953125,
        810.5
      ],
      [
        -777.0,
        -2808.98095703125,
        766.0
      ],
      [
        -777.0,
        -2857.0,
        790.0
      ],
      [
        -777.0,
        -2860.0,
        775.0
      ],
      [
        -806.0,
        -2808.981201171875,
        766.0
      ],
      [
        -775.0,
        -2808.981201171875,
        766.0
      ],
      [
        -715.0,
        -2804.182861328125,
        810.0
      ],
      [
        -715.0,
        -2808.98095703125,
        766.0
      ],
      [
        -732.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -715.0,
        -2811.0,
        805.0
      ],
      [
        -715.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -744.0,
        -2808.981201171875,
        766.0
      ],
      [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -698.0,
        -2811.0,
        810.5
      ],
      [
        -698.0,
        -2804.128173828125,
        810.5
      ],
      [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -713.0,
        -2808.981201171875,
        766.0
      ],
      [
        -700.5,
        -2863.199951171875,
        821.5
      ],
      [
        -731.0,
        -2863.199951171875,
        821.5
      ],
      [
        -731.0,
        -2863.199951171875,
        821.5
      ],
      [
        -731.0,
        -2859.0,
        821.5
      ],
      [
        -733.0,
        -2859.0,
        821.5
      ],
      [
        -733.0,
        -2855.5,
        825.0
      ],
      [
        -733.0,
        -2855.5,
        821.5
      ],
      [
        -733.0,
        -2859.0,
        821.5
      ],
      [
        -731.0,
        -2859.0,
        821.5
      ],
      [
        -733.0,
        -2855.5,
        810.5
      ],
      [
        -687.0,
        -2808.0,
        830.0
      ],
      [
        -687.0,
        -2808.0,
        810.5
      ],
      [
        -684.0,
        -2808.0,
        830.0
      ],
      [
        -684.0,
        -2808.0,
        810.5
      ],
      [
        -698.0,
        -2808.0,
        830.0
      ],
      [
        -698.0,
        -2808.0,
        810.5
      ],
      [
        -725.0,
        -2808.0,
        820.0
      ],
      [
        -705.0,
        -2808.0,
        820.0
      ],
      [
        -731.5,
        -2854.0,
        820.0
      ],
      [
        -731.5,
        -2824.5,
        820.0
      ],
      [
        -731.5,
        -2823.0,
        820.0
      ],
      [
        -733.0,
        -2854.0,
        820.0
      ],
      [
        -731.5,
        -2854.0,
        820.0
      ],
      [
        -730.0001220703125,
        -2823.0,
        820.0
      ],
      [
        -730.0001220703125,
        -2824.5,
        820.0
      ],
      [
        -727.5,
        -2808.0,
        810.5
      ],
      [
        -725.0,
        -2808.0,
        820.0
      ],
      [
        -702.5,
        -2808.0,
        810.5
      ],
      [
        -705.0,
        -2808.0,
        820.0
      ],
      [
        -633.4802856445312,
        -2802.328857421875,
        827.0
      ],
      [
        -642.6710815429688,
        -2802.328857421875,
        827.0
      ],
      [
        -599.3289184570312,
        -2802.328857421875,
        827.0
      ],
      [
        -608.5197143554688,
        -2802.328857421875,
        827.0
      ],
      [
        -608.5197143554688,
        -2802.328857421875,
        827.0
      ],
      [
        -633.4802856445312,
        -2802.328857421875,
        827.0
      ],
      [
        -687.0,
        -2808.0,
        827.0
      ],
      [
        -687.0,
        -2802.3271484375,
        827.0
      ],
      [
        -684.0,
        -2802.3271484375,
        827.0
      ],
      [
        -684.0,
        -2808.0,
        827.0
      ],
      [
        -698.0,
        -2802.001708984375,
        830.0
      ],
      [
        -698.0,
        -2802.328857421875,
        827.0
      ],
      [
        -698.0,
        -2808.0,
        827.0
      ],
      [
        -600.9645385742188,
        -2803.964599609375,
        812.0
      ],
      [
        -607.4212646484375,
        -2803.964599609375,
        812.0
      ],
      [
        -634.5787353515625,
        -2803.964599609375,
        812.0
      ],
      [
        -641.0354614257812,
        -2803.964599609375,
        812.0
      ],
      [
        -607.4212646484375,
        -2803.964599609375,
        812.0
      ],
      [
        -634.5787353515625,
        -2803.964599609375,
        812.0
      ],
      [
        -698.0,
        -2803.964599609375,
        812.0
      ],
      [
        -698.0,
        -2808.0,
        812.0
      ],
      [
        -702.5,
        -2804.128173828125,
        810.5
      ],
      [
        -702.8947143554688,
        -2803.964599609375,
        812.0
      ],
      [
        -702.8947143554688,
        -2808.0,
        812.0
      ],
      [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      [
        -727.1052856445312,
        -2808.0,
        812.0
      ],
      [
        -727.1052856445312,
        -2803.964599609375,
        812.0
      ],
      [
        -687.0,
        -2808.0,
        812.0
      ],
      [
        -687.0,
        -2803.96337890625,
        812.0
      ],
      [
        -684.0,
        -2803.96337890625,
        812.0
      ],
      [
        -684.0,
        -2808.0,
        812.0
      ],
      [
        -642.6710815429688,
        -2802.328857421875,
        827.0
      ],
      [
        -641.0354614257812,
        -2803.964599609375,
        812.0
      ],
      [
        -725.0,
        -2803.09228515625,
        820.0
      ],
      [
        -705.0,
        -2803.09228515625,
        820.0
      ],
      [
        -687.0,
        -2808.0,
        820.0
      ],
      [
        -687.0,
        -2803.0908203125,
        820.0
      ],
      [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      [
        -684.0,
        -2808.0,
        820.0
      ],
      [
        -698.0,
        -2803.09228515625,
        820.0
      ],
      [
        -698.0,
        -2808.0,
        820.0
      ],
      [
        -705.0,
        -2803.09228515625,
        820.0
      ],
      [
        -725.0,
        -2803.09228515625,
        820.0
      ],
      [
        -599.3289184570312,
        -2802.328857421875,
        827.0
      ],
      [
        -600.9645385742188,
        -2803.964599609375,
        812.0
      ],
      [
        -733.0,
        -2660.000244140625,
        825.0
      ],
      [
        -610.0,
        -2660.000244140625,
        825.0
      ],
      [
        -599.3289184570312,
        -2687.671142578125,
        827.0
      ],
      [
        -608.5197143554688,
        -2687.671142578125,
        827.0
      ],
      [
        -633.4802856445312,
        -2687.671142578125,
        827.0
      ],
      [
        -642.6710815429688,
        -2687.671142578125,
        827.0
      ],
      [
        -608.5197143554688,
        -2687.671142578125,
        827.0
      ],
      [
        -633.4802856445312,
        -2687.671142578125,
        827.0
      ],
      [
        -567.0,
        -2659.600341796875,
        827.0
      ],
      [
        -607.0,
        -2659.600341796875,
        827.0
      ],
      [
        -746.0,
        -2678.0,
        827.0
      ],
      [
        -746.0,
        -2687.6728515625,
        827.0
      ],
      [
        -777.0,
        -2678.0,
        827.0
      ],
      [
        -777.0,
        -2687.6728515625,
        827.0
      ],
      [
        -687.0,
        -2678.0,
        827.0
      ],
      [
        -687.0,
        -2687.6728515625,
        827.0
      ],
      [
        -684.0,
        -2678.0,
        827.0
      ],
      [
        -684.0,
        -2687.6728515625,
        827.0
      ],
      [
        -698.0,
        -2687.671142578125,
        827.0
      ],
      [
        -698.0,
        -2687.998291015625,
        830.0
      ],
      [
        -698.0,
        -2679.0,
        827.0
      ],
      [
        -567.0,
        -2675.0,
        825.0
      ],
      [
        -569.0,
        -2675.0,
        825.0
      ],
      [
        -600.2307739257812,
        -2675.0,
        825.0
      ],
      [
        -607.0,
        -2675.0,
        825.0
      ],
      [
        -569.0,
        -2675.0,
        825.0
      ],
      [
        -600.2307739257812,
        -2675.0,
        825.0
      ],
      [
        -605.0,
        -2682.0,
        825.0
      ],
      [
        -637.0,
        -2682.0,
        825.0
      ],
      [
        -573.0908813476562,
        -2676.0,
        825.0
      ],
      [
        -571.7999877929688,
        -2676.0,
        825.0
      ],
      [
        -590.2000122070312,
        -2676.0,
        825.0
      ],
      [
        -588.272705078125,
        -2676.0,
        825.0
      ],
      [
        -588.272705078125,
        -2676.0,
        825.0
      ],
      [
        -573.0908813476562,
        -2676.0,
        825.0
      ],
      [
        -573.0,
        -2682.0,
        826.0
      ],
      [
        -589.0,
        -2682.0,
        826.0
      ],
      [
        -746.0,
        -2678.0,
        826.0
      ],
      [
        -746.0,
        -2682.0,
        826.0
      ],
      [
        -746.0,
        -2682.0,
        827.0
      ],
      [
        -777.0,
        -2678.0,
        826.0
      ],
      [
        -777.0,
        -2682.0,
        826.0
      ],
      [
        -777.0,
        -2682.0,
        827.0
      ],
      [
        -687.0,
        -2678.0,
        826.0
      ],
      [
        -687.0,
        -2682.0,
        827.0
      ],
      [
        -687.0,
        -2682.0,
        826.0
      ],
      [
        -684.0,
        -2678.0,
        826.0
      ],
      [
        -684.0,
        -2682.0,
        826.0
      ],
      [
        -684.0,
        -2682.0,
        827.0
      ],
      [
        -698.0,
        -2682.0,
        827.0
      ],
      [
        -698.0,
        -2679.0,
        826.0
      ],
      [
        -698.0,
        -2682.0,
        826.0
      ],
      [
        -589.0,
        -2682.0,
        826.0
      ],
      [
        -590.2000122070312,
        -2676.0,
        825.0
      ],
      [
        -590.2000122070312,
        -2682.0,
        825.0
      ],
      [
        -746.0,
        -2678.0,
        825.0
      ],
      [
        -746.0,
        -2682.0,
        825.0
      ],
      [
        -777.0,
        -2678.0,
        825.0
      ],
      [
        -777.0,
        -2682.0,
        825.0
      ],
      [
        -687.0,
        -2678.0,
        825.0
      ],
      [
        -687.0,
        -2682.0,
        825.0
      ],
      [
        -684.0,
        -2678.0,
        825.0
      ],
      [
        -684.0,
        -2682.0,
        825.0
      ],
      [
        -698.0,
        -2679.0,
        825.0
      ],
      [
        -698.0,
        -2682.0,
        825.0
      ],
      [
        -573.0,
        -2682.0,
        826.0
      ],
      [
        -571.7999877929688,
        -2682.0,
        825.0
      ],
      [
        -571.7999877929688,
        -2676.0,
        825.0
      ],
      [
        -642.6710815429688,
        -2687.671142578125,
        827.0
      ],
      [
        -637.0,
        -2682.0,
        825.0
      ],
      [
        -642.4530029296875,
        -2687.453125,
        825.0
      ],
      [
        -698.0,
        -2687.453125,
        825.0
      ],
      [
        -746.0,
        -2687.45458984375,
        825.0
      ],
      [
        -777.0,
        -2687.45458984375,
        825.0
      ],
      [
        -684.0,
        -2687.45458984375,
        825.0
      ],
      [
        -687.0,
        -2687.45458984375,
        825.0
      ],
      [
        -573.0,
        -2687.56201171875,
        826.0
      ],
      [
        -589.0,
        -2687.56201171875,
        826.0
      ],
      [
        -605.0,
        -2682.0,
        826.0
      ],
      [
        -599.3289184570312,
        -2687.671142578125,
        827.0
      ],
      [
        -599.43798828125,
        -2687.56201171875,
        826.0
      ],
      [
        -605.0,
        -2682.0,
        825.0
      ],
      [
        -599.5469970703125,
        -2687.453125,
        825.0
      ],
      [
        -589.0,
        -2687.56201171875,
        826.0
      ],
      [
        -590.2000122070312,
        -2687.452880859375,
        825.0
      ],
      [
        -573.0,
        -2687.56201171875,
        826.0
      ],
      [
        -571.7999877929688,
        -2687.452880859375,
        825.0
      ],
      [
        -567.0,
        -2660.000244140625,
        825.0
      ],
      [
        -567.0,
        -2659.600341796875,
        827.0
      ],
      [
        -567.0,
        -2675.0,
        825.0
      ],
      [
        -607.0,
        -2673.0,
        825.0
      ],
      [
        -607.0,
        -2670.28564453125,
        825.0
      ],
      [
        -607.0,
        -2675.0,
        825.0
      ],
      [
        -607.0,
        -2673.0,
        825.0
      ],
      [
        -607.0,
        -2670.28564453125,
        825.0
      ],
      [
        -607.0,
        -2659.600341796875,
        827.0
      ],
      [
        -607.0,
        -2660.000244140625,
        825.0
      ],
      [
        -746.0,
        -2681.01904296875,
        766.0
      ],
      [
        -777.0,
        -2681.01904296875,
        766.0
      ],
      [
        -806.0,
        -2671.7998046875,
        766.0
      ],
      [
        -806.0,
        -2681.01904296875,
        766.0
      ],
      [
        -775.0,
        -2671.7998046875,
        766.0
      ],
      [
        -775.0,
        -2681.01904296875,
        766.0
      ],
      [
        -684.0,
        -2681.01904296875,
        766.0
      ],
      [
        -687.0,
        -2681.01904296875,
        766.0
      ],
      [
        -684.0,
        -2675.0,
        820.0
      ],
      [
        -687.0,
        -2675.0,
        820.0
      ],
      [
        -687.0,
        -2675.0,
        810.5
      ],
      [
        -684.0,
        -2675.0,
        810.5
      ],
      [
        -684.0,
        -2669.0,
        825.0
      ],
      [
        -687.0,
        -2669.0,
        825.0
      ],
      [
        -687.0,
        -2675.0,
        820.0
      ],
      [
        -684.0,
        -2675.0,
        820.0
      ],
      [
        -687.0,
        -2669.0,
        810.5
      ],
      [
        -684.0,
        -2669.0,
        810.5
      ],
      [
        -684.0,
        -2675.0,
        810.5
      ],
      [
        -687.0,
        -2675.0,
        810.5
      ],
      [
        -684.0,
        -2669.0,
        810.5
      ],
      [
        -687.0,
        -2669.0,
        810.5
      ],
      [
        -687.0,
        -2662.89990234375,
        810.5
      ],
      [
        -684.0,
        -2662.89990234375,
        810.5
      ],
      [
        -715.0,
        -2685.8173828125,
        810.0
      ],
      [
        -715.0,
        -2681.01904296875,
        766.0
      ],
      [
        -715.0,
        -2679.0,
        805.0
      ],
      [
        -732.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -715.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -727.5,
        -2685.871826171875,
        810.5
      ],
      [
        -715.0,
        -2675.0,
        810.5
      ],
      [
        -715.0,
        -2685.871826171875,
        810.5
      ],
      [
        -715.0,
        -2675.0,
        810.5
      ],
      [
        -715.0,
        -2669.0,
        810.5
      ],
      [
        -731.0,
        -2662.89990234375,
        810.5
      ],
      [
        -733.0,
        -2662.89990234375,
        810.5
      ],
      [
        -715.0,
        -2669.0,
        810.5
      ],
      [
        -731.0,
        -2662.89990234375,
        810.5
      ],
      [
        -715.0,
        -2662.89990234375,
        810.5
      ],
      [
        -733.0,
        -2662.89990234375,
        810.5
      ],
      [
        -733.0,
        -2660.0,
        825.0
      ],
      [
        -715.0,
        -2669.0,
        825.0
      ],
      [
        -715.0,
        -2675.0,
        820.0
      ],
      [
        -715.0,
        -2675.0,
        820.0
      ],
      [
        -725.0,
        -2686.90771484375,
        820.0
      ],
      [
        -715.0,
        -2686.90771484375,
        820.0
      ],
      [
        -725.0,
        -2686.90771484375,
        820.0
      ],
      [
        -727.393798828125,
        -2685.915771484375,
        810.9035034179688
      ],
      [
        -727.5,
        -2685.871826171875,
        810.5
      ],
      [
        -744.0,
        -2671.7998046875,
        766.0
      ],
      [
        -744.0,
        -2681.01904296875,
        766.0
      ],
      [
        -698.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -698.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -702.5,
        -2685.871826171875,
        810.5
      ],
      [
        -698.0,
        -2662.89990234375,
        810.5
      ],
      [
        -700.5,
        -2662.89990234375,
        810.5
      ],
      [
        -700.5,
        -2662.89990234375,
        810.5
      ],
      [
        -705.0,
        -2686.90771484375,
        820.0
      ],
      [
        -702.5,
        -2685.871826171875,
        810.5
      ],
      [
        -705.0,
        -2686.90771484375,
        820.0
      ],
      [
        -698.0,
        -2662.89990234375,
        810.5
      ],
      [
        -713.0,
        -2671.7998046875,
        766.0
      ],
      [
        -713.0,
        -2681.01904296875,
        766.0
      ],
      [
        -606.3539428710938,
        -2684.181640625,
        795.0
      ],
      [
        -602.8184204101562,
        -2684.181640625,
        795.0
      ],
      [
        -639.1815795898438,
        -2684.181640625,
        795.0
      ],
      [
        -635.6460571289062,
        -2684.181640625,
        795.0
      ],
      [
        -635.6460571289062,
        -2684.181640625,
        795.0
      ],
      [
        -606.3539428710938,
        -2684.181640625,
        795.0
      ],
      [
        -595.0,
        -2684.181396484375,
        795.0
      ],
      [
        -567.0,
        -2684.181396484375,
        795.0
      ],
      [
        -682.0,
        -2675.0,
        784.0
      ],
      [
        -658.0,
        -2675.0,
        784.0
      ],
      [
        -682.0,
        -2675.0,
        775.0
      ],
      [
        -682.0,
        -2675.0,
        784.0
      ],
      [
        -682.0,
        -2675.0,
        766.0
      ],
      [
        -682.0,
        -2681.01904296875,
        766.0
      ],
      [
        -682.0,
        -2675.0,
        775.0
      ],
      [
        -658.0,
        -2675.0,
        784.0
      ],
      [
        -658.0,
        -2675.0,
        775.0
      ],
      [
        -658.0,
        -2675.0,
        775.0
      ],
      [
        -658.0,
        -2681.01904296875,
        766.0
      ],
      [
        -658.0,
        -2675.0,
        766.0
      ],
      [
        -573.0,
        -2685.8173828125,
        810.0
      ],
      [
        -589.0,
        -2685.8173828125,
        810.0
      ],
      [
        -601.1826171875,
        -2685.8173828125,
        810.0
      ],
      [
        -607.2904663085938,
        -2685.8173828125,
        810.0
      ],
      [
        -634.7095336914062,
        -2685.8173828125,
        810.0
      ],
      [
        -640.8173828125,
        -2685.8173828125,
        810.0
      ],
      [
        -607.2904663085938,
        -2685.8173828125,
        810.0
      ],
      [
        -634.7095336914062,
        -2685.8173828125,
        810.0
      ],
      [
        -595.0,
        -2682.0,
        810.5
      ],
      [
        -567.0,
        -2682.0,
        810.5
      ],
      [
        -567.0,
        -2682.0,
        821.0
      ],
      [
        -567.0,
        -2682.0,
        810.5
      ],
      [
        -595.0,
        -2682.0,
        821.0
      ],
      [
        -595.0,
        -2682.0,
        810.5
      ],
      [
        -595.0,
        -2682.0,
        821.0
      ],
      [
        -590.2000122070312,
        -2682.0,
        825.0
      ],
      [
        -567.0,
        -2682.0,
        821.0
      ],
      [
        -571.7999877929688,
        -2682.0,
        825.0
      ],
      [
        -641.0354614257812,
        -2686.035400390625,
        812.0
      ],
      [
        -634.5786743164062,
        -2686.035400390625,
        812.0
      ],
      [
        -607.4213256835938,
        -2686.035400390625,
        812.0
      ],
      [
        -600.9645385742188,
        -2686.035400390625,
        812.0
      ],
      [
        -634.5786743164062,
        -2686.035400390625,
        812.0
      ],
      [
        -607.4213256835938,
        -2686.035400390625,
        812.0
      ],
      [
        -595.0,
        -2685.871826171875,
        810.5
      ],
      [
        -567.0,
        -2685.871826171875,
        810.5
      ],
      [
        -567.0,
        -2686.035400390625,
        812.0
      ],
      [
        -567.0,
        -2685.871826171875,
        810.5
      ],
      [
        -567.0,
        -2682.0,
        812.0
      ],
      [
        -595.0,
        -2682.0,
        812.0
      ],
      [
        -595.0,
        -2685.871826171875,
        810.5
      ],
      [
        -595.0,
        -2686.035400390625,
        812.0
      ],
      [
        -600.9645385742188,
        -2686.035400390625,
        812.0
      ],
      [
        -567.0,
        -2687.016845703125,
        821.0
      ],
      [
        -595.0,
        -2687.016845703125,
        821.0
      ],
      [
        -595.0,
        -2687.016845703125,
        821.0
      ],
      [
        -567.0,
        -2687.016845703125,
        821.0
      ],
      [
        -641.0354614257812,
        -2686.035400390625,
        812.0
      ],
      [
        -595.0,
        -2682.0,
        805.0
      ],
      [
        -595.0,
        -2682.0,
        795.0
      ],
      [
        -567.0,
        -2682.0,
        805.0
      ],
      [
        -567.0,
        -2682.0,
        795.0
      ],
      [
        -589.0,
        -2682.0,
        810.0
      ],
      [
        -595.0,
        -2682.0,
        805.0
      ],
      [
        -573.0,
        -2682.0,
        810.0
      ],
      [
        -567.0,
        -2682.0,
        805.0
      ],
      [
        -602.8184204101562,
        -2684.181640625,
        795.0
      ],
      [
        -601.1826171875,
        -2685.8173828125,
        810.0
      ],
      [
        -595.0,
        -2685.272216796875,
        805.0
      ],
      [
        -595.0,
        -2684.181396484375,
        795.0
      ],
      [
        -567.0,
        -2685.272216796875,
        805.0
      ],
      [
        -567.0,
        -2684.181396484375,
        795.0
      ],
      [
        -589.0,
        -2685.8173828125,
        810.0
      ],
      [
        -595.0,
        -2685.272216796875,
        805.0
      ],
      [
        -573.0,
        -2685.8173828125,
        810.0
      ],
      [
        -567.0,
        -2685.272216796875,
        805.0
      ],
      [
        -640.8173828125,
        -2685.8173828125,
        810.0
      ],
      [
        -639.1815795898438,
        -2684.181640625,
        795.0
      ],
      [
        -567.0,
        -2669.000244140625,
        825.0
      ],
      [
        -567.0,
        -2675.0,
        820.0000610351562
      ],
      [
        -607.0,
        -2671.181884765625,
        823.1819458007812
      ],
      [
        -607.0,
        -2669.433837890625,
        824.6386108398438
      ],
      [
        -607.0,
        -2675.0,
        820.0000610351562
      ],
      [
        -607.0,
        -2671.181884765625,
        823.1819458007812
      ],
      [
        -607.0,
        -2669.433837890625,
        824.6386108398438
      ],
      [
        -607.0,
        -2669.0,
        825.0
      ],
      [
        -600.5,
        -2662.89990234375,
        810.5000610351562
      ],
      [
        -600.0,
        -2662.900146484375,
        810.5
      ],
      [
        -610.0,
        -2662.89990234375,
        810.5
      ],
      [
        -612.0,
        -2662.89990234375,
        810.5
      ],
      [
        -638.0,
        -2662.89990234375,
        810.5
      ],
      [
        -640.5,
        -2662.89990234375,
        810.5
      ],
      [
        -668.0,
        -2662.89990234375,
        810.5
      ],
      [
        -670.5,
        -2662.89990234375,
        810.5
      ],
      [
        -638.0,
        -2662.89990234375,
        810.5
      ],
      [
        -612.0,
        -2662.89990234375,
        810.5
      ],
      [
        -640.5,
        -2662.89990234375,
        810.5
      ],
      [
        -668.0,
        -2662.89990234375,
        810.5
      ],
      [
        -670.5,
        -2662.89990234375,
        810.5
      ],
      [
        -607.0,
        -2662.900146484375,
        810.5
      ],
      [
        -600.0,
        -2662.900146484375,
        810.5
      ],
      [
        -607.0,
        -2663.10009765625,
        809.5
      ],
      [
        -600.0,
        -2663.10009765625,
        809.5
      ],
      [
        -607.0,
        -2675.0,
        809.5
      ],
      [
        -607.0,
        -2668.0,
        810.5
      ],
      [
        -607.0,
        -2668.0,
        809.5
      ],
      [
        -567.0,
        -2668.0,
        810.5
      ],
      [
        -567.0,
        -2675.0,
        809.5
      ],
      [
        -567.0,
        -2668.0,
        809.5
      ],
      [
        -600.0,
        -2662.900146484375,
        810.5
      ],
      [
        -600.0,
        -2663.10009765625,
        809.5
      ],
      [
        -607.0,
        -2662.900146484375,
        810.5
      ],
      [
        -607.0,
        -2663.10009765625,
        809.5
      ],
      [
        -567.0,
        -2663.10009765625,
        809.5
      ],
      [
        -567.0,
        -2662.900146484375,
        810.5
      ],
      [
        -567.0,
        -2664.623291015625,
        809.5
      ],
      [
        -573.5,
        -2664.623291015625,
        809.5
      ],
      [
        -574.0,
        -2664.623291015625,
        809.5
      ],
      [
        -574.0,
        -2664.623291015625,
        809.5
      ],
      [
        -573.9634399414062,
        -2663.10009765625,
        809.5
      ],
      [
        -573.8775024414062,
        -2662.900146484375,
        810.5
      ],
      [
        -573.5,
        -2662.900146484375,
        810.5
      ],
      [
        -573.5,
        -2663.10009765625,
        809.5
      ],
      [
        -573.5,
        -2664.623291015625,
        809.5
      ],
      [
        -567.0,
        -2666.0,
        795.0
      ],
      [
        -567.0,
        -2671.7998046875,
        766.0
      ],
      [
        -607.0,
        -2674.418701171875,
        794.0
      ],
      [
        -607.0,
        -2674.300048828125,
        794.0
      ],
      [
        -607.0,
        -2674.418701171875,
        794.0
      ],
      [
        -607.0,
        -2675.0,
        794.0
      ],
      [
        -607.0,
        -2674.300048828125,
        794.0
      ],
      [
        -607.0,
        -2668.0,
        795.0
      ],
      [
        -607.0,
        -2668.0,
        794.0
      ],
      [
        -593.0,
        -2666.0,
        795.0
      ],
      [
        -593.0,
        -2666.0849609375,
        794.574462890625
      ],
      [
        -600.0,
        -2666.0849609375,
        794.574462890625
      ],
      [
        -600.0,
        -2666.0,
        795.0
      ],
      [
        -600.0,
        -2666.0849609375,
        794.574462890625
      ],
      [
        -593.0,
        -2666.0849609375,
        794.574462890625
      ],
      [
        -607.0,
        -2666.0,
        795.0
      ],
      [
        -607.0,
        -2666.199951171875,
        794.0
      ],
      [
        -567.0,
        -2666.11181640625,
        794.4407958984375
      ],
      [
        -573.5,
        -2666.11181640625,
        794.4408569335938
      ],
      [
        -574.0,
        -2666.199951171875,
        794.0
      ],
      [
        -574.0,
        -2666.11181640625,
        794.4407958984375
      ],
      [
        -574.0,
        -2666.11181640625,
        794.4407958984375
      ],
      [
        -573.9519653320312,
        -2666.0,
        795.0
      ],
      [
        -573.5,
        -2666.0,
        795.0
      ],
      [
        -573.5,
        -2666.11181640625,
        794.4408569335938
      ],
      [
        -607.0,
        -2668.303466796875,
        783.48193359375
      ],
      [
        -607.0,
        -2668.0,
        784.9998779296875
      ],
      [
        -607.0,
        -2668.303466796875,
        783.48193359375
      ],
      [
        -607.0,
        -2671.7998046875,
        766.0
      ],
      [
        -607.0,
        -2668.0,
        784.9998779296875
      ],
      [
        -682.0,
        -2671.7998046875,
        766.0
      ],
      [
        -658.0,
        -2671.7998046875,
        766.0
      ],
      [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      [
        -567.0,
        -2669.10009765625,
        779.5
      ],
      [
        -567.0,
        -2669.2998046875,
        778.5
      ],
      [
        -593.0,
        -2669.2998046875,
        778.5
      ],
      [
        -593.0,
        -2669.2998046875,
        778.5
      ],
      [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      [
        -586.3599853515625,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -586.5,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -573.5,
        -2668.35986328125,
        783.2000732421875
      ],
      [
        -573.6401977539062,
        -2668.35986328125,
        783.2000732421875
      ],
      [
        -592.5,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -592.699951171875,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -573.6401977539062,
        -2668.35986328125,
        783.2000732421875
      ],
      [
        -586.3599853515625,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -586.5,
        -2668.5,
        782.4993286132812
      ],
      [
        -573.5,
        -2668.5,
        782.4993896484375
      ],
      [
        -586.5,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -586.5,
        -2668.5,
        782.4993286132812
      ],
      [
        -573.5,
        -2668.5,
        782.4993896484375
      ],
      [
        -573.5,
        -2668.35986328125,
        783.2000732421875
      ],
      [
        -592.699951171875,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -592.699951171875,
        -2668.5,
        783.2000122070312
      ],
      [
        -592.7567749023438,
        -2668.5,
        782.4995727539062
      ],
      [
        -592.5,
        -2668.5,
        783.2000122070312
      ],
      [
        -592.5,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -592.5,
        -2668.5,
        782.4995727539062
      ],
      [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      [
        -592.5,
        -2669.10009765625,
        779.5
      ],
      [
        -574.0,
        -2666.300537109375,
        793.4967041015625
      ],
      [
        -567.0,
        -2666.300537109375,
        793.4967041015625
      ],
      [
        -574.0,
        -2666.300537109375,
        793.4967041015625
      ],
      [
        -607.0,
        -2666.0,
        795.0
      ],
      [
        -567.0,
        -2666.0,
        795.0
      ],
      [
        -599.5,
        -2668.5,
        798.7000122070312
      ],
      [
        -599.699951171875,
        -2668.5,
        798.7000122070312
      ],
      [
        -593.5,
        -2668.300048828125,
        798.7000732421875
      ],
      [
        -573.5,
        -2668.300048828125,
        798.7000732421875
      ],
      [
        -599.699951171875,
        -2668.300048828125,
        798.7000122070312
      ],
      [
        -599.699951171875,
        -2668.5,
        798.7000122070312
      ],
      [
        -600.0,
        -2668.5,
        795.0
      ],
      [
        -599.5,
        -2668.5,
        795.0
      ],
      [
        -599.5,
        -2668.5,
        798.7000122070312
      ],
      [
        -599.5,
        -2668.300048828125,
        798.7000122070312
      ],
      [
        -593.5,
        -2665.872314453125,
        795.6383666992188
      ],
      [
        -593.5,
        -2665.260009765625,
        798.7000732421875
      ],
      [
        -573.699951171875,
        -2665.413330078125,
        797.9340209960938
      ],
      [
        -573.5,
        -2665.413330078125,
        797.9340209960938
      ],
      [
        -573.699951171875,
        -2665.413330078125,
        797.9340209960938
      ],
      [
        -573.5,
        -2665.413330078125,
        797.9340209960938
      ],
      [
        -593.2333984375,
        -2665.260009765625,
        798.7000732421875
      ],
      [
        -593.0,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -593.0,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -599.5,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -593.5,
        -2665.872314453125,
        795.6383666992188
      ],
      [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -599.7666015625,
        -2665.260009765625,
        798.7000732421875
      ],
      [
        -599.5,
        -2665.872314453125,
        795.6383056640625
      ],
      [
        -599.5,
        -2665.260009765625,
        798.7000732421875
      ],
      [
        -574.0,
        -2663.3740234375,
        808.1300048828125
      ],
      [
        -567.0,
        -2663.3740234375,
        808.1300048828125
      ],
      [
        -567.0,
        -2663.185302734375,
        809.0741577148438
      ],
      [
        -573.5,
        -2663.185302734375,
        809.0741577148438
      ],
      [
        -574.0,
        -2663.3740234375,
        808.1300048828125
      ],
      [
        -574.0,
        -2663.185302734375,
        809.0741577148438
      ],
      [
        -574.0,
        -2663.185302734375,
        809.0741577148438
      ],
      [
        -573.5,
        -2663.185302734375,
        809.0741577148438
      ],
      [
        -593.5,
        -2665.085205078125,
        799.5745239257812
      ],
      [
        -593.300048828125,
        -2665.085205078125,
        799.5745239257812
      ],
      [
        -593.5,
        -2665.085205078125,
        799.5745239257812
      ],
      [
        -593.300048828125,
        -2665.085205078125,
        799.5745239257812
      ],
      [
        -599.5,
        -2665.085205078125,
        799.574462890625
      ],
      [
        -599.699951171875,
        -2665.085205078125,
        799.574462890625
      ],
      [
        -599.699951171875,
        -2665.085205078125,
        799.574462890625
      ],
      [
        -599.5,
        -2665.085205078125,
        799.574462890625
      ],
      [
        -600.300048828125,
        -2662.16015625,
        814.2000732421875
      ],
      [
        -600.5,
        -2662.16015625,
        814.2000732421875
      ],
      [
        -600.5,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -600.5,
        -2667.999755859375,
        810.5000610351562
      ],
      [
        -567.0,
        -2668.5,
        810.5
      ],
      [
        -567.0,
        -2667.999755859375,
        810.5
      ],
      [
        -567.0,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -567.0,
        -2668.5,
        814.2000732421875
      ],
      [
        -573.5,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -610.0,
        -2668.5,
        810.5
      ],
      [
        -610.0,
        -2667.999755859375,
        810.5
      ],
      [
        -610.0,
        -2668.048095703125,
        811.0949096679688
      ],
      [
        -610.0,
        -2668.5,
        810.8125
      ],
      [
        -610.0,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -610.0,
        -2668.5,
        814.2000732421875
      ],
      [
        -610.0,
        -2668.5,
        810.8125
      ],
      [
        -610.0,
        -2668.048095703125,
        811.0949096679688
      ],
      [
        -607.0,
        -2667.999755859375,
        810.5
      ],
      [
        -607.0,
        -2668.5,
        810.5
      ],
      [
        -607.0,
        -2668.5,
        812.125
      ],
      [
        -607.0,
        -2668.138916015625,
        812.2152709960938
      ],
      [
        -607.0,
        -2668.138916015625,
        812.2152709960938
      ],
      [
        -607.0,
        -2668.5,
        812.125
      ],
      [
        -607.0,
        -2668.5,
        814.2000732421875
      ],
      [
        -607.0,
        -2668.2998046875,
        814.2000732421875
      ],
      [
        -600.0,
        -2662.900146484375,
        810.5
      ],
      [
        -600.300048828125,
        -2662.16015625,
        814.2000732421875
      ],
      [
        -600.5,
        -2662.16015625,
        814.2000732421875
      ],
      [
        -600.5,
        -2662.89990234375,
        810.5000610351562
      ],
      [
        -607.0,
        -2662.900146484375,
        810.5
      ],
      [
        -607.0,
        -2662.585693359375,
        812.0714111328125
      ],
      [
        -607.0,
        -2665.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2662.89990234375,
        810.5
      ],
      [
        -610.0,
        -2662.585693359375,
        812.0714111328125
      ],
      [
        -610.0,
        -2665.0,
        814.2000732421875
      ],
      [
        -607.0,
        -2662.585693359375,
        812.0714111328125
      ],
      [
        -610.0,
        -2662.585693359375,
        812.0714111328125
      ],
      [
        -607.0,
        -2665.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2665.0,
        814.2000732421875
      ],
      [
        -567.0,
        -2662.900146484375,
        810.5
      ],
      [
        -567.0,
        -2662.16015625,
        814.2000732421875
      ],
      [
        -573.5,
        -2662.486572265625,
        812.5672607421875
      ],
      [
        -573.699951171875,
        -2662.486572265625,
        812.5672607421875
      ],
      [
        -573.699951171875,
        -2662.486572265625,
        812.5672607421875
      ],
      [
        -573.5,
        -2662.486572265625,
        812.5672607421875
      ],
      [
        -670.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -650.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2670.0,
        810.5
      ],
      [
        -567.0,
        -2670.0,
        810.5
      ],
      [
        -567.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -567.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -607.0,
        -2670.0,
        810.5
      ],
      [
        -607.0,
        -2670.0,
        811.75
      ],
      [
        -607.0,
        -2670.0,
        811.75
      ],
      [
        -607.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -607.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -650.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -650.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -670.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -670.0,
        -2675.0,
        814.2000732421875
      ],
      [
        -607.0,
        -2675.0,
        815.0
      ],
      [
        -607.0,
        -2670.0,
        815.0
      ],
      [
        -607.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -610.0,
        -2670.0,
        815.0
      ],
      [
        -610.0,
        -2675.0,
        815.0
      ],
      [
        -610.0,
        -2670.0,
        814.2000732421875
      ],
      [
        -607.0,
        -2665.0,
        815.0
      ],
      [
        -610.0,
        -2665.0,
        815.0
      ],
      [
        -607.0,
        -2665.0,
        815.0
      ],
      [
        -610.0,
        -2665.0,
        815.0
      ],
      [
        -610.0,
        -2661.25439453125,
        818.728759765625
      ],
      [
        -610.0,
        -2660.78271484375,
        821.0870361328125
      ],
      [
        -610.0,
        -2660.0,
        825.0
      ],
      [
        -610.0,
        -2660.78271484375,
        821.0870361328125
      ],
      [
        -607.0,
        -2660.8046875,
        820.9777221679688
      ],
      [
        -607.0,
        -2661.25439453125,
        818.728759765625
      ],
      [
        -607.0,
        -2660.8046875,
        820.9777221679688
      ],
      [
        -610.0,
        -2661.25439453125,
        818.728759765625
      ],
      [
        -607.0,
        -2661.25439453125,
        818.728759765625
      ],
      [
        -656.0,
        -2710.0,
        795.0
      ],
      [
        -656.0,
        -2715.0,
        795.0
      ],
      [
        -656.0,
        -2734.0,
        795.0
      ],
      [
        -656.0,
        -2690.0,
        795.0
      ],
      [
        -656.0,
        -2800.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        795.0
      ],
      [
        -656.0,
        -2690.0,
        810.0
      ],
      [
        -656.0,
        -2734.0,
        810.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -617.0,
        -2722.0,
        810.5
      ],
      [
        -611.0,
        -2716.0,
        810.5
      ],
      [
        -617.0,
        -2788.0,
        810.5
      ],
      [
        -611.0,
        -2782.0,
        810.5
      ],
      [
        -625.0,
        -2768.0,
        810.5
      ],
      [
        -631.0,
        -2774.0,
        810.5
      ],
      [
        -611.0,
        -2774.0,
        810.5
      ],
      [
        -617.0,
        -2768.0,
        810.5
      ],
      [
        -631.0,
        -2782.0,
        810.5
      ],
      [
        -625.0,
        -2788.0,
        810.5
      ],
      [
        -625.0,
        -2788.0,
        810.5
      ],
      [
        -617.0,
        -2788.0,
        810.5
      ],
      [
        -631.0,
        -2774.0,
        810.5
      ],
      [
        -631.0,
        -2782.0,
        810.5
      ],
      [
        -611.0,
        -2782.0,
        810.5
      ],
      [
        -611.0,
        -2774.0,
        810.5
      ],
      [
        -625.0,
        -2768.0,
        810.5
      ],
      [
        -617.0,
        -2768.0,
        810.5
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      [
        -623.3990478515625,
        -2784.21142578125,
        810.5
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        810.0
      ],
      [
        -618.36474609375,
        -2784.293212890625,
        810.0
      ],
      [
        -618.390380859375,
        -2784.21142578125,
        810.5
      ],
      [
        -614.577880859375,
        -2780.39892578125,
        810.5
      ],
      [
        -614.505859375,
        -2780.434326171875,
        810.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        810.0
      ],
      [
        -623.3990478515625,
        -2771.577880859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2775.390380859375,
        810.5
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -614.505859375,
        -2775.36474609375,
        810.0
      ],
      [
        -614.577880859375,
        -2775.390380859375,
        810.5
      ],
      [
        -618.390380859375,
        -2771.577880859375,
        810.5
      ],
      [
        -618.36474609375,
        -2771.505859375,
        810.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        810.0
      ],
      [
        -623.3990478515625,
        -2784.21142578125,
        810.5
      ],
      [
        -618.390380859375,
        -2784.21142578125,
        810.5
      ],
      [
        -618.36474609375,
        -2784.293212890625,
        810.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        810.0
      ],
      [
        -627.2115478515625,
        -2775.390380859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2780.39892578125,
        810.5
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      [
        -618.36474609375,
        -2771.505859375,
        810.0
      ],
      [
        -618.390380859375,
        -2771.577880859375,
        810.5
      ],
      [
        -623.3990478515625,
        -2771.577880859375,
        810.5
      ],
      [
        -623.434326171875,
        -2771.505859375,
        810.0
      ],
      [
        -614.505859375,
        -2780.434326171875,
        810.0
      ],
      [
        -614.577880859375,
        -2780.39892578125,
        810.5
      ],
      [
        -614.577880859375,
        -2775.390380859375,
        810.5
      ],
      [
        -614.505859375,
        -2775.36474609375,
        810.0
      ],
      [
        -625.0,
        -2702.0,
        810.5
      ],
      [
        -631.0,
        -2708.0,
        810.5
      ],
      [
        -611.0,
        -2708.0,
        810.5
      ],
      [
        -617.0,
        -2702.0,
        810.5
      ],
      [
        -631.0,
        -2716.0,
        810.5
      ],
      [
        -625.0,
        -2722.0,
        810.5
      ],
      [
        -625.0,
        -2722.0,
        810.5
      ],
      [
        -617.0,
        -2722.0,
        810.5
      ],
      [
        -631.0,
        -2708.0,
        810.5
      ],
      [
        -631.0,
        -2716.0,
        810.5
      ],
      [
        -625.0,
        -2702.0,
        810.5
      ],
      [
        -617.0,
        -2702.0,
        810.5
      ],
      [
        -611.0,
        -2716.0,
        810.5
      ],
      [
        -611.0,
        -2708.0,
        810.5
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        810.0
      ],
      [
        -627.2115478515625,
        -2714.39892578125,
        810.5
      ],
      [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        810.0
      ],
      [
        -618.36474609375,
        -2718.293212890625,
        810.0
      ],
      [
        -618.390380859375,
        -2718.21142578125,
        810.5
      ],
      [
        -614.577880859375,
        -2714.39892578125,
        810.5
      ],
      [
        -614.505859375,
        -2714.434326171875,
        810.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        810.0
      ],
      [
        -623.3990478515625,
        -2705.577880859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2709.390380859375,
        810.5
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        810.0
      ],
      [
        -614.505859375,
        -2709.36474609375,
        810.0
      ],
      [
        -614.577880859375,
        -2709.390380859375,
        810.5
      ],
      [
        -618.390380859375,
        -2705.577880859375,
        810.5
      ],
      [
        -618.36474609375,
        -2705.505859375,
        810.0
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        810.0
      ],
      [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      [
        -618.390380859375,
        -2718.21142578125,
        810.5
      ],
      [
        -618.36474609375,
        -2718.293212890625,
        810.0
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        810.0
      ],
      [
        -627.2115478515625,
        -2709.390380859375,
        810.5
      ],
      [
        -627.2115478515625,
        -2714.39892578125,
        810.5
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        810.0
      ],
      [
        -618.36474609375,
        -2705.505859375,
        810.0
      ],
      [
        -618.390380859375,
        -2705.577880859375,
        810.5
      ],
      [
        -623.3990478515625,
        -2705.577880859375,
        810.5
      ],
      [
        -623.434326171875,
        -2705.505859375,
        810.0
      ],
      [
        -614.505859375,
        -2714.434326171875,
        810.0
      ],
      [
        -614.577880859375,
        -2714.39892578125,
        810.5
      ],
      [
        -614.577880859375,
        -2709.390380859375,
        810.5
      ],
      [
        -614.505859375,
        -2709.36474609375,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        810.0
      ],
      [
        -656.0,
        -2800.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        795.0
      ],
      [
        -656.0,
        -2756.0,
        810.0
      ],
      [
        -656.0,
        -2795.5,
        797.5
      ],
      [
        -656.0,
        -2800.0,
        797.5
      ],
      [
        -656.0,
        -2756.0,
        797.5
      ],
      [
        -656.0,
        -2760.5,
        797.5
      ],
      [
        -656.0,
        -2800.0,
        798.5
      ],
      [
        -656.0,
        -2795.5,
        798.0
      ],
      [
        -656.0,
        -2795.5,
        798.0
      ],
      [
        -656.0,
        -2795.5,
        797.5
      ],
      [
        -651.0,
        -2791.0,
        797.5
      ],
      [
        -655.5003051757812,
        -2760.5,
        797.5
      ],
      [
        -656.0,
        -2760.5,
        798.0
      ],
      [
        -656.0,
        -2756.0,
        798.5
      ],
      [
        -656.0,
        -2760.5,
        797.5
      ],
      [
        -656.0,
        -2760.5,
        798.0
      ],
      [
        -630.9855346679688,
        -2766.375,
        795.8529663085938
      ],
      [
        -631.14111328125,
        -2766.0,
        795.0
      ],
      [
        -632.6251220703125,
        -2787.985595703125,
        795.8529663085938
      ],
      [
        -633.0,
        -2788.14111328125,
        795.0
      ],
      [
        -611.0142211914062,
        -2789.624755859375,
        795.8529663085938
      ],
      [
        -609.3748779296875,
        -2787.985595703125,
        795.8529663085938
      ],
      [
        -609.0,
        -2788.14111328125,
        795.0
      ],
      [
        -610.8587036132812,
        -2789.999755859375,
        795.0
      ],
      [
        -656.0,
        -2690.0,
        795.0
      ],
      [
        -656.0,
        -2690.0,
        810.0
      ],
      [
        -656.0,
        -2734.0,
        810.0
      ],
      [
        -656.0,
        -2734.0,
        795.0
      ],
      [
        -656.0,
        -2729.5,
        797.5
      ],
      [
        -656.0,
        -2734.0,
        797.5
      ],
      [
        -656.0,
        -2690.0,
        797.5
      ],
      [
        -656.0,
        -2694.5,
        797.5
      ],
      [
        -656.0,
        -2734.0,
        798.5
      ],
      [
        -656.0,
        -2729.5,
        798.0
      ],
      [
        -656.0,
        -2729.5,
        798.0
      ],
      [
        -656.0,
        -2729.5,
        797.5
      ],
      [
        -651.0,
        -2725.0,
        797.5
      ],
      [
        -655.5003051757812,
        -2694.5,
        797.5
      ],
      [
        -656.0,
        -2694.5,
        798.0
      ],
      [
        -656.0,
        -2690.0,
        798.5
      ],
      [
        -656.0,
        -2694.5,
        797.5
      ],
      [
        -656.0,
        -2694.5,
        798.0
      ],
      [
        -630.9857788085938,
        -2700.375244140625,
        795.8529663085938
      ],
      [
        -631.1412963867188,
        -2700.000244140625,
        795.0
      ],
      [
        -632.6251220703125,
        -2721.985595703125,
        795.8529663085938
      ],
      [
        -633.0,
        -2722.14111328125,
        795.0
      ],
      [
        -611.0143432617188,
        -2723.625,
        795.8529663085938
      ],
      [
        -609.3748779296875,
        -2721.985595703125,
        795.8529663085938
      ],
      [
        -609.0,
        -2722.14111328125,
        795.0
      ],
      [
        -610.85888671875,
        -2724.0,
        795.0
      ],
      [
        -572.5,
        -2767.5,
        795.0
      ],
      [
        -567.0,
        -2767.5,
        798.25
      ],
      [
        -572.5,
        -2767.5,
        798.25
      ],
      [
        -578.0,
        -2767.5,
        798.25
      ],
      [
        -578.0,
        -2767.5,
        798.25
      ],
      [
        -578.0,
        -2772.0,
        798.25
      ],
      [
        -656.0,
        -2690.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        827.0
      ],
      [
        -656.0,
        -2756.0,
        827.0
      ],
      [
        -656.0,
        -2800.0,
        827.0
      ],
      [
        -597.0,
        -2756.0,
        826.0
      ],
      [
        -597.0,
        -2756.571533203125,
        826.0
      ],
      [
        -597.0,
        -2690.0,
        826.0
      ],
      [
        -597.0,
        -2690.571533203125,
        826.0
      ],
      [
        -597.0,
        -2795.71435546875,
        826.0
      ],
      [
        -597.0,
        -2800.0,
        826.0
      ],
      [
        -597.0,
        -2729.71435546875,
        826.0
      ],
      [
        -597.0,
        -2734.0,
        826.0
      ],
      [
        -597.0,
        -2756.571533203125,
        826.0
      ],
      [
        -597.0,
        -2795.71435546875,
        826.0
      ],
      [
        -597.0,
        -2690.571533203125,
        826.0
      ],
      [
        -597.0,
        -2729.71435546875,
        826.0
      ],
      [
        -605.0,
        -2742.0,
        826.0
      ],
      [
        -637.0,
        -2742.0,
        826.0
      ],
      [
        -605.0,
        -2748.0,
        826.0
      ],
      [
        -637.0,
        -2748.0,
        826.0
      ],
      [
        -645.0,
        -2768.5,
        826.0
      ],
      [
        -645.0,
        -2770.0,
        826.0
      ],
      [
        -645.0,
        -2786.0,
        826.0
      ],
      [
        -645.0,
        -2787.5,
        826.0
      ],
      [
        -645.0,
        -2768.5,
        826.0
      ],
      [
        -645.0,
        -2757.333251953125,
        826.0
      ],
      [
        -645.0,
        -2798.666748046875,
        826.0
      ],
      [
        -645.0,
        -2787.5,
        826.0
      ],
      [
        -645.0,
        -2800.0,
        826.0
      ],
      [
        -645.0,
        -2798.666748046875,
        826.0
      ],
      [
        -645.0,
        -2757.333251953125,
        826.0
      ],
      [
        -645.0,
        -2756.0,
        826.0
      ],
      [
        -645.0,
        -2800.0,
        826.0
      ],
      [
        -656.0,
        -2800.0,
        827.0
      ],
      [
        -656.0,
        -2800.0,
        826.0
      ],
      [
        -645.0,
        -2756.0,
        826.0
      ],
      [
        -656.0,
        -2756.0,
        826.0
      ],
      [
        -656.0,
        -2756.0,
        827.0
      ],
      [
        -646.5,
        -2787.5,
        826.0
      ],
      [
        -646.5,
        -2786.0,
        826.0
      ],
      [
        -646.5,
        -2770.0,
        826.0
      ],
      [
        -646.5,
        -2768.5,
        826.0
      ],
      [
        -646.5,
        -2798.666748046875,
        826.0
      ],
      [
        -646.5,
        -2787.5,
        826.0
      ],
      [
        -646.5,
        -2768.5,
        826.0
      ],
      [
        -646.5,
        -2757.333251953125,
        826.0
      ],
      [
        -646.5,
        -2798.666748046875,
        826.0
      ],
      [
        -646.5,
        -2800.0,
        826.0
      ],
      [
        -646.5,
        -2756.0,
        826.0
      ],
      [
        -646.5,
        -2757.333251953125,
        826.0
      ],
      [
        -646.5,
        -2786.0,
        826.0
      ],
      [
        -645.0,
        -2786.0,
        826.0
      ],
      [
        -645.0,
        -2770.0,
        826.0
      ],
      [
        -646.5,
        -2770.0,
        826.0
      ],
      [
        -597.0,
        -2756.0,
        826.0
      ],
      [
        -605.0,
        -2748.0,
        826.0
      ],
      [
        -645.0,
        -2756.0,
        826.0
      ],
      [
        -637.0,
        -2748.0,
        826.0
      ],
      [
        -633.4393920898438,
        -2786.676025390625,
        826.0
      ],
      [
        -629.6760864257812,
        -2790.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2789.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2789.560546875,
        826.0
      ],
      [
        -632.5604248046875,
        -2773.353759765625,
        826.0
      ],
      [
        -632.5604248046875,
        -2782.646240234375,
        826.0
      ],
      [
        -608.5606079101562,
        -2769.323974609375,
        826.0
      ],
      [
        -612.3239135742188,
        -2765.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2766.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2766.439453125,
        826.0
      ],
      [
        -609.4395751953125,
        -2782.646240234375,
        826.0
      ],
      [
        -609.4395751953125,
        -2773.353759765625,
        826.0
      ],
      [
        -630.9415893554688,
        -2766.3310546875,
        826.2470092773438
      ],
      [
        -632.6690063476562,
        -2768.058349609375,
        826.2470092773438
      ],
      [
        -632.5604248046875,
        -2768.445068359375,
        826.0
      ],
      [
        -630.5550537109375,
        -2766.439453125,
        826.0
      ],
      [
        -611.0582275390625,
        -2789.668701171875,
        826.2470092773438
      ],
      [
        -609.3309936523438,
        -2787.941650390625,
        826.2470092773438
      ],
      [
        -609.4395141601562,
        -2787.554931640625,
        826.0
      ],
      [
        -611.4447021484375,
        -2789.560302734375,
        826.0
      ],
      [
        -609.4395751953125,
        -2782.646240234375,
        826.0
      ],
      [
        -608.5606079101562,
        -2786.676025390625,
        826.0
      ],
      [
        -608.5606079101562,
        -2786.676025390625,
        826.0
      ],
      [
        -608.5606079101562,
        -2769.323974609375,
        826.0
      ],
      [
        -609.4395751953125,
        -2773.353759765625,
        826.0
      ],
      [
        -629.6760864257812,
        -2765.560546875,
        826.0
      ],
      [
        -625.6463012695312,
        -2766.439453125,
        826.0
      ],
      [
        -629.6760864257812,
        -2765.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2766.439453125,
        826.0
      ],
      [
        -612.3239135742188,
        -2765.560546875,
        826.0
      ],
      [
        -632.5604248046875,
        -2773.353759765625,
        826.0
      ],
      [
        -633.4393920898438,
        -2769.323974609375,
        826.0
      ],
      [
        -633.4393920898438,
        -2769.323974609375,
        826.0
      ],
      [
        -633.4393920898438,
        -2786.676025390625,
        826.0
      ],
      [
        -632.5604248046875,
        -2782.646240234375,
        826.0
      ],
      [
        -612.3239135742188,
        -2790.439453125,
        826.0
      ],
      [
        -616.3536987304688,
        -2789.560546875,
        826.0
      ],
      [
        -612.3239135742188,
        -2790.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2789.560546875,
        826.0
      ],
      [
        -629.6760864257812,
        -2790.439453125,
        826.0
      ],
      [
        -597.0,
        -2800.0,
        826.0
      ],
      [
        -599.43798828125,
        -2802.43798828125,
        826.0
      ],
      [
        -645.0,
        -2800.0,
        826.0
      ],
      [
        -642.56201171875,
        -2802.43798828125,
        826.0
      ],
      [
        -645.0,
        -2702.5,
        826.0
      ],
      [
        -645.0,
        -2704.0,
        826.0
      ],
      [
        -645.0,
        -2720.0,
        826.0
      ],
      [
        -645.0,
        -2721.5,
        826.0
      ],
      [
        -645.0,
        -2732.666748046875,
        826.0
      ],
      [
        -645.0,
        -2721.5,
        826.0
      ],
      [
        -645.0,
        -2702.5,
        826.0
      ],
      [
        -645.0,
        -2691.333251953125,
        826.0
      ],
      [
        -645.0,
        -2734.0,
        826.0
      ],
      [
        -645.0,
        -2732.666748046875,
        826.0
      ],
      [
        -645.0,
        -2691.333251953125,
        826.0
      ],
      [
        -645.0,
        -2690.0,
        826.0
      ],
      [
        -645.0,
        -2690.0,
        826.0
      ],
      [
        -656.0,
        -2690.0,
        826.0
      ],
      [
        -656.0,
        -2690.0,
        827.0
      ],
      [
        -645.0,
        -2734.0,
        826.0
      ],
      [
        -656.0,
        -2734.0,
        827.0
      ],
      [
        -656.0,
        -2734.0,
        826.0
      ],
      [
        -646.5,
        -2721.5,
        826.0
      ],
      [
        -646.5,
        -2720.0,
        826.0
      ],
      [
        -646.5,
        -2704.0,
        826.0
      ],
      [
        -646.5,
        -2702.5,
        826.0
      ],
      [
        -646.5,
        -2732.666748046875,
        826.0
      ],
      [
        -646.5,
        -2721.5,
        826.0
      ],
      [
        -646.5,
        -2702.5,
        826.0
      ],
      [
        -646.5,
        -2691.333251953125,
        826.0
      ],
      [
        -646.5,
        -2732.666748046875,
        826.0
      ],
      [
        -646.5,
        -2734.0,
        826.0
      ],
      [
        -646.5,
        -2690.0,
        826.0
      ],
      [
        -646.5,
        -2691.333251953125,
        826.0
      ],
      [
        -646.5,
        -2720.0,
        826.0
      ],
      [
        -645.0,
        -2720.0,
        826.0
      ],
      [
        -645.0,
        -2704.0,
        826.0
      ],
      [
        -646.5,
        -2704.0,
        826.0
      ],
      [
        -637.0,
        -2742.0,
        826.0
      ],
      [
        -645.0,
        -2734.0,
        826.0
      ],
      [
        -597.0,
        -2734.0,
        826.0
      ],
      [
        -605.0,
        -2742.0,
        826.0
      ],
      [
        -633.4393920898438,
        -2720.676025390625,
        826.0
      ],
      [
        -629.6760864257812,
        -2724.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2723.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2723.560546875,
        826.0
      ],
      [
        -632.5604248046875,
        -2707.353759765625,
        826.0
      ],
      [
        -632.5604248046875,
        -2716.646240234375,
        826.0
      ],
      [
        -608.5606079101562,
        -2703.323974609375,
        826.0
      ],
      [
        -612.3239135742188,
        -2699.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2700.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2700.439453125,
        826.0
      ],
      [
        -609.4395751953125,
        -2716.646240234375,
        826.0
      ],
      [
        -609.4395751953125,
        -2707.353759765625,
        826.0
      ],
      [
        -611.0584716796875,
        -2723.669189453125,
        826.2470092773438
      ],
      [
        -609.3309936523438,
        -2721.941650390625,
        826.2470092773438
      ],
      [
        -609.4395141601562,
        -2721.554931640625,
        826.0
      ],
      [
        -611.4449462890625,
        -2723.560546875,
        826.0
      ],
      [
        -630.9417724609375,
        -2700.3310546875,
        826.2470092773438
      ],
      [
        -632.6690063476562,
        -2702.058349609375,
        826.2470092773438
      ],
      [
        -632.5604248046875,
        -2702.445068359375,
        826.0
      ],
      [
        -630.5550537109375,
        -2700.439453125,
        826.0
      ],
      [
        -609.4395751953125,
        -2716.646240234375,
        826.0
      ],
      [
        -608.5606079101562,
        -2720.676025390625,
        826.0
      ],
      [
        -608.5606079101562,
        -2720.676025390625,
        826.0
      ],
      [
        -608.5606079101562,
        -2703.323974609375,
        826.0
      ],
      [
        -609.4395751953125,
        -2707.353759765625,
        826.0
      ],
      [
        -629.6760864257812,
        -2699.560546875,
        826.0
      ],
      [
        -625.6463012695312,
        -2700.439453125,
        826.0
      ],
      [
        -629.6760864257812,
        -2699.560546875,
        826.0
      ],
      [
        -616.3536987304688,
        -2700.439453125,
        826.0
      ],
      [
        -612.3239135742188,
        -2699.560546875,
        826.0
      ],
      [
        -632.5604248046875,
        -2707.353759765625,
        826.0
      ],
      [
        -633.4393920898438,
        -2703.323974609375,
        826.0
      ],
      [
        -633.4393920898438,
        -2703.323974609375,
        826.0
      ],
      [
        -633.4393920898438,
        -2720.676025390625,
        826.0
      ],
      [
        -632.5604248046875,
        -2716.646240234375,
        826.0
      ],
      [
        -612.3239135742188,
        -2724.439453125,
        826.0
      ],
      [
        -616.3536987304688,
        -2723.560546875,
        826.0
      ],
      [
        -612.3239135742188,
        -2724.439453125,
        826.0
      ],
      [
        -625.6463012695312,
        -2723.560546875,
        826.0
      ],
      [
        -629.6760864257812,
        -2724.439453125,
        826.0
      ],
      [
        -645.0,
        -2690.0,
        826.0
      ],
      [
        -642.56201171875,
        -2687.56201171875,
        826.0
      ],
      [
        -597.0,
        -2690.0,
        826.0
      ],
      [
        -599.43798828125,
        -2687.56201171875,
        826.0
      ],
      [
        -656.0,
        -2800.0,
        812.0
      ],
      [
        -656.0,
        -2756.0,
        812.0
      ],
      [
        -656.0,
        -2734.0,
        812.0
      ],
      [
        -656.0,
        -2690.0,
        812.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        812.0
      ],
      [
        -618.3646850585938,
        -2784.293212890625,
        812.0
      ],
      [
        -623.434326171875,
        -2784.293212890625,
        812.0
      ],
      [
        -614.5057983398438,
        -2780.434326171875,
        812.0
      ],
      [
        -618.3646850585938,
        -2784.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2780.434326171875,
        812.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        812.0
      ],
      [
        -627.293212890625,
        -2775.36474609375,
        812.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        812.0
      ],
      [
        -623.434326171875,
        -2771.505859375,
        812.0
      ],
      [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      [
        -618.3646850585938,
        -2771.505859375,
        812.0
      ],
      [
        -614.5057983398438,
        -2775.36474609375,
        812.0
      ],
      [
        -614.5057983398438,
        -2775.36474609375,
        812.0
      ],
      [
        -614.5057983398438,
        -2780.434326171875,
        812.0
      ],
      [
        -614.577880859375,
        -2775.5859375,
        810.5
      ],
      [
        -614.577880859375,
        -2780.184326171875,
        810.5
      ],
      [
        -618.246337890625,
        -2771.721923828125,
        810.5
      ],
      [
        -623.1844482421875,
        -2771.577880859375,
        810.5
      ],
      [
        -627.0482177734375,
        -2775.22705078125,
        810.5
      ],
      [
        -627.2115478515625,
        -2780.1650390625,
        810.5
      ],
      [
        -618.2273559570312,
        -2784.04833984375,
        810.5
      ],
      [
        -623.165283203125,
        -2784.21142578125,
        810.5
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        812.0
      ],
      [
        -618.3646850585938,
        -2718.293212890625,
        812.0
      ],
      [
        -623.434326171875,
        -2718.293212890625,
        812.0
      ],
      [
        -614.5057983398438,
        -2714.434326171875,
        812.0
      ],
      [
        -618.3646850585938,
        -2718.293212890625,
        812.0
      ],
      [
        -627.293212890625,
        -2714.434326171875,
        812.0
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        812.0
      ],
      [
        -627.293212890625,
        -2709.36474609375,
        812.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        812.0
      ],
      [
        -623.434326171875,
        -2705.505859375,
        812.0
      ],
      [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      [
        -618.3646850585938,
        -2705.505859375,
        812.0
      ],
      [
        -614.5057983398438,
        -2709.36474609375,
        812.0
      ],
      [
        -614.5057983398438,
        -2709.36474609375,
        812.0
      ],
      [
        -614.5057983398438,
        -2714.434326171875,
        812.0
      ],
      [
        -614.577880859375,
        -2709.5859375,
        810.5
      ],
      [
        -614.577880859375,
        -2714.184326171875,
        810.5
      ],
      [
        -618.246337890625,
        -2705.721923828125,
        810.5
      ],
      [
        -623.1844482421875,
        -2705.577880859375,
        810.5
      ],
      [
        -627.0482177734375,
        -2709.22705078125,
        810.5
      ],
      [
        -627.2115478515625,
        -2714.1650390625,
        810.5
      ],
      [
        -618.2273559570312,
        -2718.04833984375,
        810.5
      ],
      [
        -623.165283203125,
        -2718.21142578125,
        810.5
      ],
      [
        -656.0,
        -2800.0,
        812.0
      ],
      [
        -656.0,
        -2756.0,
        812.0
      ],
      [
        -656.0,
        -2795.5,
        814.5
      ],
      [
        -656.0,
        -2800.0,
        814.5
      ],
      [
        -656.0,
        -2756.0,
        814.5
      ],
      [
        -656.0,
        -2760.5,
        814.5
      ],
      [
        -656.0,
        -2800.0,
        815.5
      ],
      [
        -656.0,
        -2795.5,
        815.0
      ],
      [
        -656.0,
        -2795.5,
        815.0
      ],
      [
        -656.0,
        -2795.5,
        814.5
      ],
      [
        -651.0,
        -2791.000244140625,
        814.5
      ],
      [
        -655.4998168945312,
        -2760.5,
        814.5
      ],
      [
        -656.0,
        -2760.5,
        815.0
      ],
      [
        -656.0,
        -2756.0,
        815.5
      ],
      [
        -656.0,
        -2760.5,
        814.5
      ],
      [
        -656.0,
        -2760.5,
        815.0
      ],
      [
        -656.0,
        -2690.0,
        812.0
      ],
      [
        -656.0,
        -2734.0,
        812.0
      ],
      [
        -656.0,
        -2729.5,
        814.5
      ],
      [
        -656.0,
        -2734.0,
        814.5
      ],
      [
        -656.0,
        -2690.0,
        814.5
      ],
      [
        -656.0,
        -2694.5,
        814.5
      ],
      [
        -656.0,
        -2734.0,
        815.5
      ],
      [
        -656.0,
        -2729.5,
        815.0
      ],
      [
        -656.0,
        -2729.5,
        815.0
      ],
      [
        -656.0,
        -2729.5,
        814.5
      ],
      [
        -651.0,
        -2725.000244140625,
        814.5
      ],
      [
        -655.4998168945312,
        -2694.5,
        814.5
      ],
      [
        -656.0,
        -2694.5,
        815.0
      ],
      [
        -656.0,
        -2690.0,
        815.5
      ],
      [
        -656.0,
        -2694.5,
        814.5
      ],
      [
        -656.0,
        -2694.5,
        815.0
      ],
      [
        -700.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -701.5,
        -2800.0,
        827.5
      ],
      [
        -700.0,
        -2800.0,
        827.5
      ],
      [
        -700.0,
        -2800.0,
        829.7142944335938
      ],
      [
        -700.0,
        -2800.0,
        830.0
      ],
      [
        -701.5,
        -2800.0,
        830.0
      ],
      [
        -701.5,
        -2690.0,
        827.5
      ],
      [
        -700.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -700.0,
        -2690.0,
        827.5
      ],
      [
        -701.5,
        -2690.0,
        830.0
      ],
      [
        -700.0,
        -2690.0,
        830.0
      ],
      [
        -700.0,
        -2690.0,
        829.7142944335938
      ],
      [
        -701.5,
        -2800.0,
        812.0
      ],
      [
        -700.7999877929688,
        -2800.0,
        810.0
      ],
      [
        -700.0,
        -2800.0,
        810.0
      ],
      [
        -700.0,
        -2800.0,
        812.0
      ],
      [
        -700.7999877929688,
        -2690.0,
        810.0
      ],
      [
        -701.5,
        -2690.0,
        812.0
      ],
      [
        -700.0,
        -2690.0,
        812.0
      ],
      [
        -700.0,
        -2690.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.0576171875,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.100341796875,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.701416015625,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.820556640625,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.0576171875,
        810.0
      ],
      [
        -674.6666870117188,
        -2736.0,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.820556640625,
        810.0
      ],
      [
        -674.6666870117188,
        -2735.701416015625,
        810.0
      ],
      [
        -674.6665649414062,
        -2688.100341796875,
        810.0
      ],
      [
        -674.6665649414062,
        -2754.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2802.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2802.0,
        810.0
      ],
      [
        -674.6665649414062,
        -2754.0,
        810.0
      ],
      [
        -682.5999755859375,
        -2736.0,
        827.0
      ],
      [
        -656.0,
        -2736.0,
        827.0
      ],
      [
        -682.5999755859375,
        -2688.0,
        827.0
      ],
      [
        -656.0,
        -2688.0,
        827.0
      ],
      [
        -682.5999755859375,
        -2754.0,
        827.0
      ],
      [
        -656.0,
        -2754.0,
        827.0
      ],
      [
        -682.5999755859375,
        -2802.0,
        827.0
      ],
      [
        -656.0,
        -2802.0,
        827.0
      ],
      [
        -674.6666870117188,
        -2736.0,
        810.0
      ],
      [
        -675.6000366210938,
        -2736.0,
        812.0
      ],
      [
        -656.0,
        -2736.0,
        812.0
      ],
      [
        -656.0,
        -2736.0,
        810.0
      ],
      [
        -675.6000366210938,
        -2688.0,
        812.0
      ],
      [
        -674.6666870117188,
        -2688.0,
        810.0
      ],
      [
        -656.0,
        -2688.0,
        810.0
      ],
      [
        -656.0,
        -2688.0,
        812.0
      ],
      [
        -675.6000366210938,
        -2754.0,
        812.0
      ],
      [
        -674.6666870117188,
        -2754.0,
        810.0
      ],
      [
        -656.0,
        -2754.0,
        810.0
      ],
      [
        -656.0,
        -2754.0,
        812.0
      ],
      [
        -674.6666870117188,
        -2802.0,
        810.0
      ],
      [
        -675.6000366210938,
        -2802.0,
        812.0
      ],
      [
        -656.0,
        -2802.0,
        812.0
      ],
      [
        -656.0,
        -2802.0,
        810.0
      ],
      [
        -680.2666625976562,
        -2736.0,
        822.0
      ],
      [
        -681.5,
        -2736.0,
        827.0
      ],
      [
        -679.166748046875,
        -2736.0,
        822.0
      ],
      [
        -680.2666625976562,
        -2688.0,
        822.0
      ],
      [
        -679.166748046875,
        -2688.0,
        822.0
      ],
      [
        -681.5,
        -2688.0,
        827.0
      ],
      [
        -680.2666625976562,
        -2802.0,
        822.0
      ],
      [
        -681.5,
        -2802.0,
        827.0
      ],
      [
        -679.166748046875,
        -2802.0,
        822.0
      ],
      [
        -680.2666625976562,
        -2754.0,
        822.0
      ],
      [
        -679.166748046875,
        -2754.0,
        822.0
      ],
      [
        -681.5,
        -2754.0,
        827.0
      ],
      [
        -676.7667236328125,
        -2736.0,
        814.5
      ],
      [
        -675.6668701171875,
        -2736.0,
        814.5
      ],
      [
        -674.500244140625,
        -2736.0,
        812.0
      ],
      [
        -676.7667236328125,
        -2688.0,
        814.5
      ],
      [
        -674.500244140625,
        -2688.0,
        812.0
      ],
      [
        -675.6668701171875,
        -2688.0,
        814.5
      ],
      [
        -676.7667236328125,
        -2754.0,
        814.5
      ],
      [
        -674.500244140625,
        -2754.0,
        812.0
      ],
      [
        -675.6668701171875,
        -2754.0,
        814.5
      ],
      [
        -676.7667236328125,
        -2802.0,
        814.5
      ],
      [
        -675.6668701171875,
        -2802.0,
        814.5
      ],
      [
        -674.500244140625,
        -2802.0,
        812.0
      ],
      [
        -698.0,
        -2690.0,
        810.0
      ],
      [
        -698.0,
        -2685.8173828125,
        810.0
      ],
      [
        -698.0,
        -2690.0,
        810.0
      ],
      [
        -698.0,
        -2800.0,
        810.0
      ],
      [
        -698.0,
        -2804.1826171875,
        810.0
      ],
      [
        -698.0,
        -2800.0,
        810.0
      ],
      [
        -687.0,
        -2802.0,
        810.0
      ],
      [
        -684.0,
        -2802.0,
        810.0
      ],
      [
        -687.0,
        -2802.0,
        810.0
      ],
      [
        -687.0,
        -2804.181640625,
        810.0
      ],
      [
        -684.0,
        -2802.0,
        810.0
      ],
      [
        -684.0,
        -2804.181640625,
        810.0
      ],
      [
        -684.0,
        -2688.0,
        810.0
      ],
      [
        -687.0,
        -2688.0,
        810.0
      ],
      [
        -684.0,
        -2688.0,
        810.0
      ],
      [
        -684.0,
        -2685.818359375,
        810.0
      ],
      [
        -687.0,
        -2688.0,
        810.0
      ],
      [
        -687.0,
        -2685.818359375,
        810.0
      ],
      [
        -808.0,
        -2804.181884765625,
        810.0
      ],
      [
        -808.0,
        -2793.6728515625,
        810.0
      ],
      [
        -808.0,
        -2696.3271484375,
        810.0
      ],
      [
        -808.0,
        -2685.818115234375,
        810.0
      ],
      [
        -808.0,
        -2793.6728515625,
        810.0
      ],
      [
        -808.0,
        -2790.69091796875,
        810.0
      ],
      [
        -808.0,
        -2699.30908203125,
        810.0
      ],
      [
        -808.0,
        -2696.3271484375,
        810.0
      ],
      [
        -808.0,
        -2790.69091796875,
        810.0
      ],
      [
        -808.0,
        -2699.30908203125,
        810.0
      ],
      [
        -732.5,
        -2727.5,
        827.5
      ],
      [
        -730.0,
        -2727.5,
        827.5
      ],
      [
        -730.0,
        -2712.5,
        827.5
      ],
      [
        -732.5,
        -2712.5,
        827.5
      ],
      [
        -730.0,
        -2727.5,
        827.5
      ],
      [
        -730.0,
        -2722.5,
        827.5
      ],
      [
        -730.0,
        -2717.5,
        827.5
      ],
      [
        -730.0,
        -2712.5,
        827.5
      ],
      [
        -732.5,
        -2722.5,
        827.5
      ],
      [
        -730.0,
        -2722.5,
        827.5
      ],
      [
        -730.0,
        -2717.5,
        827.5
      ],
      [
        -732.5,
        -2717.5,
        827.5
      ],
      [
        -728.5,
        -2690.0,
        827.5
      ],
      [
        -732.0,
        -2690.0,
        827.5
      ],
      [
        -728.5,
        -2690.0,
        830.0
      ],
      [
        -746.0,
        -2688.0,
        827.5
      ],
      [
        -749.0,
        -2688.0,
        827.5
      ],
      [
        -777.0,
        -2688.0,
        827.5
      ],
      [
        -780.0,
        -2688.0,
        827.5
      ],
      [
        -746.0,
        -2688.0,
        827.5
      ],
      [
        -746.0,
        -2687.727294921875,
        827.5
      ],
      [
        -777.0,
        -2688.0,
        827.5
      ],
      [
        -777.0,
        -2687.727294921875,
        827.5
      ],
      [
        -728.5,
        -2800.0,
        827.5
      ],
      [
        -732.0,
        -2800.0,
        827.5
      ],
      [
        -728.5,
        -2800.0,
        830.0
      ],
      [
        -749.0,
        -2802.0,
        827.5
      ],
      [
        -746.0,
        -2802.0,
        827.5
      ],
      [
        -780.0,
        -2802.0,
        827.5
      ],
      [
        -777.0,
        -2802.0,
        827.5
      ],
      [
        -746.0,
        -2802.0,
        827.5
      ],
      [
        -746.0,
        -2802.272705078125,
        827.5
      ],
      [
        -777.0,
        -2802.0,
        827.5
      ],
      [
        -777.0,
        -2802.272705078125,
        827.5
      ],
      [
        -730.0,
        -2767.5,
        827.5
      ],
      [
        -730.0,
        -2762.5,
        827.5
      ],
      [
        -730.0,
        -2777.5,
        827.5
      ],
      [
        -730.0,
        -2772.5,
        827.5
      ],
      [
        -730.0,
        -2767.5,
        827.5
      ],
      [
        -732.5,
        -2767.5,
        827.5
      ],
      [
        -730.0,
        -2762.5,
        827.5
      ],
      [
        -732.5,
        -2762.5,
        827.5
      ],
      [
        -732.5,
        -2772.5,
        827.5
      ],
      [
        -730.0,
        -2772.5,
        827.5
      ],
      [
        -732.5,
        -2743.0,
        812.0
      ],
      [
        -730.0,
        -2743.0,
        812.0
      ],
      [
        -730.0,
        -2697.0,
        812.0
      ],
      [
        -732.5,
        -2697.0,
        812.0
      ],
      [
        -730.0,
        -2743.0,
        812.0
      ],
      [
        -730.0,
        -2738.0,
        812.0
      ],
      [
        -730.0,
        -2702.0,
        812.0
      ],
      [
        -730.0,
        -2697.0,
        812.0
      ],
      [
        -732.5,
        -2738.0,
        812.0
      ],
      [
        -730.0,
        -2738.0,
        812.0
      ],
      [
        -730.0,
        -2702.0,
        812.0
      ],
      [
        -732.5,
        -2702.0,
        812.0
      ],
      [
        -746.0,
        -2688.0,
        812.0
      ],
      [
        -746.0,
        -2688.0,
        810.0
      ],
      [
        -749.0,
        -2688.0,
        810.0
      ],
      [
        -749.0,
        -2688.0,
        812.0
      ],
      [
        -777.0,
        -2688.0,
        812.0
      ],
      [
        -777.0,
        -2688.0,
        810.0
      ],
      [
        -780.0,
        -2688.0,
        810.0
      ],
      [
        -780.0,
        -2688.0,
        812.0
      ],
      [
        -746.0,
        -2688.0,
        810.0
      ],
      [
        -746.0,
        -2688.0,
        812.0
      ],
      [
        -746.0,
        -2686.03662109375,
        812.0
      ],
      [
        -746.0,
        -2685.818359375,
        810.0
      ],
      [
        -777.0,
        -2688.0,
        810.0
      ],
      [
        -777.0,
        -2688.0,
        812.0
      ],
      [
        -777.0,
        -2686.03662109375,
        812.0
      ],
      [
        -777.0,
        -2685.818359375,
        810.0
      ],
      [
        -728.5,
        -2690.0,
        812.0
      ],
      [
        -729.2000122070312,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2690.0,
        810.0
      ],
      [
        -732.0,
        -2690.0,
        812.0
      ],
      [
        -729.2000122070312,
        -2800.0,
        810.0
      ],
      [
        -728.5,
        -2800.0,
        812.0
      ],
      [
        -732.0,
        -2800.0,
        812.0
      ],
      [
        -732.0,
        -2800.0,
        810.0
      ],
      [
        -749.0,
        -2802.0,
        812.0
      ],
      [
        -749.0,
        -2802.0,
        810.0
      ],
      [
        -746.0,
        -2802.0,
        810.0
      ],
      [
        -746.0,
        -2802.0,
        812.0
      ],
      [
        -780.0,
        -2802.0,
        812.0
      ],
      [
        -780.0,
        -2802.0,
        810.0
      ],
      [
        -777.0,
        -2802.0,
        810.0
      ],
      [
        -777.0,
        -2802.0,
        812.0
      ],
      [
        -746.0,
        -2802.0,
        812.0
      ],
      [
        -746.0,
        -2802.0,
        810.0
      ],
      [
        -746.0,
        -2804.181640625,
        810.0
      ],
      [
        -746.0,
        -2803.96337890625,
        812.0
      ],
      [
        -777.0,
        -2802.0,
        812.0
      ],
      [
        -777.0,
        -2802.0,
        810.0
      ],
      [
        -777.0,
        -2804.181640625,
        810.0
      ],
      [
        -777.0,
        -2803.96337890625,
        812.0
      ],
      [
        -730.0,
        -2752.0,
        812.0
      ],
      [
        -730.0,
        -2747.0,
        812.0
      ],
      [
        -730.0,
        -2793.0,
        812.0
      ],
      [
        -730.0,
        -2788.0,
        812.0
      ],
      [
        -730.0,
        -2752.0,
        812.0
      ],
      [
        -732.5,
        -2752.0,
        812.0
      ],
      [
        -730.0,
        -2747.0,
        812.0
      ],
      [
        -732.5,
        -2747.0,
        812.0
      ],
      [
        -732.5,
        -2788.0,
        812.0
      ],
      [
        -730.0,
        -2788.0,
        812.0
      ],
      [
        -730.0,
        -2800.0,
        827.5
      ],
      [
        -730.0,
        -2800.0,
        812.0
      ],
      [
        -830.187255859375,
        -2708.330322265625,
        775.0
      ],
      [
        -830.187255859375,
        -2708.330322265625,
        766.0
      ],
      [
        -825.7378540039062,
        -2708.475830078125,
        775.0
      ],
      [
        -825.7378540039062,
        -2708.475830078125,
        766.0
      ],
      [
        -825.738037109375,
        -2781.524169921875,
        775.0
      ],
      [
        -825.738037109375,
        -2781.524169921875,
        766.0
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2709.2998046875,
        776.0
      ],
      [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2769.5,
        770.5
      ],
      [
        -808.0,
        -2770.89990234375,
        766.0
      ],
      [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      [
        -808.0,
        -2779.10009765625,
        766.0
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -808.0,
        -2782.10009765625,
        770.5
      ],
      [
        -808.0,
        -2780.7001953125,
        766.0
      ],
      [
        -808.0,
        -2770.89990234375,
        775.0
      ],
      [
        -808.0,
        -2769.5,
        770.5
      ],
      [
        -808.0,
        -2780.5,
        770.5
      ],
      [
        -808.0,
        -2779.10009765625,
        775.0
      ],
      [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2710.89990234375,
        775.0
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -808.0,
        -2707.89990234375,
        770.5
      ],
      [
        -808.0,
        -2709.2998046875,
        775.0
      ],
      [
        -808.0,
        -2719.10009765625,
        766.0
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -808.0,
        -2722.10009765625,
        770.5
      ],
      [
        -808.0,
        -2720.7001953125,
        766.0
      ],
      [
        -808.0,
        -2709.5,
        770.5
      ],
      [
        -808.0,
        -2710.89990234375,
        766.0
      ],
      [
        -808.0,
        -2720.5,
        770.5
      ],
      [
        -808.0,
        -2719.10009765625,
        775.0
      ],
      [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      [
        -808.0,
        -2720.7001953125,
        775.0
      ],
      [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      [
        -777.0,
        -2808.0,
        775.0
      ],
      [
        -777.0,
        -2804.39990234375,
        766.0
      ],
      [
        -746.0,
        -2808.0,
        775.0
      ],
      [
        -746.0,
        -2804.39990234375,
        766.0
      ],
      [
        -777.0,
        -2682.0,
        775.0
      ],
      [
        -777.0,
        -2685.60009765625,
        766.0
      ],
      [
        -746.0,
        -2682.0,
        775.0
      ],
      [
        -746.0,
        -2685.60009765625,
        766.0
      ],
      [
        -684.0,
        -2808.0,
        775.0
      ],
      [
        -687.0,
        -2808.0,
        775.0
      ],
      [
        -687.0,
        -2804.39990234375,
        766.0
      ],
      [
        -684.0,
        -2804.39990234375,
        766.0
      ],
      [
        -658.0,
        -2807.7138671875,
        774.2849731445312
      ],
      [
        -658.0,
        -2808.077880859375,
        774.2849731445312
      ],
      [
        -656.0,
        -2805.99951171875,
        769.9992065429688
      ],
      [
        -658.0,
        -2807.7138671875,
        774.2849731445312
      ],
      [
        -687.0,
        -2682.0,
        775.0
      ],
      [
        -684.0,
        -2682.0,
        775.0
      ],
      [
        -684.0,
        -2685.60009765625,
        766.0
      ],
      [
        -687.0,
        -2685.60009765625,
        766.0
      ],
      [
        -658.0,
        -2682.28564453125,
        774.28564453125
      ],
      [
        -658.0,
        -2681.922119140625,
        774.28564453125
      ],
      [
        -658.0,
        -2682.28564453125,
        774.28564453125
      ],
      [
        -656.0,
        -2684.0,
        769.9998779296875
      ],
      [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -715.0,
        -2804.53564453125,
        806.7630004882812
      ],
      [
        -715.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -715.0,
        -2808.0,
        775.0
      ],
      [
        -715.0,
        -2804.39990234375,
        766.0
      ],
      [
        -698.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2802.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2802.0,
        810.0
      ],
      [
        -715.0,
        -2685.46435546875,
        806.7630004882812
      ],
      [
        -732.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -715.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -715.0,
        -2682.0,
        775.0
      ],
      [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      [
        -698.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2688.0,
        807.4545288085938
      ],
      [
        -698.0,
        -2688.0,
        810.0
      ],
      [
        -732.0,
        -2801.833251953125,
        807.5
      ],
      [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      [
        -697.5,
        -2800.0,
        808.0000610351562
      ],
      [
        -697.5,
        -2792.667236328125,
        810.0
      ],
      [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      [
        -698.0,
        -2802.0,
        807.5
      ],
      [
        -698.0,
        -2688.166748046875,
        807.5
      ],
      [
        -732.0,
        -2688.166748046875,
        807.5
      ],
      [
        -697.5,
        -2697.333251953125,
        810.0
      ],
      [
        -697.5,
        -2690.0,
        808.0
      ],
      [
        -698.0,
        -2688.166748046875,
        807.5
      ],
      [
        -698.0,
        -2688.0,
        807.5
      ],
      [
        -667.6666870117188,
        -2754.0,
        795.0
      ],
      [
        -656.0,
        -2754.0,
        795.0
      ],
      [
        -667.6666870117188,
        -2802.0,
        795.0
      ],
      [
        -656.0,
        -2802.0,
        795.0
      ],
      [
        -667.6666870117188,
        -2688.0,
        795.0
      ],
      [
        -656.0,
        -2688.0,
        795.0
      ],
      [
        -667.6666870117188,
        -2736.0,
        795.0
      ],
      [
        -656.0,
        -2736.0,
        795.0
      ],
      [
        -668.8333740234375,
        -2736.0,
        797.5
      ],
      [
        -667.6669311523438,
        -2736.0,
        797.5
      ],
      [
        -666.5003051757812,
        -2736.0,
        795.0
      ],
      [
        -668.8333740234375,
        -2688.0,
        797.5
      ],
      [
        -666.5003051757812,
        -2688.0,
        795.0
      ],
      [
        -667.6669311523438,
        -2688.0,
        797.5
      ],
      [
        -668.8333740234375,
        -2754.0,
        797.5
      ],
      [
        -666.5003051757812,
        -2754.0,
        795.0
      ],
      [
        -667.6669311523438,
        -2754.0,
        797.5
      ],
      [
        -668.8333740234375,
        -2802.0,
        797.5
      ],
      [
        -667.6669311523438,
        -2802.0,
        797.5
      ],
      [
        -666.5003051757812,
        -2802.0,
        795.0
      ],
      [
        -672.3333740234375,
        -2736.0,
        805.0
      ],
      [
        -673.5,
        -2736.0,
        810.0
      ],
      [
        -671.166748046875,
        -2736.0,
        805.0
      ],
      [
        -672.3333740234375,
        -2688.0,
        805.0
      ],
      [
        -671.166748046875,
        -2688.0,
        805.0
      ],
      [
        -673.5,
        -2688.0,
        810.0
      ],
      [
        -672.3333740234375,
        -2754.0,
        805.0
      ],
      [
        -671.166748046875,
        -2754.0,
        805.0
      ],
      [
        -673.5,
        -2754.0,
        810.0
      ],
      [
        -672.3333740234375,
        -2802.0,
        805.0
      ],
      [
        -673.5,
        -2802.0,
        810.0
      ],
      [
        -671.166748046875,
        -2802.0,
        805.0
      ],
      [
        -567.0,
        -2647.0,
        827.0
      ],
      [
        -607.0,
        -2647.0,
        827.0
      ],
      [
        -733.0,
        -2631.0,
        827.0
      ],
      [
        -733.0,
        -2641.0,
        827.0
      ],
      [
        -723.0,
        -2631.0,
        827.0
      ],
      [
        -733.0,
        -2631.0,
        827.0
      ],
      [
        -733.0,
        -2641.0,
        827.0
      ],
      [
        -723.0,
        -2641.0,
        827.0
      ],
      [
        -567.0,
        -2625.0,
        825.0
      ],
      [
        -607.0,
        -2625.0,
        825.0
      ],
      [
        -567.0,
        -2625.0,
        825.0
      ],
      [
        -567.0,
        -2647.0,
        827.0
      ],
      [
        -567.0,
        -2647.0,
        825.0
      ],
      [
        -607.0,
        -2629.71435546875,
        825.0
      ],
      [
        -607.0,
        -2627.0,
        825.0
      ],
      [
        -607.0,
        -2627.0,
        825.0
      ],
      [
        -607.0,
        -2625.0,
        825.0
      ],
      [
        -607.0,
        -2647.0,
        827.0
      ],
      [
        -607.0,
        -2629.71435546875,
        825.0
      ],
      [
        -607.0,
        -2647.0,
        825.0
      ],
      [
        -607.0,
        -2659.84033203125,
        825.7999877929688
      ],
      [
        -607.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -567.0,
        -2659.84033203125,
        825.7999877929688
      ],
      [
        -567.0,
        -2647.0,
        825.7999877929688
      ],
      [
        -567.0,
        -2660.000244140625,
        825.0
      ],
      [
        -567.0,
        -2653.0,
        825.0
      ],
      [
        -567.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -607.0,
        -2660.000244140625,
        825.0
      ],
      [
        -607.0,
        -2653.0,
        825.7999877929688
      ],
      [
        -607.0,
        -2653.0,
        825.0
      ],
      [
        -567.0,
        -2625.0,
        819.9999389648438
      ],
      [
        -607.0,
        -2625.0,
        819.9999389648438
      ],
      [
        -567.0,
        -2625.0,
        819.9999389648438
      ],
      [
        -567.0,
        -2631.0,
        825.0
      ],
      [
        -607.0,
        -2630.56640625,
        824.6385498046875
      ],
      [
        -607.0,
        -2628.818115234375,
        823.1818237304688
      ],
      [
        -607.0,
        -2628.818115234375,
        823.1818237304688
      ],
      [
        -607.0,
        -2625.0,
        819.9999389648438
      ],
      [
        -607.0,
        -2631.0,
        825.0
      ],
      [
        -607.0,
        -2630.56640625,
        824.6385498046875
      ],
      [
        -607.0,
        -2628.5,
        790.0
      ],
      [
        -607.0,
        -2627.906982421875,
        790.0
      ],
      [
        -607.0,
        -2627.906982421875,
        790.0
      ],
      [
        -607.0,
        -2625.0,
        790.0
      ],
      [
        -607.0,
        -2667.0,
        790.0
      ],
      [
        -607.0,
        -2628.5,
        790.0
      ],
      [
        -567.0,
        -2625.0,
        790.0
      ],
      [
        -607.0,
        -2625.0,
        790.0
      ],
      [
        -567.0,
        -2625.0,
        790.0
      ],
      [
        -567.0,
        -2667.0,
        790.0
      ],
      [
        -567.0,
        -2635.5,
        790.0
      ],
      [
        -592.5,
        -2635.5,
        790.0
      ],
      [
        -600.0,
        -2635.5,
        801.7999877929688
      ],
      [
        -567.0,
        -2635.5,
        801.7999877929688
      ],
      [
        -567.0,
        -2635.5,
        802.7999877929688
      ],
      [
        -600.0,
        -2635.5,
        802.7999877929688
      ],
      [
        -600.0,
        -2635.5,
        802.7999877929688
      ],
      [
        -599.699951171875,
        -2635.5,
        806.5
      ],
      [
        -592.7810668945312,
        -2635.218994140625,
        790.0
      ],
      [
        -567.0,
        -2635.218994140625,
        790.0
      ],
      [
        -592.699951171875,
        -2635.5,
        791.0
      ],
      [
        -592.7810668945312,
        -2635.218994140625,
        790.0
      ],
      [
        -592.699951171875,
        -2635.5,
        791.0
      ],
      [
        -592.7810668945312,
        -2635.5,
        790.0
      ],
      [
        -593.5,
        -2654.333740234375,
        802.7999877929688
      ],
      [
        -593.5,
        -2657.6669921875,
        801.7999877929688
      ],
      [
        -593.5,
        -2645.333740234375,
        801.7999877929688
      ],
      [
        -593.300048828125,
        -2657.6669921875,
        801.7999877929688
      ],
      [
        -593.300048828125,
        -2654.333740234375,
        802.7999877929688
      ],
      [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      [
        -593.300048828125,
        -2654.333740234375,
        802.7999877929688
      ],
      [
        -593.300048828125,
        -2657.6669921875,
        801.7999877929688
      ],
      [
        -593.5,
        -2657.6669921875,
        801.7999877929688
      ],
      [
        -593.5,
        -2654.333740234375,
        802.7999877929688
      ],
      [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      [
        -574.0,
        -2645.376708984375,
        802.7999877929688
      ],
      [
        -567.0,
        -2645.376708984375,
        802.7999877929688
      ],
      [
        -574.0,
        -2645.376708984375,
        802.7999877929688
      ],
      [
        -599.5,
        -2645.333251953125,
        801.7999877929688
      ],
      [
        -599.5,
        -2657.666748046875,
        801.7999877929688
      ],
      [
        -599.5,
        -2654.33349609375,
        802.7999877929688
      ],
      [
        -599.699951171875,
        -2654.33349609375,
        802.7999877929688
      ],
      [
        -599.699951171875,
        -2657.666748046875,
        801.7999877929688
      ],
      [
        -600.0,
        -2645.333251953125,
        801.7999877929688
      ],
      [
        -599.5,
        -2654.33349609375,
        802.7999877929688
      ],
      [
        -599.5,
        -2657.666748046875,
        801.7999877929688
      ],
      [
        -599.699951171875,
        -2657.666748046875,
        801.7999877929688
      ],
      [
        -599.699951171875,
        -2654.33349609375,
        802.7999877929688
      ],
      [
        -599.5,
        -2645.333251953125,
        801.7999877929688
      ],
      [
        -593.5,
        -2645.333740234375,
        801.7999877929688
      ],
      [
        -593.5,
        -2641.700439453125,
        806.5000610351562
      ],
      [
        -573.5,
        -2641.700439453125,
        806.5000610351562
      ],
      [
        -600.0,
        -2641.4501953125,
        802.7999877929688
      ],
      [
        -599.699951171875,
        -2641.4501953125,
        806.5
      ],
      [
        -599.699951171875,
        -2641.700439453125,
        806.5
      ],
      [
        -599.5,
        -2641.700439453125,
        806.5
      ],
      [
        -599.5,
        -2641.4501953125,
        806.5
      ],
      [
        -599.5,
        -2641.4501953125,
        802.7999877929688
      ],
      [
        -574.0,
        -2657.8701171875,
        806.5
      ],
      [
        -574.0,
        -2654.493408203125,
        806.5
      ],
      [
        -574.0,
        -2657.8701171875,
        806.5
      ],
      [
        -567.0,
        -2657.8701171875,
        806.5
      ],
      [
        -567.0,
        -2654.493408203125,
        806.5
      ],
      [
        -573.5,
        -2654.493408203125,
        806.5
      ],
      [
        -574.0,
        -2654.493408203125,
        806.5
      ],
      [
        -573.5,
        -2654.493408203125,
        806.5
      ],
      [
        -573.5,
        -2642.0,
        790.0
      ],
      [
        -573.5,
        -2641.449951171875,
        790.0
      ],
      [
        -573.5,
        -2642.0,
        790.0
      ],
      [
        -573.5,
        -2651.11669921875,
        790.0
      ],
      [
        -574.0,
        -2651.116943359375,
        790.0
      ],
      [
        -573.7810668945312,
        -2642.0,
        790.0
      ],
      [
        -574.0,
        -2654.493408203125,
        790.0
      ],
      [
        -574.0,
        -2651.116943359375,
        790.0
      ],
      [
        -574.0,
        -2654.493408203125,
        790.0
      ],
      [
        -573.5,
        -2666.300537109375,
        793.4967041015625
      ],
      [
        -573.5,
        -2654.493408203125,
        790.0
      ],
      [
        -573.5,
        -2641.449951171875,
        790.0
      ],
      [
        -573.5,
        -2641.449951171875,
        790.8372192382812
      ],
      [
        -573.6998901367188,
        -2641.449951171875,
        790.8372192382812
      ],
      [
        -573.767822265625,
        -2641.449951171875,
        790.0
      ],
      [
        -573.6917724609375,
        -2641.660888671875,
        791.0000610351562
      ],
      [
        -573.6867065429688,
        -2641.449951171875,
        791.0000610351562
      ],
      [
        -573.6917724609375,
        -2641.660888671875,
        791.0000610351562
      ],
      [
        -573.6867065429688,
        -2641.449951171875,
        791.0000610351562
      ],
      [
        -586.5,
        -2641.449951171875,
        790.0
      ],
      [
        -586.5,
        -2641.449951171875,
        790.0
      ],
      [
        -586.5,
        -2642.0,
        790.0
      ],
      [
        -586.5,
        -2642.0,
        790.0
      ],
      [
        -586.5,
        -2645.33349609375,
        790.0
      ],
      [
        -586.2189331054688,
        -2641.759033203125,
        790.0
      ],
      [
        -573.7810668945312,
        -2641.759033203125,
        790.0
      ],
      [
        -586.300048828125,
        -2645.33349609375,
        790.0
      ],
      [
        -586.2189331054688,
        -2642.0,
        790.0
      ],
      [
        -586.5,
        -2645.33349609375,
        790.0
      ],
      [
        -586.300048828125,
        -2645.33349609375,
        790.0
      ],
      [
        -586.2189331054688,
        -2642.0,
        790.0
      ],
      [
        -586.2189331054688,
        -2641.759033203125,
        790.0
      ],
      [
        -573.7810668945312,
        -2642.0,
        790.0
      ],
      [
        -573.7810668945312,
        -2641.759033203125,
        790.0
      ],
      [
        -592.5,
        -2642.0,
        790.0
      ],
      [
        -592.5,
        -2641.449951171875,
        791.0
      ],
      [
        -592.5,
        -2641.449951171875,
        790.0
      ],
      [
        -592.5,
        -2642.0,
        790.0
      ],
      [
        -592.5,
        -2645.333251953125,
        790.0
      ],
      [
        -592.5,
        -2645.333251953125,
        790.0
      ],
      [
        -592.699951171875,
        -2645.333251953125,
        790.0
      ],
      [
        -592.7810668945312,
        -2642.0,
        790.0
      ],
      [
        -592.699951171875,
        -2645.333251953125,
        790.0
      ],
      [
        -592.699951171875,
        -2641.449951171875,
        791.0
      ],
      [
        -592.7810668945312,
        -2642.0,
        790.0
      ],
      [
        -592.7810668945312,
        -2641.449951171875,
        790.0
      ],
      [
        -592.5,
        -2635.5,
        790.0
      ],
      [
        -567.0,
        -2651.116943359375,
        790.0
      ],
      [
        -573.5,
        -2651.11669921875,
        790.0
      ],
      [
        -567.0,
        -2654.493408203125,
        790.0
      ],
      [
        -573.5,
        -2663.3740234375,
        808.1300048828125
      ],
      [
        -573.5,
        -2657.8701171875,
        806.5
      ],
      [
        -607.0,
        -2632.0,
        785.0
      ],
      [
        -607.0,
        -2631.696533203125,
        783.4820556640625
      ],
      [
        -607.0,
        -2631.696533203125,
        783.4820556640625
      ],
      [
        -607.0,
        -2628.199951171875,
        766.0
      ],
      [
        -607.0,
        -2633.0,
        790.0
      ],
      [
        -607.0,
        -2632.0,
        785.0
      ],
      [
        -607.0,
        -2667.0,
        766.0
      ],
      [
        -607.0,
        -2670.0,
        774.9995727539062
      ],
      [
        -607.0,
        -2630.0,
        775.0001220703125
      ],
      [
        -607.0,
        -2633.000244140625,
        766.0
      ],
      [
        -592.9732055664062,
        -2669.10009765625,
        779.5
      ],
      [
        -573.699951171875,
        -2654.717041015625,
        778.5
      ],
      [
        -573.699951171875,
        -2657.543212890625,
        779.5
      ],
      [
        -574.0,
        -2665.173828125,
        778.5
      ],
      [
        -573.5,
        -2657.543212890625,
        779.5
      ],
      [
        -573.5,
        -2654.717041015625,
        778.5
      ],
      [
        -573.5,
        -2665.173828125,
        778.5
      ],
      [
        -573.699951171875,
        -2657.543212890625,
        779.5
      ],
      [
        -573.699951171875,
        -2654.717041015625,
        778.5
      ],
      [
        -573.5,
        -2654.717041015625,
        778.5
      ],
      [
        -573.5,
        -2657.543212890625,
        779.5
      ],
      [
        -574.0,
        -2665.173828125,
        778.5
      ],
      [
        -567.0,
        -2665.173828125,
        778.5
      ],
      [
        -573.5,
        -2665.173828125,
        778.5
      ],
      [
        -593.0,
        -2664.666748046875,
        779.5
      ],
      [
        -586.0,
        -2664.666748046875,
        779.5
      ],
      [
        -586.0,
        -2664.666748046875,
        779.5
      ],
      [
        -573.5,
        -2642.0,
        770.2999877929688
      ],
      [
        -574.0,
        -2642.0,
        770.2999877929688
      ],
      [
        -573.7991333007812,
        -2635.0,
        770.2999877929688
      ],
      [
        -573.5,
        -2635.0,
        770.2999877929688
      ],
      [
        -573.9841918945312,
        -2641.449951171875,
        770.300048828125
      ],
      [
        -573.5,
        -2641.449951171875,
        773.805419921875
      ],
      [
        -573.699951171875,
        -2641.449951171875,
        773.805419921875
      ],
      [
        -573.5,
        -2635.5,
        771.7000732421875
      ],
      [
        -573.5,
        -2635.5,
        770.2999877929688
      ],
      [
        -573.8134765625,
        -2635.5,
        770.2999877929688
      ],
      [
        -573.699951171875,
        -2635.5,
        771.7000732421875
      ],
      [
        -573.513427734375,
        -2635.5,
        774.0
      ],
      [
        -573.5,
        -2635.5,
        774.0
      ],
      [
        -573.5076293945312,
        -2635.300048828125,
        774.0
      ],
      [
        -573.5,
        -2635.300048828125,
        774.0
      ],
      [
        -573.5,
        -2635.5,
        774.0
      ],
      [
        -573.513427734375,
        -2635.5,
        774.0
      ],
      [
        -573.6901245117188,
        -2641.6591796875,
        774.0000610351562
      ],
      [
        -573.6841430664062,
        -2641.449951171875,
        774.0000610351562
      ],
      [
        -573.6901245117188,
        -2641.6591796875,
        774.0000610351562
      ],
      [
        -573.6841430664062,
        -2641.449951171875,
        774.0000610351562
      ],
      [
        -574.0,
        -2635.0,
        770.2999877929688
      ],
      [
        -574.0,
        -2641.449951171875,
        770.300048828125
      ],
      [
        -574.0,
        -2641.449951171875,
        774.0000610351562
      ],
      [
        -574.0,
        -2641.449951171875,
        774.0000610351562
      ],
      [
        -574.0,
        -2641.669921875,
        774.0000610351562
      ],
      [
        -574.0,
        -2641.669921875,
        774.0000610351562
      ],
      [
        -574.0,
        -2635.5,
        774.0
      ],
      [
        -574.0,
        -2635.5,
        770.2999877929688
      ],
      [
        -574.0,
        -2635.300048828125,
        774.0
      ],
      [
        -574.0,
        -2635.5,
        774.0
      ],
      [
        -586.0,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -586.0,
        -2635.5,
        770.2999877929688
      ],
      [
        -574.0,
        -2635.5,
        770.2999877929688
      ],
      [
        -585.5,
        -2648.2666015625,
        771.5173950195312
      ],
      [
        -585.699951171875,
        -2648.2666015625,
        771.5173950195312
      ],
      [
        -579.5,
        -2648.266845703125,
        771.5174560546875
      ],
      [
        -579.300048828125,
        -2648.266845703125,
        771.5174560546875
      ],
      [
        -585.699951171875,
        -2648.2666015625,
        771.5173950195312
      ],
      [
        -586.0,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -579.5,
        -2643.33349609375,
        769.7717895507812
      ],
      [
        -585.5,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -579.0,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -579.5,
        -2644.826171875,
        770.2999877929688
      ],
      [
        -579.5,
        -2643.33349609375,
        769.7717895507812
      ],
      [
        -579.0,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -579.0907592773438,
        -2644.825927734375,
        770.2999877929688
      ],
      [
        -585.5,
        -2643.333251953125,
        769.7717895507812
      ],
      [
        -585.5,
        -2644.825927734375,
        770.2999877929688
      ],
      [
        -585.5,
        -2648.2666015625,
        771.5173950195312
      ],
      [
        -579.5,
        -2648.266845703125,
        771.5174560546875
      ],
      [
        -579.300048828125,
        -2648.266845703125,
        771.5174560546875
      ],
      [
        -579.5,
        -2642.0,
        769.2999877929688
      ],
      [
        -579.5,
        -2650.19677734375,
        766.0
      ],
      [
        -585.5,
        -2642.0,
        769.2999877929688
      ],
      [
        -585.5,
        -2650.19677734375,
        766.0
      ],
      [
        -592.5,
        -2642.0,
        786.2999877929688
      ],
      [
        -592.5,
        -2664.666748046875,
        779.5
      ],
      [
        -593.0,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -592.9129028320312,
        -2635.087158203125,
        788.3738403320312
      ],
      [
        -592.5,
        -2642.0,
        787.2999877929688
      ],
      [
        -593.0,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -592.5,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -592.5,
        -2642.0,
        786.2999877929688
      ],
      [
        -592.5,
        -2635.0,
        786.2999877929688
      ],
      [
        -592.5,
        -2635.0,
        787.2999877929688
      ],
      [
        -592.691162109375,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -567.0,
        -2635.5,
        786.2999877929688
      ],
      [
        -592.5,
        -2635.5,
        786.2999877929688
      ],
      [
        -567.0,
        -2635.5,
        787.2999877929688
      ],
      [
        -592.5,
        -2635.5,
        787.2999877929688
      ],
      [
        -586.5,
        -2642.0,
        786.2999877929688
      ],
      [
        -586.5,
        -2664.666748046875,
        779.5
      ],
      [
        -586.0,
        -2642.0,
        787.2999877929688
      ],
      [
        -586.5,
        -2642.0,
        787.2999877929688
      ],
      [
        -586.5,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -586.0,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -586.0121459960938,
        -2668.5,
        779.5
      ],
      [
        -586.25537109375,
        -2668.5,
        782.4993286132812
      ],
      [
        -586.0,
        -2641.449951171875,
        787.300048828125
      ],
      [
        -586.0,
        -2641.449951171875,
        787.4649047851562
      ],
      [
        -586.20556640625,
        -2641.449951171875,
        790.0
      ],
      [
        -586.2130737304688,
        -2641.759033203125,
        790.0
      ],
      [
        -585.9189453125,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -585.9188842773438,
        -2642.0,
        786.2999877929688
      ],
      [
        -585.9866333007812,
        -2641.449951171875,
        787.300048828125
      ],
      [
        -586.3074951171875,
        -2668.3076171875,
        783.2000122070312
      ],
      [
        -586.308837890625,
        -2668.35986328125,
        783.2000122070312
      ],
      [
        -586.3074951171875,
        -2668.3076171875,
        783.2000122070312
      ],
      [
        -567.0,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -573.5,
        -2668.2998046875,
        783.2000732421875
      ],
      [
        -573.699951171875,
        -2660.8115234375,
        780.656494140625
      ],
      [
        -573.5,
        -2660.8115234375,
        780.656494140625
      ],
      [
        -573.699951171875,
        -2660.8115234375,
        780.656494140625
      ],
      [
        -573.9043579101562,
        -2664.66650390625,
        779.5
      ],
      [
        -573.5,
        -2660.8115234375,
        780.656494140625
      ],
      [
        -573.5,
        -2664.66650390625,
        779.5000610351562
      ],
      [
        -574.0,
        -2645.37646484375,
        787.2999877929688
      ],
      [
        -567.0,
        -2645.37646484375,
        787.2999877929688
      ],
      [
        -574.0,
        -2645.37646484375,
        787.2999877929688
      ],
      [
        -573.5,
        -2641.759033203125,
        790.0
      ],
      [
        -586.5,
        -2642.0,
        786.2999877929688
      ],
      [
        -586.5,
        -2635.5,
        786.2999877929688
      ],
      [
        -586.5,
        -2635.5,
        787.2999877929688
      ],
      [
        -592.5,
        -2638.66650390625,
        787.2999877929688
      ],
      [
        -586.5,
        -2638.66650390625,
        787.2999877929688
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -766.0,
      "bbox_min": [
        -871.5,
        -2865.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2730.0,
      "bbox_min": [
        -871.5,
        -2857.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7432851195335388,
        0.668974757194519
      ],
      "plane_d": -2540.26513671875,
      "bbox_min": [
        -871.5,
        -2730.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        718.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2702.27197265625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2702.27197265625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2715.0,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        718.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -607.0,
        -2635.000244140625,
        760.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2635.000244140625,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -656.0,
        -2675.0,
        760.0
      ],
      "bbox_max": [
        -567.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -656.0,
        -2675.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2633.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.36830756068229675,
        0.9297040104866028
      ],
      "plane_d": -1689.2196044921875,
      "bbox_min": [
        -586.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.01171875,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -586.0,
      "bbox_min": [
        -586.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.01171875,
        761.0498657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 579.0,
      "bbox_min": [
        -579.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.01171875,
        761.0498657226562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        -586.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.349853515625,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9962174296379089,
        -0.03200415149331093,
        0.08078727126121521
      ],
      "plane_d": -730.5687866210938,
      "bbox_min": [
        -586.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -585.5,
        -2665.349853515625,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.0,
      "bbox_min": [
        -586.0,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -585.5,
        -2666.439453125,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830568313598633,
        0.9297047257423401
      ],
      "plane_d": -1692.655029296875,
      "bbox_min": [
        -585.699951171875,
        -2668.0,
        763.7000122070312
      ],
      "bbox_max": [
        -585.5,
        -2666.439453125,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9962175488471985,
        -0.03200381249189377,
        0.08078594505786896
      ],
      "plane_d": 430.0264892578125,
      "bbox_min": [
        -579.5,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.349853515625,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -579.5,
      "bbox_min": [
        -579.5,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2665.349853515625,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.0,
      "bbox_min": [
        -579.5,
        -2668.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2666.439453125,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830756068229675,
        0.9297040104866028
      ],
      "plane_d": -1692.6595458984375,
      "bbox_min": [
        -579.5,
        -2668.0,
        763.7000122070312
      ],
      "bbox_max": [
        -579.300048828125,
        -2666.439453125,
        764.3182373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -586.0,
      "bbox_min": [
        -610.0,
        -2667.0,
        760.0
      ],
      "bbox_max": [
        -579.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.37346509099006653,
        -0.9276442527770996
      ],
      "plane_d": 1700.33154296875,
      "bbox_min": [
        -586.0,
        -2666.439453125,
        760.0355224609375
      ],
      "bbox_max": [
        -579.0,
        -2650.19677734375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 579.0,
      "bbox_min": [
        -586.0,
        -2666.439453125,
        760.0355224609375
      ],
      "bbox_max": [
        -579.0,
        -2650.19677734375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830756068229675,
        0.9297040104866028
      ],
      "plane_d": -1689.2196044921875,
      "bbox_min": [
        -586.0,
        -2666.439453125,
        761.0498657226562
      ],
      "bbox_max": [
        -579.0,
        -2652.854248046875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        -586.0,
        -2666.439453125,
        761.0498657226562
      ],
      "bbox_max": [
        -579.0,
        -2652.854248046875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9962174296379089,
        -0.03200415149331093,
        0.08078727126121521
      ],
      "plane_d": -730.5687866210938,
      "bbox_min": [
        -586.0,
        -2666.439453125,
        761.0498657226562
      ],
      "bbox_max": [
        -585.5,
        -2652.854248046875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830568313598633,
        0.9297047257423401
      ],
      "plane_d": -1692.655029296875,
      "bbox_min": [
        -585.699951171875,
        -2666.439453125,
        764.3182373046875
      ],
      "bbox_max": [
        -585.5,
        -2662.194091796875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9962175488471985,
        -0.03200381249189377,
        0.08078594505786896
      ],
      "plane_d": 430.0264892578125,
      "bbox_min": [
        -579.5,
        -2666.439453125,
        761.0498657226562
      ],
      "bbox_max": [
        -579.0,
        -2652.854248046875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -579.5,
      "bbox_min": [
        -579.5,
        -2666.439453125,
        761.0498657226562
      ],
      "bbox_max": [
        -579.300048828125,
        -2652.8544921875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830756068229675,
        0.9297040104866028
      ],
      "plane_d": -1692.6595458984375,
      "bbox_min": [
        -579.5,
        -2666.439453125,
        764.3182373046875
      ],
      "bbox_max": [
        -579.300048828125,
        -2662.1943359375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2667.0,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2633.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2662.5,
      "bbox_min": [
        -610.0,
        -2662.5,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2637.5,
      "bbox_min": [
        -610.0,
        -2637.5,
        760.0
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2730.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2633.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -808.0,
        -2633.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -812.0,
        -2698.3701171875,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2698.3701171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2702.27197265625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2702.27197265625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.11181640625,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        760.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2698.3701171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657039642334,
        -0.0
      ],
      "plane_d": -2734.01806640625,
      "bbox_min": [
        -840.5,
        -2725.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.4472135901451111,
        0.0
      ],
      "plane_d": -472.70477294921875,
      "bbox_min": [
        -839.0,
        -2708.53271484375,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2700.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.05712890625,
        765.0
      ],
      "bbox_max": [
        -838.545654296875,
        -2707.51171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -824.0,
        -2708.53271484375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2705.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2708.05712890625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -838.545654296875,
        -2708.11181640625,
        765.0
      ],
      "bbox_max": [
        -838.5,
        -2708.05712890625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2710.89990234375,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2719.10009765625,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2719.10009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -812.4000244140625,
        -2725.0,
        760.0
      ],
      "bbox_max": [
        -808.0,
        -2665.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -812.0,
        -2666.666748046875,
        760.0
      ],
      "bbox_max": [
        -808.0,
        -2665.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -812.4000244140625,
        -2667.0,
        765.0
      ],
      "bbox_max": [
        -808.0,
        -2666.666748046875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.3328201174736023,
        0.9429903626441956
      ],
      "plane_d": 165.30062866210938,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 751.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -744.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -775.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -808.0,
        -2686.800048828125,
        760.0
      ],
      "bbox_max": [
        -806.0,
        -2665.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -751.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -744.0,
        -2665.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -749.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 689.0,
      "bbox_min": [
        -720.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -720.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -713.0,
        -2665.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -718.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 658.0,
      "bbox_min": [
        -689.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2650.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -689.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -682.0,
        -2665.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2688.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -658.0,
        -2686.800048828125,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2665.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2730.0,
        764.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2728.199951171875,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -871.5,
        -2857.0,
        718.0
      ],
      "bbox_max": [
        -640.0,
        -2760.0,
        766.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -814.3270263671875,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        718.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2762.27197265625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        718.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2768.11181640625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        718.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2768.11181640625,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        718.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2775.0,
        760.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -871.5,
        -2857.0,
        760.0
      ],
      "bbox_max": [
        -640.0,
        -2760.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -871.5,
        -2857.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2857.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -871.5,
        -2857.0,
        760.0
      ],
      "bbox_max": [
        -810.0,
        -2762.27197265625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -871.5,
        -2790.0,
        760.0
      ],
      "bbox_max": [
        -812.0,
        -2762.27197265625,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -814.3270263671875,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        760.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2762.27197265625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        760.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 313.389892578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        760.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2768.11181640625,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        760.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2775.0,
        765.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -814.3270263671875,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2762.27197265625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -871.5,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.4472135901451111,
        -0.0
      ],
      "plane_d": 1982.497802734375,
      "bbox_min": [
        -824.0,
        -2790.0,
        765.0
      ],
      "bbox_max": [
        -821.5,
        -2781.46728515625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -824.0,
        -2785.0,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2781.46728515625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2765.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -825.0,
        -2781.46728515625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2765.0,
        766.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2779.10009765625,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        765.0
      ],
      "bbox_max": [
        -824.0,
        -2779.10009765625,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -765.0,
      "bbox_min": [
        -812.0,
        -2789.0,
        765.0
      ],
      "bbox_max": [
        -810.0,
        -2765.0,
        765.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.3328201174736023,
        0.9429903626441956
      ],
      "plane_d": -1661.8818359375,
      "bbox_min": [
        -808.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        -808.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 751.0,
      "bbox_min": [
        -808.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 782.0,
      "bbox_min": [
        -808.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -7.55350774852559e-05,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.257568359375,
      "bbox_min": [
        -808.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -806.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -780.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -749.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -749.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 689.0,
      "bbox_min": [
        -718.0,
        -2840.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -718.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -718.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -715.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2812.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2319.334716796875,
      "bbox_min": [
        -658.0,
        -2804.39990234375,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2761.800048828125,
        764.0001220703125
      ],
      "bbox_max": [
        -656.0,
        -2760.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -760.0,
      "bbox_min": [
        -808.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -656.0,
        -2760.0,
        760.0
      ],
      "bbox_max": [
        -656.0,
        -2730.0,
        766.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805822372436523,
        -0.19610847532749176
      ],
      "plane_d": 2770.138427734375,
      "bbox_min": [
        -871.5,
        -2865.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.9941065907478333,
        -0.10840681195259094
      ],
      "plane_d": 2875.466064453125,
      "bbox_min": [
        -871.5,
        -2865.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        830.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -816.0,
        -2865.0,
        766.0
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.0,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2468.15771484375,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.126953125,
        810.5
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2808.0,
      "bbox_min": [
        -682.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2808.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -682.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.0,
        775.0
      ],
      "bbox_max": [
        -658.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -640.8173828125,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -640.8173828125,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -601.1826171875,
        -2804.1826171875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2435.98291015625,
      "bbox_min": [
        -640.8173828125,
        -2808.0,
        795.0
      ],
      "bbox_max": [
        -637.0,
        -2804.1826171875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -698.0,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -747.5,
        -2804.126953125,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        -0.3713906705379486
      ],
      "plane_d": 1045.4647216796875,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284766912460327,
        0.0,
        0.3713906705379486
      ],
      "plane_d": 469.8092041015625,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": 2956.45068359375,
      "bbox_min": [
        -816.0,
        -2860.0,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2807.01806640625,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -713.0,
        -2823.0,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2807.01806640625,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2855.5,
      "bbox_min": [
        -777.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.0,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 821.5,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -670.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2464.06982421875,
      "bbox_min": [
        -733.0,
        -2863.199951171875,
        821.5
      ],
      "bbox_max": [
        -700.5,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -733.0,
        -2863.199951171875,
        821.5
      ],
      "bbox_max": [
        -731.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -731.0,
        -2855.5,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2859.0,
      "bbox_min": [
        -733.0,
        -2859.0,
        821.5
      ],
      "bbox_max": [
        -731.0,
        -2859.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2865.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -700.5,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2464.06982421875,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -700.5,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -728.500244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.0,
      "bbox_min": [
        -731.0,
        -2865.0,
        810.5
      ],
      "bbox_max": [
        -731.0,
        -2859.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -731.500244140625,
        -2857.0,
        810.5
      ],
      "bbox_max": [
        -728.500244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        -0.00011509368050610647,
        -0.7070779800415039
      ],
      "plane_d": 1095.684326171875,
      "bbox_min": [
        -731.500244140625,
        -2857.0,
        818.5
      ],
      "bbox_max": [
        -728.500244140625,
        -2855.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -777.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2812.0,
        810.5
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2808.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2808.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2808.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2855.5,
        820.0
      ],
      "bbox_max": [
        -728.500244140625,
        -2823.0,
        821.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2597.91015625,
      "bbox_min": [
        -733.0,
        -2854.0,
        820.0
      ],
      "bbox_max": [
        -731.5,
        -2852.5,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        0.0,
        -0.7070779800415039
      ],
      "plane_d": 1096.012939453125,
      "bbox_min": [
        -730.0001220703125,
        -2824.5,
        820.0
      ],
      "bbox_max": [
        -728.500244140625,
        -2823.0,
        821.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2808.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 731.5,
      "bbox_min": [
        -733.0,
        -2855.5,
        810.5
      ],
      "bbox_max": [
        -730.0001220703125,
        -2823.0,
        820.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2597.91015625,
      "bbox_min": [
        -733.0,
        -2855.5,
        818.5
      ],
      "bbox_max": [
        -731.5,
        -2854.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071355581283569,
        0.0,
        -0.7070779800415039
      ],
      "plane_d": 1096.012939453125,
      "bbox_min": [
        -731.5,
        -2824.5,
        818.5
      ],
      "bbox_max": [
        -730.0001220703125,
        -2823.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -705.0,
        -2815.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2808.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -727.5,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.0,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2808.0,
        827.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2808.0,
        827.0
      ],
      "bbox_max": [
        -698.0,
        -2802.001708984375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -727.5,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.3271484375,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -727.5,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.96337890625,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -727.5,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2803.964599609375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.5,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -727.1052856445312,
        -2803.964599609375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.96337890625,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2808.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2803.96337890625,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2435.98291015625,
      "bbox_min": [
        -727.1052856445312,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.3271484375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.1052856445312,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -684.0,
        -2802.3271484375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2808.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2802.3271484375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2808.0,
        820.0
      ],
      "bbox_max": [
        -684.0,
        -2802.3271484375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2808.0,
        820.0
      ],
      "bbox_max": [
        -698.0,
        -2802.328857421875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -727.1052856445312,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -684.0,
        -2803.0908203125,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -698.0,
        -2803.09228515625,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.1052856445312,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -725.0,
        -2803.09228515625,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -605.0,
        -2808.0,
        812.0
      ],
      "bbox_max": [
        -599.3289184570312,
        -2802.328857421875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9941065907478333,
        -0.10840681195259094
      ],
      "plane_d": -2582.17919921875,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        830.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -806.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -777.0,
        -2678.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2687.998291015625,
        827.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -777.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2682.0,
      "bbox_min": [
        -777.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2676.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2676.0,
      "bbox_min": [
        -777.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2676.0,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 826.0,
      "bbox_min": [
        -777.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2676.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2682.0,
        826.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2682.0,
        826.0
      ],
      "bbox_max": [
        -777.0,
        -2678.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2682.0,
        826.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2682.0,
        826.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2682.0,
        826.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 1011.619384765625,
      "bbox_min": [
        -777.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2676.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -777.0,
        -2678.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -698.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2678.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -698.0,
        -2679.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -573.0,
        -2682.0,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2676.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -746.0,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -777.0,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -684.0,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2687.6728515625,
        825.0
      ],
      "bbox_max": [
        -687.0,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 826.0,
      "bbox_min": [
        -605.0,
        -2687.671142578125,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -605.0,
        -2687.671142578125,
        826.0
      ],
      "bbox_max": [
        -599.3289184570312,
        -2682.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -573.0,
        -2687.56201171875,
        825.0
      ],
      "bbox_max": [
        -571.7999877929688,
        -2682.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2659.600341796875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        825.0
      ],
      "bbox_max": [
        -607.0,
        -2659.600341796875,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -806.0,
        -2687.45458984375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2668.199951171875,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -806.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -782.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -751.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -744.0,
        -2687.45458984375,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -744.0,
        -2687.45458984375,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -687.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -687.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -687.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -684.0,
        -2662.89990234375,
        810.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -744.0,
        -2687.453125,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -733.0,
        -2686.90771484375,
        805.0
      ],
      "bbox_max": [
        -715.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -733.0,
        -2686.90771484375,
        810.5
      ],
      "bbox_max": [
        -715.0,
        -2660.0,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -733.0,
        -2686.90771484375,
        810.5
      ],
      "bbox_max": [
        -715.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.393798828125,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -715.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.393798828125,
        -2686.90771484375,
        810.9035034179688
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -733.0,
        -2685.915771484375,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -733.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2675.0,
        820.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -744.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -715.0,
        -2687.453125,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -715.0,
        -2687.453125,
        805.0
      ],
      "bbox_max": [
        -687.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -715.0,
        -2686.90771484375,
        805.0
      ],
      "bbox_max": [
        -698.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -715.0,
        -2686.90771484375,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -715.0,
        -2686.90771484375,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -715.0,
        -2675.0,
        820.0
      ],
      "bbox_max": [
        -698.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -705.0,
        -2686.90771484375,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2675.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -705.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -698.0,
        -2675.0,
        820.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -698.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -698.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2662.89990234375,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -698.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -687.0,
        -2662.89990234375,
        810.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -713.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2675.0,
      "bbox_min": [
        -684.0,
        -2687.453125,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -682.0,
        -2687.453125,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -682.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2675.0,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2675.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2682.98193359375,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2675.0,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -642.4530029296875,
        -2687.453125,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2682.0,
      "bbox_min": [
        -642.4530029296875,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -595.0,
        -2682.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2676.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.5,
      "bbox_min": [
        -585.0,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        820.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        -585.0,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        820.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -573.5,
      "bbox_min": [
        -573.5,
        -2676.0,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        820.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 1011.619384765625,
      "bbox_min": [
        -595.0,
        -2682.0,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -571.7999877929688,
        -2682.0,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -642.4530029296875,
        -2687.453125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -595.0,
        -2686.035400390625,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2686.035400390625,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -595.0,
        -2686.035400390625,
        810.5
      ],
      "bbox_max": [
        -595.0,
        -2682.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -642.4530029296875,
        -2687.453125,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -595.0,
        -2687.452880859375,
        812.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 1011.619384765625,
      "bbox_min": [
        -595.0,
        -2687.452880859375,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -571.7999877929688,
        -2687.452880859375,
        821.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1446.0333251953125,
      "bbox_min": [
        -642.4530029296875,
        -2687.453125,
        812.0
      ],
      "bbox_max": [
        -637.0,
        -2682.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2676.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2675.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -585.0,
        -2676.0,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 585.0,
      "bbox_min": [
        -585.0,
        -2676.0,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -573.5,
      "bbox_min": [
        -573.5,
        -2676.0,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2675.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2682.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 999.3278198242188,
      "bbox_min": [
        -595.0,
        -2682.0,
        805.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 255.43356323242188,
      "bbox_min": [
        -573.0,
        -2682.0,
        805.0
      ],
      "bbox_max": [
        -567.0,
        -2676.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -640.8173828125,
        -2685.8173828125,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -595.0,
        -2685.8173828125,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2685.8173828125,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 999.3278198242188,
      "bbox_min": [
        -595.0,
        -2685.8173828125,
        805.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 255.43356323242188,
      "bbox_min": [
        -573.0,
        -2685.8173828125,
        805.0
      ],
      "bbox_max": [
        -567.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1446.0333251953125,
      "bbox_min": [
        -640.8173828125,
        -2685.8173828125,
        795.0
      ],
      "bbox_max": [
        -637.0,
        -2682.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": 2342.434814453125,
      "bbox_min": [
        -684.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        820.0000610351562
      ],
      "bbox_max": [
        -567.0,
        -2669.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        820.0000610351562
      ],
      "bbox_max": [
        -607.0,
        -2669.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -684.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 15
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 809.5,
      "bbox_min": [
        -682.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2662.900146484375,
        810.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2668.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        809.5
      ],
      "bbox_max": [
        -567.0,
        -2662.900146484375,
        810.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        809.5
      ],
      "bbox_max": [
        -567.0,
        -2668.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2668.0,
        809.5
      ],
      "bbox_max": [
        -607.0,
        -2662.900146484375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        809.5
      ],
      "bbox_max": [
        -567.0,
        -2662.900146484375,
        810.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -19.517065048217773,
      "bbox_min": [
        -574.0,
        -2668.0,
        809.5
      ],
      "bbox_max": [
        -567.0,
        -2662.900146484375,
        810.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        809.5
      ],
      "bbox_max": [
        -574.0,
        -2664.623291015625,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2668.0,
        809.5
      ],
      "bbox_max": [
        -573.5,
        -2662.900146484375,
        810.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -682.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2666.0,
        795.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2668.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        794.0
      ],
      "bbox_max": [
        -567.0,
        -2666.0,
        795.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        794.0
      ],
      "bbox_max": [
        -600.0,
        -2668.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        794.0
      ],
      "bbox_max": [
        -607.0,
        -2668.0,
        795.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        -607.0,
        -2668.0,
        794.0
      ],
      "bbox_max": [
        -593.0,
        -2666.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2873474657535553,
        -0.9578264355659485
      ],
      "plane_d": 1527.1572265625,
      "bbox_min": [
        -600.0,
        -2668.0,
        794.0
      ],
      "bbox_max": [
        -593.0,
        -2666.0849609375,
        794.574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2668.0,
        794.0
      ],
      "bbox_max": [
        -607.0,
        -2666.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -4.6551194190979,
      "bbox_min": [
        -574.0,
        -2668.0,
        794.0
      ],
      "bbox_max": [
        -567.0,
        -2666.0,
        795.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        794.0
      ],
      "bbox_max": [
        -574.0,
        -2666.11181640625,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964426755905151,
        0.023930512368679047,
        0.08080419898033142
      ],
      "plane_d": -572.350830078125,
      "bbox_min": [
        -574.0,
        -2668.0,
        794.4407958984375
      ],
      "bbox_max": [
        -573.5,
        -2666.0,
        795.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2668.0,
        794.4408569335938
      ],
      "bbox_max": [
        -573.5,
        -2666.0,
        795.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -682.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2666.199951171875,
        794.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        -682.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2675.0,
        766.0
      ],
      "bbox_max": [
        -658.0,
        -2668.199951171875,
        784.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -593.0,
      "bbox_min": [
        -593.0,
        -2675.0,
        778.5
      ],
      "bbox_max": [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.6950121941335965e-06,
        -4.6950121941335965e-06,
        1.0
      ],
      "plane_d": -783.2152709960938,
      "bbox_min": [
        -593.0,
        -2675.0,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2666.199951171875,
        794.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.5,
      "bbox_min": [
        -593.0,
        -2675.0,
        779.5
      ],
      "bbox_max": [
        -573.5,
        -2668.35986328125,
        783.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -586.5,
      "bbox_min": [
        -592.7567749023438,
        -2668.5,
        782.4993286132812
      ],
      "bbox_max": [
        -573.5,
        -2668.35986328125,
        783.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2668.5,
        782.4993896484375
      ],
      "bbox_max": [
        -573.5,
        -2668.35986328125,
        783.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -654.065673828125,
      "bbox_min": [
        -592.7567749023438,
        -2668.5,
        782.4995727539062
      ],
      "bbox_max": [
        -592.5,
        -2668.35986328125,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 592.5,
      "bbox_min": [
        -592.5,
        -2675.0,
        779.5
      ],
      "bbox_max": [
        -592.5,
        -2668.5,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 3.7013893127441406,
      "bbox_min": [
        -574.0,
        -2668.0,
        793.4967041015625
      ],
      "bbox_max": [
        -567.0,
        -2666.199951171875,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        793.4967041015625
      ],
      "bbox_max": [
        -574.0,
        -2666.199951171875,
        794.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2663.10009765625,
        809.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -798.7000732421875,
      "bbox_min": [
        -600.0,
        -2668.5,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2663.10009765625,
        809.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.9967281222343445,
        0.08082734793424606
      ],
      "plane_d": 2595.012939453125,
      "bbox_min": [
        -600.0,
        -2668.5,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -600.0,
        -2668.5,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2668.0,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.5,
        -2668.5,
        795.0
      ],
      "bbox_max": [
        -599.5,
        -2668.0,
        798.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -600.0,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2665.413330078125,
        798.7000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -8.207984924316406,
      "bbox_min": [
        -573.699951171875,
        -2668.0,
        797.9340209960938
      ],
      "bbox_max": [
        -573.5,
        -2665.413330078125,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9964353442192078,
        -0.02424079179763794,
        0.08080200850963593
      ],
      "plane_d": 461.97412109375,
      "bbox_min": [
        -593.300048828125,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -593.0,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 593.0,
      "bbox_min": [
        -593.0,
        -2668.0,
        795.0
      ],
      "bbox_max": [
        -593.0,
        -2665.872314453125,
        795.6383056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967281222343445,
        -0.0,
        0.08082734793424606
      ],
      "plane_d": 526.8020629882812,
      "bbox_min": [
        -593.300048828125,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -593.0,
        -2668.0,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.743514965521172e-06,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1528.120849609375,
      "bbox_min": [
        -600.0,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -593.5,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        -600.0,
        -2668.0,
        795.0
      ],
      "bbox_max": [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -726.7771606445312,
      "bbox_min": [
        -600.0,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -599.5,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.5,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -599.5,
        -2665.260009765625,
        798.7000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -662.2955932617188,
      "bbox_min": [
        -600.0,
        -2668.300048828125,
        795.0
      ],
      "bbox_max": [
        -599.699951171875,
        -2668.0,
        798.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        808.1300048828125
      ],
      "bbox_max": [
        -574.0,
        -2663.185302734375,
        809.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2664.623291015625,
        809.0741577148438
      ],
      "bbox_max": [
        -573.5,
        -2663.10009765625,
        809.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9964353442192078,
        -0.02424079179763794,
        0.08080200850963593
      ],
      "plane_d": 461.97412109375,
      "bbox_min": [
        -593.300048828125,
        -2668.0,
        798.7000732421875
      ],
      "bbox_max": [
        -593.2333984375,
        -2665.085205078125,
        799.5745239257812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1531.6590576171875,
      "bbox_min": [
        -599.7666015625,
        -2668.0,
        798.7000122070312
      ],
      "bbox_max": [
        -599.5,
        -2665.085205078125,
        799.574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -726.7771606445312,
      "bbox_min": [
        -599.7666015625,
        -2668.0,
        798.7000122070312
      ],
      "bbox_max": [
        -599.5,
        -2665.085205078125,
        799.574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.5,
        -2668.0,
        798.7000122070312
      ],
      "bbox_max": [
        -599.5,
        -2665.085205078125,
        799.574462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -662.2955932617188,
      "bbox_min": [
        -600.0,
        -2675.0,
        795.0
      ],
      "bbox_max": [
        -599.5,
        -2668.5,
        798.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.699951171875,
        -2675.0,
        795.0
      ],
      "bbox_max": [
        -599.5,
        -2668.5,
        798.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -798.7000122070312,
      "bbox_min": [
        -599.699951171875,
        -2675.0,
        798.7000122070312
      ],
      "bbox_max": [
        -599.5,
        -2668.5,
        798.7000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.2000732421875,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.5,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2662.16015625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9967281222343445,
        0.08082734793424606
      ],
      "plane_d": 2593.760009765625,
      "bbox_min": [
        -610.0,
        -2668.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2662.16015625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -600.5,
      "bbox_min": [
        -610.0,
        -2668.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2667.999755859375,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -573.5,
        -2668.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2667.999755859375,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2668.5,
        810.5000610351562
      ],
      "bbox_max": [
        -573.5,
        -2668.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2668.5,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2667.999755859375,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2668.5,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2667.999755859375,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": 532.5263061523438,
      "bbox_min": [
        -610.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2662.16015625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -600.5,
      "bbox_min": [
        -610.0,
        -2668.2998046875,
        810.5
      ],
      "bbox_max": [
        -600.5,
        -2662.16015625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2668.2998046875,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2662.585693359375,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2668.2998046875,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2662.585693359375,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2665.0,
      "bbox_min": [
        -610.0,
        -2665.0,
        813.0
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2662.16015625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2662.486572265625,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.2839656174182892,
        0.9588344693183899
      ],
      "plane_d": -23.062828063964844,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2662.486572265625,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -637.6325073242188,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        810.5
      ],
      "bbox_max": [
        -573.699951171875,
        -2668.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2668.5,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2670.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2670.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2670.0,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        810.5
      ],
      "bbox_max": [
        -670.0,
        -2670.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2668.5,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2668.5,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2670.0,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2668.5,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -567.0,
        -2660.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 650.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2670.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        -670.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -670.0,
        -2670.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2670.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2675.0,
        814.2000732421875
      ],
      "bbox_max": [
        -610.0,
        -2670.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2665.0,
      "bbox_min": [
        -610.0,
        -2665.0,
        814.2000732421875
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2675.0,
        815.0
      ],
      "bbox_max": [
        -607.0,
        -2660.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2675.0,
        815.0
      ],
      "bbox_max": [
        -607.0,
        -2660.000244140625,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.4190581738948822,
        -0.9079594016075134
      ],
      "plane_d": 1858.5928955078125,
      "bbox_min": [
        -610.0,
        -2665.0,
        815.0
      ],
      "bbox_max": [
        -607.0,
        -2661.25439453125,
        818.728759765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2665.0,
      "bbox_min": [
        -610.0,
        -2665.0,
        815.0
      ],
      "bbox_max": [
        -607.0,
        -2665.0,
        817.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -656.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2684.181396484375,
        827.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1488.459716796875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1535.1287841796875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2393.556396484375,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2413.35546875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2788.0,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 631.0,
      "bbox_min": [
        -631.0,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2768.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2768.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1635.751220703125,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2263.564453125,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2780.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -623.434326171875,
        -2780.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2771.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.577880859375,
        -2780.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2775.36474609375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1468.6607666015625,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2346.887451171875,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2366.686279296875,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2722.0,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 631.0,
      "bbox_min": [
        -631.0,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2702.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -611.0,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1589.610595703125,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2217.334716796875,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.434326171875,
        -2714.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2705.505859375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.577880859375,
        -2714.434326171875,
        810.0
      ],
      "bbox_max": [
        -614.505859375,
        -2709.36474609375,
        810.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2684.181396484375,
        810.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2684.181640625,
        810.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 803.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        803.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2704.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2760.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        -597.0,
        -2760.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2760.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.0,
      "bbox_min": [
        -597.0,
        -2694.0,
        795.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        803.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2742.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2684.181640625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2370.928955078125,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -656.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2435.98291015625,
      "bbox_min": [
        -645.0,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -602.8184204101562,
        -2805.818359375,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1492.702392578125,
      "bbox_min": [
        -645.0,
        -2756.0,
        795.0
      ],
      "bbox_max": [
        -637.0,
        -2748.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2756.0,
        810.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2756.0,
        810.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1857.5523681640625,
      "bbox_min": [
        -646.5,
        -2788.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1875.025390625,
      "bbox_min": [
        -646.5,
        -2788.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2765.3193359375,
      "bbox_min": [
        -646.5,
        -2788.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2747.84619140625,
      "bbox_min": [
        -646.5,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -656.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        798.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -484.4078674316406,
      "bbox_min": [
        -656.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -656.0,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2791.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2791.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -865.0101318359375,
      "bbox_min": [
        -656.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.5003051757812,
        -2795.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2760.5,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2767.5,
      "bbox_min": [
        -651.0,
        -2767.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2767.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -655.5003051757812,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -656.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.5499877929688,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        810.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.40039318799972534,
        -0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": -1528.274169921875,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40039318799972534,
        0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": 696.3103637695312,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40039318799972534,
        -0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": -2025.5625,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40039318799972534,
        0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": 199.0220184326172,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1865.6982421875,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": 237.6070556640625,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9154629111289978,
        0.4024023413658142
      ],
      "plane_d": 2212.260498046875,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20672766864299774,
        -0.9089968204498291,
        0.36192330718040466
      ],
      "plane_d": -2694.4541015625,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2766.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9089968204498291,
        -0.20672766864299774,
        0.36192330718040466
      ],
      "plane_d": -1436.415283203125,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2766.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1061.7841796875,
      "bbox_min": [
        -633.984375,
        -2768.99853515625,
        795.0
      ],
      "bbox_max": [
        -630.9855346679688,
        -2766.0,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": -899.3978881835938,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2773.171630859375,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -2534.468505859375,
      "bbox_min": [
        -633.0,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2787.985595703125,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9090052843093872,
        0.2066630721092224,
        0.36193883419036865
      ],
      "plane_d": -288.0338439941406,
      "bbox_min": [
        -633.984375,
        -2788.14111328125,
        795.0
      ],
      "bbox_max": [
        -631.0,
        -2782.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -2534.468505859375,
      "bbox_min": [
        -633.984375,
        -2788.14111328125,
        795.0
      ],
      "bbox_max": [
        -632.6251220703125,
        -2787.00146484375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        0.4024023413658142
      ],
      "plane_d": -2874.05126953125,
      "bbox_min": [
        -625.828369140625,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2787.985595703125,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1730.5545654296875,
      "bbox_min": [
        -611.0142211914062,
        -2789.999755859375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2787.985595703125,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2066630721092224,
        -0.9090052843093872,
        0.36193883419036865
      ],
      "plane_d": -2951.2060546875,
      "bbox_min": [
        -617.0,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -610.8587036132812,
        -2788.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1730.5545654296875,
      "bbox_min": [
        -611.99853515625,
        -2790.984375,
        795.0
      ],
      "bbox_max": [
        -610.8587036132812,
        -2789.624755859375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2066630721092224,
        0.9090052843093872,
        0.36193883419036865
      ],
      "plane_d": 2355.90283203125,
      "bbox_min": [
        -631.14111328125,
        -2768.0,
        795.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1061.7841796875,
      "bbox_min": [
        -631.14111328125,
        -2766.375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2765.015625,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20672766864299774,
        0.9089968204498291,
        0.36192330718040466
      ],
      "plane_d": 2099.176513671875,
      "bbox_min": [
        -617.0,
        -2768.0,
        795.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2765.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089968204498291,
        0.20672766864299774,
        0.36192330718040466
      ],
      "plane_d": 841.1376342773438,
      "bbox_min": [
        -611.0,
        -2788.14111328125,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2768.84326171875,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1730.5545654296875,
      "bbox_min": [
        -609.3748779296875,
        -2788.14111328125,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2787.00146484375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9090052843093872,
        -0.2066630721092224,
        0.36193883419036865
      ],
      "plane_d": -307.2693176269531,
      "bbox_min": [
        -611.0,
        -2774.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2768.84326171875,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -629.0,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1635.751220703125,
      "bbox_min": [
        -629.0,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -629.0,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2263.564453125,
      "bbox_min": [
        -629.0,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -629.0,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -624.171630859375,
        -2786.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -624.171630859375,
        -2781.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -624.171630859375,
        -2771.505859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2770.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1511.087158203125,
      "bbox_min": [
        -656.0,
        -2742.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2684.181640625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -656.0,
        -2742.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2684.181640625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -645.0,
        -2690.0,
        795.0
      ],
      "bbox_max": [
        -597.0,
        -2684.181640625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1446.0333251953125,
      "bbox_min": [
        -645.0,
        -2690.0,
        795.0
      ],
      "bbox_max": [
        -639.1815795898438,
        -2684.181640625,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -656.0,
        -2742.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2389.313720703125,
      "bbox_min": [
        -645.0,
        -2742.0,
        795.0
      ],
      "bbox_max": [
        -637.0,
        -2734.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2690.0,
        810.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2734.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        810.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1802.6370849609375,
      "bbox_min": [
        -646.5,
        -2722.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1820.110107421875,
      "bbox_min": [
        -646.5,
        -2722.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2710.40380859375,
      "bbox_min": [
        -646.5,
        -2722.5,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        806.25
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2692.930908203125,
      "bbox_min": [
        -646.5,
        -2704.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        802.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        795.0
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        798.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -656.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        798.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -491.69635009765625,
      "bbox_min": [
        -656.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -656.0,
        -2729.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2725.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2729.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2725.0,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -865.0101318359375,
      "bbox_min": [
        -656.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.5003051757812,
        -2729.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2694.5,
        798.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2701.5,
      "bbox_min": [
        -651.0,
        -2701.5,
        797.5
      ],
      "bbox_max": [
        -646.5,
        -2701.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -655.5003051757812,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -656.0,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        798.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.5499877929688,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        810.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.40039318799972534,
        -0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": -1501.8482666015625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.40039318799972534,
        0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": 669.8843994140625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40039318799972534,
        -0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": -1999.1365966796875,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.40039318799972534,
        0.40039318799972534,
        0.8242393732070923
      ],
      "plane_d": 172.5960693359375,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1822.9781494140625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": 237.6070556640625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9154629111289978,
        0.4024023413658142
      ],
      "plane_d": 2151.840087890625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20672766864299774,
        -0.9089968204498291,
        0.36192330718040466
      ],
      "plane_d": -2634.46044921875,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2700.000244140625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9089968204498291,
        -0.20672766864299774,
        0.36192330718040466
      ],
      "plane_d": -1422.771240234375,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2700.000244140625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1019.0641479492188,
      "bbox_min": [
        -633.984375,
        -2702.99853515625,
        795.0
      ],
      "bbox_max": [
        -630.9857788085938,
        -2700.000244140625,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        0.0,
        0.4024023413658142
      ],
      "plane_d": -899.3978881835938,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2707.171630859375,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -2491.74853515625,
      "bbox_min": [
        -633.0,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2721.985595703125,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9090052843093872,
        0.2066630721092224,
        0.36193883419036865
      ],
      "plane_d": -301.6736145019531,
      "bbox_min": [
        -633.984375,
        -2722.14111328125,
        795.0
      ],
      "bbox_max": [
        -631.0,
        -2716.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -2491.74853515625,
      "bbox_min": [
        -633.984375,
        -2722.14111328125,
        795.0
      ],
      "bbox_max": [
        -632.6251220703125,
        -2721.00146484375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        0.4024023413658142
      ],
      "plane_d": -2813.630859375,
      "bbox_min": [
        -625.828369140625,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2721.985595703125,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1687.83447265625,
      "bbox_min": [
        -611.0143432617188,
        -2724.0,
        795.0
      ],
      "bbox_max": [
        -609.0,
        -2721.985595703125,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2066630721092224,
        -0.9090052843093872,
        0.36193883419036865
      ],
      "plane_d": -2891.211669921875,
      "bbox_min": [
        -617.0,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -610.85888671875,
        -2722.0,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1687.83447265625,
      "bbox_min": [
        -611.99853515625,
        -2724.984375,
        795.0
      ],
      "bbox_max": [
        -610.85888671875,
        -2723.625,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2066630721092224,
        0.9090052843093872,
        0.36193883419036865
      ],
      "plane_d": 2295.908447265625,
      "bbox_min": [
        -631.1412963867188,
        -2702.0,
        795.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6472737193107605,
        0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": 1019.0641479492188,
      "bbox_min": [
        -631.1412963867188,
        -2700.375244140625,
        795.0
      ],
      "bbox_max": [
        -630.00146484375,
        -2699.015625,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20672766864299774,
        0.9089968204498291,
        0.36192330718040466
      ],
      "plane_d": 2039.1826171875,
      "bbox_min": [
        -617.0,
        -2702.0,
        795.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2699.015625,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9089968204498291,
        0.20672766864299774,
        0.36192330718040466
      ],
      "plane_d": 827.49365234375,
      "bbox_min": [
        -611.0,
        -2722.14111328125,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2702.84326171875,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6472737193107605,
        -0.6472737193107605,
        0.40258342027664185
      ],
      "plane_d": -1687.83447265625,
      "bbox_min": [
        -609.3748779296875,
        -2722.14111328125,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2721.00146484375,
        795.8529663085938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9090052843093872,
        -0.2066630721092224,
        0.36193883419036865
      ],
      "plane_d": -293.6295471191406,
      "bbox_min": [
        -611.0,
        -2708.0,
        795.0
      ],
      "bbox_max": [
        -608.015625,
        -2702.84326171875,
        799.5499877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1589.610595703125,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2217.334716796875,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -629.0,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -624.171630859375,
        -2715.171630859375,
        799.5499877929688
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -624.171630859375,
        -2705.505859375,
        799.5499877929688
      ],
      "bbox_max": [
        -617.828369140625,
        -2704.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2684.181396484375,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 999.3278198242188,
      "bbox_min": [
        -595.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.272216796875,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 255.43356323242188,
      "bbox_min": [
        -595.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2685.272216796875,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2772.0,
      "bbox_min": [
        -595.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -798.25,
      "bbox_min": [
        -578.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -572.5,
      "bbox_min": [
        -578.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        798.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2747.0,
      "bbox_min": [
        -572.5,
        -2767.5,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2747.0,
        798.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2767.5,
      "bbox_min": [
        -572.5,
        -2767.5,
        795.0
      ],
      "bbox_max": [
        -567.0,
        -2767.5,
        798.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2767.5,
      "bbox_min": [
        -578.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -572.5,
        -2767.5,
        798.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -578.0,
      "bbox_min": [
        -578.0,
        -2772.0,
        795.0
      ],
      "bbox_max": [
        -578.0,
        -2767.5,
        798.25
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -799.0,
      "bbox_min": [
        -578.0,
        -2772.0,
        798.25
      ],
      "bbox_max": [
        -567.0,
        -2767.5,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2767.5,
      "bbox_min": [
        -578.0,
        -2772.0,
        798.25
      ],
      "bbox_max": [
        -567.0,
        -2767.5,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -578.0,
      "bbox_min": [
        -578.0,
        -2772.0,
        798.25
      ],
      "bbox_max": [
        -578.0,
        -2767.5,
        799.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 826.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        827.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -656.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2742.0,
      "bbox_min": [
        -656.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.0,
      "bbox_min": [
        -656.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2756.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2756.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -646.5,
        -2800.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2756.0,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2370.928955078125,
      "bbox_min": [
        -645.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1492.702392578125,
      "bbox_min": [
        -645.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        -0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": -1796.5113525390625,
      "bbox_min": [
        -645.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6329130530357361,
        -0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": -1010.433349609375,
      "bbox_min": [
        -633.984375,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 2506.031494140625,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 1719.95361328125,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -719.30712890625,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": -2221.354736328125,
      "bbox_min": [
        -633.984375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        -0.0,
        -0.4024023413658142
      ],
      "plane_d": -246.7012939453125,
      "bbox_min": [
        -633.984375,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 2051.924560546875,
      "bbox_min": [
        -632.6690063476562,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": 2864.95703125,
      "bbox_min": [
        -632.6690063476562,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        -0.4024023413658142
      ],
      "plane_d": 890.3036499023438,
      "bbox_min": [
        -632.6690063476562,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2766.3310546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1545.618408203125,
      "bbox_min": [
        -632.6690063476562,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -609.3309936523438,
        -2766.3310546875,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -213.0009002685547,
      "bbox_min": [
        -611.4447021484375,
        -2789.668701171875,
        826.0
      ],
      "bbox_max": [
        -609.3309936523438,
        -2787.554931640625,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.892458438873291,
        -0.20296645164489746,
        -0.40289273858070374
      ],
      "plane_d": 313.83868408203125,
      "bbox_min": [
        -609.4395751953125,
        -2787.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2768.84326171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 1407.530029296875,
      "bbox_min": [
        -609.4395751953125,
        -2787.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2768.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -213.0009002685547,
      "bbox_min": [
        -609.4395141601562,
        -2787.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.390869140625,
        -2786.676025390625,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.892458438873291,
        0.20296648144721985,
        -0.40289273858070374
      ],
      "plane_d": 1441.5203857421875,
      "bbox_min": [
        -609.4395751953125,
        -2787.15673828125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2768.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 304.6900939941406,
      "bbox_min": [
        -609.4395751953125,
        -2773.353759765625,
        826.0
      ],
      "bbox_max": [
        -608.390869140625,
        -2768.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20296648144721985,
        0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": 2676.670166015625,
      "bbox_min": [
        -630.9415893554688,
        -2766.439453125,
        826.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2942.349853515625,
      "bbox_min": [
        -630.9415893554688,
        -2766.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1545.618408203125,
      "bbox_min": [
        -630.9415893554688,
        -2766.439453125,
        826.0
      ],
      "bbox_max": [
        -629.6760864257812,
        -2765.390869140625,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20296645164489746,
        0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": 2928.75439453125,
      "bbox_min": [
        -630.15673828125,
        -2766.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2765.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2695.818603515625,
      "bbox_min": [
        -616.3536987304688,
        -2766.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2765.390869140625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        0.20296645164489746,
        -0.40289273858070374
      ],
      "plane_d": 333.0869140625,
      "bbox_min": [
        -633.984375,
        -2787.15673828125,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2768.058349609375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": -825.58984375,
      "bbox_min": [
        -633.984375,
        -2787.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2768.058349609375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1545.618408203125,
      "bbox_min": [
        -633.609130859375,
        -2769.323974609375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2768.058349609375,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        -0.20296648144721985,
        -0.40289273858070374
      ],
      "plane_d": -794.5947875976562,
      "bbox_min": [
        -633.984375,
        -2787.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2768.84326171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 277.2501525878906,
      "bbox_min": [
        -633.609130859375,
        -2787.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2782.646240234375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20296648144721985,
        -0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": -2029.7445068359375,
      "bbox_min": [
        -630.15673828125,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -611.0582275390625,
        -2789.560302734375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2360.409423828125,
      "bbox_min": [
        -630.00146484375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -611.0582275390625,
        -2789.560302734375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -213.0009002685547,
      "bbox_min": [
        -612.3239135742188,
        -2790.609130859375,
        826.0
      ],
      "bbox_max": [
        -611.0582275390625,
        -2789.560302734375,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20296645164489746,
        -0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": -2281.828857421875,
      "bbox_min": [
        -630.00146484375,
        -2790.984375,
        826.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2789.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2113.87841796875,
      "bbox_min": [
        -630.00146484375,
        -2790.609130859375,
        826.0
      ],
      "bbox_max": [
        -625.6463012695312,
        -2789.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -599.43798828125,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2435.98291015625,
      "bbox_min": [
        -645.0,
        -2802.43798828125,
        826.0
      ],
      "bbox_max": [
        -642.56201171875,
        -2800.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2742.0,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -646.5,
        -2734.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        827.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        826.0
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2389.313720703125,
      "bbox_min": [
        -645.0,
        -2742.0,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1511.087158203125,
      "bbox_min": [
        -645.0,
        -2742.0,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 2464.25927734375,
      "bbox_min": [
        -645.0,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": 1678.1812744140625,
      "bbox_min": [
        -645.0,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6329130530357361,
        -0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": -968.6610717773438,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6329130530357361,
        -0.6329130530357361,
        -0.44591718912124634
      ],
      "plane_d": -1754.7391357421875,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -692.4019775390625,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": -2160.934326171875,
      "bbox_min": [
        -633.984375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        -0.0,
        -0.4024023413658142
      ],
      "plane_d": -246.7012939453125,
      "bbox_min": [
        -633.984375,
        -2723.669189453125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 2025.01953125,
      "bbox_min": [
        -632.6690063476562,
        -2723.669189453125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": 2804.53662109375,
      "bbox_min": [
        -632.6690063476562,
        -2723.669189453125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        -0.4024023413658142
      ],
      "plane_d": 890.3036499023438,
      "bbox_min": [
        -632.6690063476562,
        -2723.669189453125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2700.3310546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -186.09573364257812,
      "bbox_min": [
        -632.6690063476562,
        -2723.669189453125,
        826.0
      ],
      "bbox_max": [
        -609.3309936523438,
        -2700.3310546875,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1518.7132568359375,
      "bbox_min": [
        -632.6690063476562,
        -2702.445068359375,
        826.0
      ],
      "bbox_max": [
        -630.5550537109375,
        -2700.3310546875,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.892458438873291,
        -0.20296645164489746,
        -0.40289273858070374
      ],
      "plane_d": 327.2344665527344,
      "bbox_min": [
        -609.4395751953125,
        -2721.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2702.84326171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 1394.4293212890625,
      "bbox_min": [
        -609.4395751953125,
        -2721.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2702.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -186.09573364257812,
      "bbox_min": [
        -609.4395141601562,
        -2721.941650390625,
        826.0
      ],
      "bbox_max": [
        -608.390869140625,
        -2720.676025390625,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.892458438873291,
        0.20296648144721985,
        -0.40289273858070374
      ],
      "plane_d": 1428.1246337890625,
      "bbox_min": [
        -609.4395751953125,
        -2721.15673828125,
        826.0
      ],
      "bbox_max": [
        -608.015625,
        -2702.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 317.7908020019531,
      "bbox_min": [
        -609.4395751953125,
        -2707.353759765625,
        826.0
      ],
      "bbox_max": [
        -608.390869140625,
        -2702.99853515625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20296648144721985,
        0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": 2617.767822265625,
      "bbox_min": [
        -630.9417724609375,
        -2700.439453125,
        826.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2882.28662109375,
      "bbox_min": [
        -630.9417724609375,
        -2700.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1518.7132568359375,
      "bbox_min": [
        -630.9417724609375,
        -2700.439453125,
        826.0
      ],
      "bbox_max": [
        -629.6760864257812,
        -2699.390869140625,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20296645164489746,
        0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": 2869.852294921875,
      "bbox_min": [
        -630.15673828125,
        -2700.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2699.015625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2635.75537109375,
      "bbox_min": [
        -616.3536987304688,
        -2700.439453125,
        826.0
      ],
      "bbox_max": [
        -611.99853515625,
        -2699.390869140625,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        0.20296645164489746,
        -0.40289273858070374
      ],
      "plane_d": 319.6911315917969,
      "bbox_min": [
        -633.984375,
        -2721.15673828125,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2702.058349609375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": -812.4891357421875,
      "bbox_min": [
        -633.984375,
        -2721.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2702.058349609375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1518.7132568359375,
      "bbox_min": [
        -633.609130859375,
        -2703.323974609375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2702.058349609375,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.892458438873291,
        -0.20296648144721985,
        -0.40289273858070374
      ],
      "plane_d": -781.198974609375,
      "bbox_min": [
        -633.984375,
        -2721.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2702.84326171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 264.1494445800781,
      "bbox_min": [
        -633.609130859375,
        -2721.00146484375,
        826.0
      ],
      "bbox_max": [
        -632.5604248046875,
        -2716.646240234375,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.20296648144721985,
        -0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": -1970.84228515625,
      "bbox_min": [
        -630.15673828125,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -611.0584716796875,
        -2723.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2300.34619140625,
      "bbox_min": [
        -630.00146484375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -611.0584716796875,
        -2723.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -186.09573364257812,
      "bbox_min": [
        -612.3239135742188,
        -2724.609130859375,
        826.0
      ],
      "bbox_max": [
        -611.0584716796875,
        -2723.560546875,
        826.2470092773438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.20296645164489746,
        -0.892458438873291,
        -0.40289273858070374
      ],
      "plane_d": -2222.9267578125,
      "bbox_min": [
        -630.00146484375,
        -2724.984375,
        826.0
      ],
      "bbox_max": [
        -611.84326171875,
        -2723.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2053.815185546875,
      "bbox_min": [
        -630.00146484375,
        -2724.609130859375,
        826.0
      ],
      "bbox_max": [
        -625.6463012695312,
        -2723.560546875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1446.0333251953125,
      "bbox_min": [
        -645.0,
        -2690.0,
        826.0
      ],
      "bbox_max": [
        -642.56201171875,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2324.260009765625,
      "bbox_min": [
        -599.43798828125,
        -2690.0,
        826.0
      ],
      "bbox_max": [
        -597.0,
        -2687.56201171875,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 595.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        826.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        810.5
      ],
      "bbox_max": [
        -595.0,
        -2686.035400390625,
        826.0
      ],
      "face_count": 20
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1488.459716796875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1535.1287841796875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1515.329833984375,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2393.556396484375,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2413.35546875,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2788.0,
      "bbox_min": [
        -631.0,
        -2788.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 631.0,
      "bbox_min": [
        -631.0,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2768.0,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2768.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2244.845458984375,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2616.994140625,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        -0.1500629037618637
      ],
      "plane_d": -1392.3492431640625,
      "bbox_min": [
        -627.293212890625,
        -2784.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -627.293212890625,
        -2780.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1623.5675048828125,
      "bbox_min": [
        -627.293212890625,
        -2780.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -623.434326171875,
        -2780.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        -0.13688138127326965
      ],
      "plane_d": 2485.586181640625,
      "bbox_min": [
        -618.416015625,
        -2780.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2771.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        0.0,
        -0.14262303709983826
      ],
      "plane_d": 724.03369140625,
      "bbox_min": [
        -614.64990234375,
        -2780.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2775.36474609375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2780.36376953125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2775.416015625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2263.564453125,
      "bbox_min": [
        -618.416015625,
        -2775.5859375,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2771.64990234375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2775.5859375,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2775.390380859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -623.36376953125,
        -2771.721923828125,
        810.5
      ],
      "bbox_max": [
        -618.246337890625,
        -2771.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2263.564453125,
      "bbox_min": [
        -618.416015625,
        -2771.721923828125,
        810.5
      ],
      "bbox_max": [
        -618.246337890625,
        -2771.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -627.1298828125,
        -2775.416015625,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2771.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2627.648193359375,
      "bbox_min": [
        -623.3990478515625,
        -2771.64990234375,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2771.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.2115478515625,
        -2780.36376953125,
        810.5
      ],
      "bbox_max": [
        -627.0482177734375,
        -2775.22705078125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1380.16552734375,
      "bbox_min": [
        -627.2115478515625,
        -2775.416015625,
        810.5
      ],
      "bbox_max": [
        -627.0482177734375,
        -2775.22705078125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1635.751220703125,
      "bbox_min": [
        -618.416015625,
        -2784.1298828125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2780.184326171875,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2780.39892578125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2780.184326171875,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -623.36376953125,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.2273559570312,
        -2784.04833984375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1635.751220703125,
      "bbox_min": [
        -618.416015625,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.2273559570312,
        -2784.04833984375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2509.4990234375,
      "bbox_min": [
        -627.2115478515625,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2780.1650390625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.2115478515625,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2780.1650390625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2878.44921875,
      "bbox_min": [
        -623.3990478515625,
        -2784.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2784.1298828125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1468.6607666015625,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": -2346.887451171875,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2366.686279296875,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2722.0,
      "bbox_min": [
        -631.0,
        -2722.0,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 631.0,
      "bbox_min": [
        -631.0,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2702.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2702.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -611.0,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -611.0,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2198.8017578125,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2551.857177734375,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        -0.1500629037618637
      ],
      "plane_d": -1346.2086181640625,
      "bbox_min": [
        -627.293212890625,
        -2718.293212890625,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1577.4268798828125,
      "bbox_min": [
        -627.293212890625,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2793.657470703125,
      "bbox_min": [
        -623.434326171875,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        -0.13688138127326965
      ],
      "plane_d": 2439.3564453125,
      "bbox_min": [
        -618.416015625,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2705.505859375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        0.0,
        -0.14262303709983826
      ],
      "plane_d": 724.03369140625,
      "bbox_min": [
        -614.64990234375,
        -2714.434326171875,
        810.5
      ],
      "bbox_max": [
        -614.5057983398438,
        -2709.36474609375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2714.36376953125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2709.416015625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2217.334716796875,
      "bbox_min": [
        -618.416015625,
        -2709.5859375,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2705.64990234375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2709.5859375,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2709.390380859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.36376953125,
        -2705.721923828125,
        810.5
      ],
      "bbox_max": [
        -618.246337890625,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        0.13688138127326965
      ],
      "plane_d": 2217.334716796875,
      "bbox_min": [
        -618.416015625,
        -2705.721923828125,
        810.5
      ],
      "bbox_max": [
        -618.246337890625,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -627.1298828125,
        -2709.416015625,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        0.14262303709983826
      ],
      "plane_d": 2562.322998046875,
      "bbox_min": [
        -623.3990478515625,
        -2705.64990234375,
        810.5
      ],
      "bbox_max": [
        -623.1844482421875,
        -2705.577880859375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.2115478515625,
        -2714.36376953125,
        810.5
      ],
      "bbox_max": [
        -627.0482177734375,
        -2709.22705078125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        0.1500629037618637
      ],
      "plane_d": 1334.02490234375,
      "bbox_min": [
        -627.2115478515625,
        -2709.416015625,
        810.5
      ],
      "bbox_max": [
        -627.0482177734375,
        -2709.22705078125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1589.610595703125,
      "bbox_min": [
        -618.416015625,
        -2718.1298828125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2714.184326171875,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        -0.0,
        0.14262303709983826
      ],
      "plane_d": 492.6990966796875,
      "bbox_min": [
        -614.64990234375,
        -2714.39892578125,
        810.5
      ],
      "bbox_max": [
        -614.577880859375,
        -2714.184326171875,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -623.36376953125,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.2273559570312,
        -2718.04833984375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        0.1500629186630249
      ],
      "plane_d": -1589.610595703125,
      "bbox_min": [
        -618.416015625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -618.2273559570312,
        -2718.04833984375,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        0.1631648987531662
      ],
      "plane_d": -2463.455322265625,
      "bbox_min": [
        -627.2115478515625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2714.1650390625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        0.16119296848773956
      ],
      "plane_d": -749.6563720703125,
      "bbox_min": [
        -627.2115478515625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2714.1650390625,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9869229197502136,
        0.16119298338890076
      ],
      "plane_d": -2813.312255859375,
      "bbox_min": [
        -623.3990478515625,
        -2718.21142578125,
        810.5
      ],
      "bbox_max": [
        -623.165283203125,
        -2718.1298828125,
        811.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2742.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2686.035400390625,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2748.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2748.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2748.0,
        826.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2760.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2770.0,
      "bbox_min": [
        -597.0,
        -2770.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2760.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.0,
      "bbox_min": [
        -597.0,
        -2760.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2760.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -2370.928955078125,
      "bbox_min": [
        -656.0,
        -2803.964599609375,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2748.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1557.7562255859375,
      "bbox_min": [
        -600.9645385742188,
        -2803.964599609375,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2800.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2748.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1492.702392578125,
      "bbox_min": [
        -645.0,
        -2756.0,
        812.0
      ],
      "bbox_max": [
        -637.0,
        -2748.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2756.0,
        826.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2756.0,
        826.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1848.1224365234375,
      "bbox_min": [
        -646.5,
        -2788.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1865.595458984375,
      "bbox_min": [
        -646.5,
        -2788.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2774.7490234375,
      "bbox_min": [
        -646.5,
        -2788.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2786.0,
      "bbox_min": [
        -646.5,
        -2786.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2786.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2757.276123046875,
      "bbox_min": [
        -646.5,
        -2770.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2767.5,
        819.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2770.0,
      "bbox_min": [
        -646.5,
        -2770.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2770.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -656.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        815.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -501.30389404296875,
      "bbox_min": [
        -656.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -656.0,
        -2795.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2791.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2795.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2791.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -881.9061889648438,
      "bbox_min": [
        -656.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2756.0,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.4998168945312,
        -2795.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2760.5,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2767.5,
      "bbox_min": [
        -651.0,
        -2767.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2767.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -655.4998168945312,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -656.0,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2760.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 822.4500122070312,
      "bbox_min": [
        -634.2572631835938,
        -2790.439453125,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -719.30712890625,
      "bbox_min": [
        -633.4393920898438,
        -2790.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -213.0009002685547,
      "bbox_min": [
        -633.4393920898438,
        -2790.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": -2221.354736328125,
      "bbox_min": [
        -633.4393920898438,
        -2790.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 2051.924560546875,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        -0.4024023413658142
      ],
      "plane_d": 890.3036499023438,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1545.618408203125,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": 2864.95703125,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        -0.0,
        -0.4024023413658142
      ],
      "plane_d": -246.7012939453125,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2769.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": -825.58984375,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2769.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 277.2501525878906,
      "bbox_min": [
        -633.4393920898438,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2782.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2695.818603515625,
      "bbox_min": [
        -629.6760864257812,
        -2768.0,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2942.349853515625,
      "bbox_min": [
        -629.6760864257812,
        -2768.0,
        822.4500122070312
      ],
      "bbox_max": [
        -625.0,
        -2765.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 1407.530029296875,
      "bbox_min": [
        -611.0,
        -2786.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2769.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 304.6900939941406,
      "bbox_min": [
        -611.0,
        -2774.0,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2769.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2360.409423828125,
      "bbox_min": [
        -629.6760864257812,
        -2790.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2788.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2113.87841796875,
      "bbox_min": [
        -629.6760864257812,
        -2790.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -625.0,
        -2788.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -634.2572631835938,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2244.845458984375,
      "bbox_min": [
        -629.0,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1623.5675048828125,
      "bbox_min": [
        -629.0,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        -0.1500629037618637
      ],
      "plane_d": -1392.3492431640625,
      "bbox_min": [
        -624.171630859375,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        -0.13688138127326965
      ],
      "plane_d": 2485.586181640625,
      "bbox_min": [
        -624.171630859375,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2616.994140625,
      "bbox_min": [
        -624.171630859375,
        -2786.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2858.98291015625,
      "bbox_min": [
        -624.171630859375,
        -2781.171630859375,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2770.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        0.0,
        -0.14262303709983826
      ],
      "plane_d": 724.03369140625,
      "bbox_min": [
        -614.5057983398438,
        -2781.171630859375,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2774.828369140625,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 631.5,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2776.60009765625,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2779.10009765625,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": -1025.1182861328125,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -634.0,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.0,
        0.5144957304000854
      ],
      "plane_d": 121.67826843261719,
      "bbox_min": [
        -631.7572631835938,
        -2779.10009765625,
        816.0
      ],
      "bbox_max": [
        -631.5,
        -2776.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": -124.59374237060547,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        814.5
      ],
      "bbox_max": [
        -634.0,
        -2776.60009765625,
        814.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -634.2572631835938,
      "bbox_min": [
        -634.2572631835938,
        -2779.10009765625,
        814.9287719726562
      ],
      "bbox_max": [
        -634.2572631835938,
        -2776.60009765625,
        815.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -597.0,
      "bbox_min": [
        -656.0,
        -2742.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2686.035400390625,
        826.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -597.0,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2704.0,
      "bbox_min": [
        -597.0,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.0,
      "bbox_min": [
        -597.0,
        -2694.0,
        812.0
      ],
      "bbox_max": [
        -595.0,
        -2694.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 1511.087158203125,
      "bbox_min": [
        -656.0,
        -2742.0,
        812.0
      ],
      "bbox_max": [
        -597.0,
        -2686.035400390625,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -1446.0333251953125,
      "bbox_min": [
        -645.0,
        -2690.0,
        812.0
      ],
      "bbox_max": [
        -641.0354614257812,
        -2686.035400390625,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -656.0,
        -2742.0,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2690.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 2389.313720703125,
      "bbox_min": [
        -645.0,
        -2742.0,
        812.0
      ],
      "bbox_max": [
        -637.0,
        -2734.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 645.0,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2690.0,
        826.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -646.5,
      "bbox_min": [
        -656.0,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2690.0,
        826.0
      ],
      "face_count": 14
    },
    {
      "plane_normal": [
        -0.0,
        -0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": -1793.2071533203125,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 1810.68017578125,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8320503234863281,
        -0.5547001957893372
      ],
      "plane_d": 2719.833740234375,
      "bbox_min": [
        -646.5,
        -2722.5,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2720.0,
      "bbox_min": [
        -646.5,
        -2720.0,
        823.25
      ],
      "bbox_max": [
        -645.0,
        -2720.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": -2702.36083984375,
      "bbox_min": [
        -646.5,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2701.5,
        819.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2704.0,
      "bbox_min": [
        -646.5,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -645.0,
        -2704.0,
        815.75
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -656.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        815.5
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -508.5923767089844,
      "bbox_min": [
        -656.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -656.0,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2725.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -651.0,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2725.000244140625,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": -881.9061889648438,
      "bbox_min": [
        -656.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2690.0,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -651.0,
      "bbox_min": [
        -655.4998168945312,
        -2729.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2694.5,
        815.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2701.5,
      "bbox_min": [
        -651.0,
        -2701.5,
        814.5
      ],
      "bbox_max": [
        -646.5,
        -2701.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -655.4998168945312,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -656.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -651.0,
        -2694.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 822.4500122070312,
      "bbox_min": [
        -634.2572631835938,
        -2724.439453125,
        812.0
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -692.4019775390625,
      "bbox_min": [
        -633.4393920898438,
        -2724.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        -0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": -186.09573364257812,
      "bbox_min": [
        -633.4393920898438,
        -2724.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": -2160.934326171875,
      "bbox_min": [
        -633.4393920898438,
        -2724.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 2025.01953125,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9154629111289978,
        0.0,
        -0.4024023413658142
      ],
      "plane_d": 890.3036499023438,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4076539874076843,
        0.4076539874076843,
        -0.8170902729034424
      ],
      "plane_d": 1518.7132568359375,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9154629111289978,
        -0.4024023413658142
      ],
      "plane_d": 2804.53662109375,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9154629111289978,
        -0.0,
        -0.4024023413658142
      ],
      "plane_d": -246.7012939453125,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2703.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": -812.4891357421875,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2703.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 264.1494445800781,
      "bbox_min": [
        -633.4393920898438,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -631.0,
        -2716.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2635.75537109375,
      "bbox_min": [
        -629.6760864257812,
        -2702.0,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": 2882.28662109375,
      "bbox_min": [
        -629.6760864257812,
        -2702.0,
        822.4500122070312
      ],
      "bbox_max": [
        -625.0,
        -2699.560546875,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 1394.4293212890625,
      "bbox_min": [
        -611.0,
        -2720.676025390625,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2703.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.910048246383667,
        -0.1984953135251999,
        -0.3638842701911926
      ],
      "plane_d": 317.7908020019531,
      "bbox_min": [
        -611.0,
        -2708.0,
        822.4500122070312
      ],
      "bbox_max": [
        -608.5606079101562,
        -2703.323974609375,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2053.815185546875,
      "bbox_min": [
        -629.6760864257812,
        -2724.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2722.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1984953135251999,
        -0.910048246383667,
        -0.3638842701911926
      ],
      "plane_d": -2300.34619140625,
      "bbox_min": [
        -617.0,
        -2724.439453125,
        822.4500122070312
      ],
      "bbox_max": [
        -612.3239135742188,
        -2722.0,
        826.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9869229197502136,
        0.0,
        -0.16119298338890076
      ],
      "plane_d": -488.20135498046875,
      "bbox_min": [
        -634.2572631835938,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6976307034492493,
        -0.6976307034492493,
        -0.1631648987531662
      ],
      "plane_d": -2198.8017578125,
      "bbox_min": [
        -629.0,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6990998387336731,
        0.6990998387336731,
        -0.1500629186630249
      ],
      "plane_d": 1577.4268798828125,
      "bbox_min": [
        -629.0,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6990998387336731,
        -0.6990998387336731,
        -0.1500629037618637
      ],
      "plane_d": -1346.2086181640625,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7004510760307312,
        0.7004510760307312,
        -0.13688138127326965
      ],
      "plane_d": 2439.3564453125,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9869229197502136,
        -0.16119296848773956
      ],
      "plane_d": -2551.857177734375,
      "bbox_min": [
        -624.171630859375,
        -2720.0,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9897770881652832,
        -0.14262303709983826
      ],
      "plane_d": 2793.657470703125,
      "bbox_min": [
        -624.171630859375,
        -2715.171630859375,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2704.0,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9897770881652832,
        0.0,
        -0.14262303709983826
      ],
      "plane_d": 724.03369140625,
      "bbox_min": [
        -614.5057983398438,
        -2715.171630859375,
        812.0
      ],
      "bbox_max": [
        -613.0,
        -2708.828369140625,
        822.4500122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 631.5,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2710.60009765625,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2713.10009765625,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.5144957304000854,
        0.0,
        0.8574929237365723
      ],
      "plane_d": -1025.1182861328125,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -634.0,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        812.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8574929237365723,
        -0.0,
        0.5144957304000854
      ],
      "plane_d": 121.67826843261719,
      "bbox_min": [
        -631.7572631835938,
        -2713.10009765625,
        816.0
      ],
      "bbox_max": [
        -631.5,
        -2710.60009765625,
        816.4287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8574929237365723,
        -0.0,
        -0.5144957304000854
      ],
      "plane_d": -124.59374237060547,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        814.5
      ],
      "bbox_max": [
        -634.0,
        -2710.60009765625,
        814.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -634.2572631835938,
      "bbox_min": [
        -634.2572631835938,
        -2713.10009765625,
        814.9287719726562
      ],
      "bbox_max": [
        -634.2572631835938,
        -2710.60009765625,
        815.9287719726562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -595.0,
        -2772.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2685.871826171875,
        826.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 1011.619384765625,
      "bbox_min": [
        -595.0,
        -2772.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2687.016845703125,
        826.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.6401844024658203,
        0.0,
        -0.7682212591171265
      ],
      "plane_d": 267.72509765625,
      "bbox_min": [
        -595.0,
        -2772.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2687.016845703125,
        826.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2772.0,
      "bbox_min": [
        -595.0,
        -2772.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2738.5,
        826.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -572.5,
      "bbox_min": [
        -581.75,
        -2767.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2738.5,
        818.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -815.0,
      "bbox_min": [
        -572.5,
        -2767.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2738.5,
        815.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -572.5,
        -2767.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2738.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2767.5,
      "bbox_min": [
        -572.5,
        -2767.5,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2767.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2738.5,
      "bbox_min": [
        -572.5,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2738.5,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2746.0,
      "bbox_min": [
        -572.5,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -567.0,
        -2746.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2741.5,
      "bbox_min": [
        -581.75,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -572.5,
        -2741.5,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2746.0,
      "bbox_min": [
        -581.75,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -572.5,
        -2741.5,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -818.0,
      "bbox_min": [
        -581.75,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -572.5,
        -2741.5,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -581.75,
      "bbox_min": [
        -581.75,
        -2746.0,
        810.5
      ],
      "bbox_max": [
        -581.75,
        -2741.5,
        818.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 830.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -701.5,
      "bbox_min": [
        -808.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        -701.5,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.5,
      "bbox_min": [
        -701.5,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -701.5,
        -2690.0,
        827.5
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -701.5,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -701.5,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2800.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -701.5,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2690.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -701.5,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -700.0,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9061815142631531,
        -0.0,
        -0.42288893461227417
      ],
      "plane_d": -268.8303527832031,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -684.0,
        -2802.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -684.0,
        -2802.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -684.0,
        -2688.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -684.0,
        -2802.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -684.0,
        -2802.0,
        827.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -682.5999755859375,
        -2802.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -675.6000366210938,
        -2802.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -675.6000366210938,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -675.6000366210938,
        -2802.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -675.6000366210938,
        -2802.0,
        810.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9061887860298157,
        0.0,
        0.4228733479976654
      ],
      "plane_d": 267.8514099121094,
      "bbox_min": [
        -682.5999755859375,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 822.0,
      "bbox_min": [
        -682.5999755859375,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2688.0,
        827.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -682.5999755859375,
        -2802.0,
        822.0
      ],
      "bbox_max": [
        -679.166748046875,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -682.5999755859375,
        -2688.0,
        822.0
      ],
      "bbox_max": [
        -679.166748046875,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -682.5999755859375,
        -2802.0,
        822.0
      ],
      "bbox_max": [
        -679.166748046875,
        -2754.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -682.5999755859375,
        -2754.0,
        822.0
      ],
      "bbox_max": [
        -679.166748046875,
        -2754.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.5,
      "bbox_min": [
        -680.2666625976562,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2688.0,
        822.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -676.7667236328125,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2688.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -676.7667236328125,
        -2688.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2688.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -676.7667236328125,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2754.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -676.7667236328125,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -674.500244140625,
        -2802.0,
        814.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -680.2666625976562,
        -2802.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2688.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -680.2666625976562,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2688.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2691.5,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2732.0,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -809.8623046875,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2171.512451171875,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2691.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 836.9039306640625,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2730.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2198.55419921875,
      "bbox_min": [
        -680.2666015625,
        -2732.0,
        821.0
      ],
      "bbox_max": [
        -678.699951171875,
        -2730.5,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -680.2666625976562,
        -2802.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2754.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -680.2666625976562,
        -2802.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -680.2666015625,
        -2798.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2758.0,
      "bbox_min": [
        -680.2666015625,
        -2798.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -846.7498779296875,
      "bbox_min": [
        -680.2666015625,
        -2798.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 873.51416015625,
      "bbox_min": [
        -680.2666015625,
        -2798.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2235.164306640625,
      "bbox_min": [
        -680.2666015625,
        -2798.0,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        822.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2208.400146484375,
      "bbox_min": [
        -677.2333984375,
        -2759.5,
        814.5
      ],
      "bbox_max": [
        -675.666748046875,
        -2758.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -681.5,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -681.5,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -681.5,
        -2688.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -681.5,
        -2734.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -508.5923767089844,
      "bbox_min": [
        -673.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -673.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2729.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -673.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2729.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -673.0,
        -2734.0,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2729.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1107.572998046875,
      "bbox_min": [
        -673.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -673.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -673.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -673.0,
        -2694.5,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2690.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -681.5,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -681.5,
        -2802.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -681.5,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -681.5,
        -2754.0,
        812.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -501.30389404296875,
      "bbox_min": [
        -673.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -673.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2795.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -673.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2795.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -673.0,
        -2800.0,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2795.5,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1114.8614501953125,
      "bbox_min": [
        -673.0,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 814.5,
      "bbox_min": [
        -673.0,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -673.0,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -673.0,
      "bbox_min": [
        -673.0,
        -2760.5,
        814.5
      ],
      "bbox_max": [
        -673.0,
        -2756.0,
        815.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -700.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -700.0,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -700.0,
        -2720.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2700.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -700.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2685.8173828125,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2745.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -700.0,
        -2804.1826171875,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -700.0,
        -2800.0,
        810.0
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -700.0,
        -2770.0,
        810.0
      ],
      "bbox_max": [
        -697.5,
        -2750.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -684.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -684.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -687.0,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 728.5,
      "bbox_min": [
        -808.0,
        -2804.181884765625,
        810.0
      ],
      "bbox_max": [
        -701.5,
        -2685.818115234375,
        830.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -808.0,
        -2804.181884765625,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818115234375,
        830.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.5,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818359375,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -780.0,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -728.5,
        -2687.727294921875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -780.0,
        -2727.5,
        827.5
      ],
      "bbox_max": [
        -728.5,
        -2687.727294921875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2727.5,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2712.5,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.5,
        -2722.5,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2717.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.5,
        -2720.0,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2717.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -780.0,
        -2690.0,
        827.5
      ],
      "bbox_max": [
        -728.5,
        -2687.727294921875,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        827.5
      ],
      "bbox_max": [
        -746.0,
        -2687.727294921875,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        827.5
      ],
      "bbox_max": [
        -746.0,
        -2687.727294921875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        827.5
      ],
      "bbox_max": [
        -777.0,
        -2687.727294921875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -780.0,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -728.5,
        -2762.5,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2802.272705078125,
        827.5
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2777.5,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2762.5,
        830.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.5,
        -2772.5,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2762.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1368.2515869140625,
      "bbox_min": [
        -732.5,
        -2765.0,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2762.5,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -732.5,
        -2772.5,
        827.5
      ],
      "bbox_max": [
        -730.0,
        -2770.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -812.0,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818359375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818359375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -780.0,
        -2745.0,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818359375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2745.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2695.0,
        812.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.5,
        -2740.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2700.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.5,
        -2702.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2700.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2685.818359375,
        812.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2685.818359375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        810.0
      ],
      "bbox_max": [
        -777.0,
        -2685.818359375,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2690.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -728.5,
        -2745.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        812.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2804.181640625,
        810.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2795.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2745.0,
        812.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.5,
        -2790.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2745.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1368.2515869140625,
      "bbox_min": [
        -732.5,
        -2747.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2745.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -732.5,
        -2790.0,
        810.0
      ],
      "bbox_max": [
        -730.0,
        -2788.0,
        812.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": -2513.7646484375,
      "bbox_min": [
        -780.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2686.03662109375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1332.896240234375,
      "bbox_min": [
        -780.0,
        -2743.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2686.03662109375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2743.0,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2697.0,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2510.22900390625,
      "bbox_min": [
        -732.5,
        -2738.0,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2702.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1336.4317626953125,
      "bbox_min": [
        -732.5,
        -2717.5,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2702.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -780.0,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2686.03662109375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -780.0,
        -2688.0,
        812.0
      ],
      "bbox_max": [
        -746.0,
        -2686.03662109375,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        812.0
      ],
      "bbox_max": [
        -746.0,
        -2686.03662109375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2688.0,
        812.0
      ],
      "bbox_max": [
        -777.0,
        -2686.03662109375,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2692.0,
      "bbox_min": [
        -730.0,
        -2692.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2692.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2545.58447265625,
      "bbox_min": [
        -780.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2747.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -780.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2772.5,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -780.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        827.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -777.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -777.0,
        -2803.96337890625,
        812.0
      ],
      "bbox_max": [
        -777.0,
        -2802.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2800.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -730.0,
        -2800.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2798.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -730.0,
        -2798.0,
        812.0
      ],
      "bbox_max": [
        -728.5,
        -2798.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 730.0,
      "bbox_min": [
        -732.5,
        -2767.5,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2747.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        0.7071067690849304
      ],
      "plane_d": 1368.2515869140625,
      "bbox_min": [
        -732.5,
        -2767.5,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2747.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1371.787109375,
      "bbox_min": [
        -732.5,
        -2767.5,
        812.0
      ],
      "bbox_max": [
        -730.0,
        -2752.0,
        827.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 829.5,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -728.5,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2690.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -728.5,
        -2800.0,
        829.5
      ],
      "bbox_max": [
        -701.5,
        -2800.0,
        830.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -728.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.5,
        -2804.128173828125,
        810.5
      ],
      "bbox_max": [
        -725.0,
        -2800.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -728.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -701.5,
        -2685.871826171875,
        829.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -727.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9670745134353638,
        0.0,
        -0.2544932961463928
      ],
      "plane_d": 909.8135375976562,
      "bbox_min": [
        -727.5,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9670745134353638,
        -0.0,
        -0.2544932961463928
      ],
      "plane_d": -473.10302734375,
      "bbox_min": [
        -705.0,
        -2690.0,
        810.5
      ],
      "bbox_max": [
        -702.5,
        -2685.871826171875,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 808.0,
      "bbox_min": [
        -871.5,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 13
    },
    {
      "plane_normal": [
        0.5555502772331238,
        -0.8314830660820007,
        0.0
      ],
      "plane_d": -1765.6602783203125,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        766.0
      ],
      "bbox_max": [
        -860.38818359375,
        -2698.3701171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2235.64404296875,
      "bbox_min": [
        -871.5,
        -2727.72802734375,
        766.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2702.27197265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -780.9940185546875,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        766.0
      ],
      "bbox_max": [
        -866.22802734375,
        -2702.27197265625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        -0.1950865387916565,
        0.0
      ],
      "plane_d": 325.0950927734375,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        766.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2708.11181640625,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        0.0
      ],
      "plane_d": 1384.4150390625,
      "bbox_min": [
        -871.5,
        -2721.88818359375,
        766.0
      ],
      "bbox_max": [
        -870.1298828125,
        -2715.0,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        0.5555502772331238,
        0.0
      ],
      "plane_d": 2268.97705078125,
      "bbox_min": [
        -871.5,
        -2787.72802734375,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807860851287842,
        0.1950865387916565,
        -0.0
      ],
      "plane_d": 1396.1202392578125,
      "bbox_min": [
        -871.5,
        -2781.88818359375,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8314830660820007,
        -0.5555502772331238,
        0.0
      ],
      "plane_d": -814.3270263671875,
      "bbox_min": [
        -870.1298828125,
        -2768.11181640625,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2707.51171875,
        782.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2708.11181640625,
      "bbox_min": [
        -840.5,
        -2708.330322265625,
        766.0
      ],
      "bbox_max": [
        -830.187255859375,
        -2707.51171875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7682725787162781,
        0.6401229500770569,
        0.0
      ],
      "plane_d": 2377.72119140625,
      "bbox_min": [
        -839.0,
        -2708.11181640625,
        766.0
      ],
      "bbox_max": [
        -838.5,
        -2707.51171875,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657039642334,
        -0.0
      ],
      "plane_d": -2734.01806640625,
      "bbox_min": [
        -836.8701171875,
        -2708.330322265625,
        766.0
      ],
      "bbox_max": [
        -830.187255859375,
        -2708.11181640625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        -0.9994657039642334,
        -0.0
      ],
      "plane_d": -2734.01806640625,
      "bbox_min": [
        -830.187255859375,
        -2708.475830078125,
        766.0
      ],
      "bbox_max": [
        -825.7378540039062,
        -2708.330322265625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.4472135901451111,
        -0.0
      ],
      "plane_d": 1982.497802734375,
      "bbox_min": [
        -836.8701171875,
        -2790.0,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -836.8701171875,
        -2781.88818359375,
        766.0
      ],
      "bbox_max": [
        -825.738037109375,
        -2781.524169921875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 824.0,
      "bbox_min": [
        -825.738037109375,
        -2785.0,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2705.0,
        790.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.03268511965870857,
        0.9994657635688782,
        0.0
      ],
      "plane_d": 2753.048828125,
      "bbox_min": [
        -825.738037109375,
        -2781.524169921875,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2708.475830078125,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2710.89990234375,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2710.89990234375,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2719.10009765625,
      "bbox_min": [
        -825.0,
        -2719.10009765625,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2719.099853515625,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2779.10009765625,
      "bbox_min": [
        -825.0,
        -2779.10009765625,
        766.0
      ],
      "bbox_max": [
        -824.0,
        -2779.099853515625,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -776.0,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2873.367431640625,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2426.12060546875,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2769.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -810.5,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2415.616943359375,
      "bbox_min": [
        -810.5,
        -2780.5,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2769.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2883.87109375,
      "bbox_min": [
        -810.5,
        -2780.5,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2779.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2780.7001953125,
      "bbox_min": [
        -810.5,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2780.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -810.5,
        -2709.2998046875,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2368.82861328125,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2709.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -810.5,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2816.07568359375,
      "bbox_min": [
        -810.5,
        -2720.5,
        766.0
      ],
      "bbox_max": [
        -808.0,
        -2709.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -810.5,
        -2720.5,
        770.5
      ],
      "bbox_max": [
        -808.0,
        -2719.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -810.5,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -808.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9061844348907471,
        -2.0624215721909422e-06,
        0.42288270592689514
      ],
      "plane_d": 268.8318176269531,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 17
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 746.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -808.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -777.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 777.0,
      "bbox_min": [
        -808.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -808.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -777.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -777.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -746.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -775.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -775.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 807.0,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2414.089111328125,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2873.367431640625,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2871.83935546875,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2767.89990234375,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2885.398681640625,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2769.5,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9548627138137817,
        0.2970476746559143
      ],
      "plane_d": 2426.12060546875,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2769.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2427.648193359375,
      "bbox_min": [
        -808.0,
        -2782.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2780.7001953125,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2415.616943359375,
      "bbox_min": [
        -808.0,
        -2780.5,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2769.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9548627138137817,
        -0.2970476746559143
      ],
      "plane_d": 2883.87109375,
      "bbox_min": [
        -808.0,
        -2780.5,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2779.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2780.7001953125,
      "bbox_min": [
        -808.0,
        -2780.7001953125,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2780.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2828.10693359375,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2358.3251953125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2356.79736328125,
      "bbox_min": [
        -808.0,
        -2709.2998046875,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2707.89990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": 2368.82861328125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": -2370.3564453125,
      "bbox_min": [
        -808.0,
        -2722.10009765625,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        770.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.954862654209137,
        0.2970476448535919
      ],
      "plane_d": -2816.07568359375,
      "bbox_min": [
        -808.0,
        -2720.5,
        766.0
      ],
      "bbox_max": [
        -807.0,
        -2709.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.954862654209137,
        -0.2970476448535919
      ],
      "plane_d": 2826.5791015625,
      "bbox_min": [
        -808.0,
        -2720.5,
        770.5
      ],
      "bbox_max": [
        -807.0,
        -2719.10009765625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2720.7001953125,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2720.7001953125,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2769.2998046875,
      "bbox_min": [
        -808.0,
        -2769.2998046875,
        775.0
      ],
      "bbox_max": [
        -807.0,
        -2769.2998046875,
        776.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -687.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2802.0,
      "bbox_min": [
        -687.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -687.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -684.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -684.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -682.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2804.39990234375,
        774.2849731445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 684.0,
      "bbox_min": [
        -687.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -687.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -684.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -684.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -684.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -682.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -656.0,
        -2681.01904296875,
        774.28564453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -746.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -715.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -744.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -715.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2804.53564453125,
        806.7630004882812
      ],
      "bbox_max": [
        -698.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -715.0,
        -2808.981201171875,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -715.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": 2319.318359375,
      "bbox_min": [
        -689.0,
        -2808.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2804.39990234375,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2688.0,
      "bbox_min": [
        -746.0,
        -2802.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 715.0,
      "bbox_min": [
        -746.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -746.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -715.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 744.0,
      "bbox_min": [
        -744.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -715.0,
        -2688.0,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2688.0,
        806.7630004882812
      ],
      "bbox_max": [
        -698.0,
        -2685.46435546875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 713.0,
      "bbox_min": [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2681.01904296875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -715.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -713.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.999755859375,
      "bbox_min": [
        -689.0,
        -2685.60009765625,
        766.0
      ],
      "bbox_max": [
        -687.0,
        -2682.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2740.0,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2790.0,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2792.667236328125,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2802.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2800.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2800.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2790.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 1516.2579345703125,
      "bbox_min": [
        -732.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2802.0,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2801.833251953125,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2750.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2740.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2700.0,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 807.5,
      "bbox_min": [
        -732.5,
        -2700.0,
        807.4545288085938
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -732.0,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -732.0,
        -2697.333251953125,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -732.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2690.0,
        807.5
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 697.5,
      "bbox_min": [
        -697.5,
        -2700.0,
        807.5
      ],
      "bbox_max": [
        -697.5,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.26311740279197693,
        -0.9647638201713562
      ],
      "plane_d": 71.74335479736328,
      "bbox_min": [
        -732.0,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 698.0,
      "bbox_min": [
        -698.0,
        -2688.166748046875,
        807.4545288085938
      ],
      "bbox_max": [
        -698.0,
        -2688.0,
        807.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -795.0,
      "bbox_min": [
        -674.6666870117188,
        -2808.077880859375,
        769.9992065429688
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        810.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -667.6666870117188,
        -2808.077880859375,
        769.9992065429688
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -667.6666870117188,
        -2808.077880859375,
        769.9992065429688
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9284766912460327,
        0.3713906705379486
      ],
      "plane_d": 2319.334716796875,
      "bbox_min": [
        -658.0,
        -2808.077880859375,
        769.9992065429688
      ],
      "bbox_max": [
        -656.0,
        -2805.99951171875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2808.077880859375,
        774.2849731445312
      ],
      "bbox_max": [
        -658.0,
        -2807.7138671875,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -667.6666870117188,
        -2736.0,
        769.9998779296875
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -667.6666870117188,
        -2736.0,
        785.0
      ],
      "bbox_max": [
        -656.0,
        -2736.0,
        795.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        3.778864265768789e-05,
        -0.9284732341766357,
        0.3713993728160858
      ],
      "plane_d": -2777.974853515625,
      "bbox_min": [
        -658.0,
        -2684.0,
        769.9998779296875
      ],
      "bbox_max": [
        -656.0,
        -2681.922119140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -658.0,
        -2682.28564453125,
        774.28564453125
      ],
      "bbox_max": [
        -658.0,
        -2681.922119140625,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9061887860298157,
        0.0,
        0.4228733479976654
      ],
      "plane_d": 267.7907409667969,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -797.5,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -666.5003051757812,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -668.8333740234375,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -666.5003051757812,
        -2688.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -668.8333740234375,
        -2688.0,
        795.0
      ],
      "bbox_max": [
        -666.5003051757812,
        -2688.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -668.8333740234375,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -666.5003051757812,
        -2754.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -668.8333740234375,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -666.5003051757812,
        -2802.0,
        797.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 805.0,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2688.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -674.6666870117188,
        -2688.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -674.6666870117188,
        -2802.0,
        805.0
      ],
      "bbox_max": [
        -671.166748046875,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -672.3333740234375,
        -2802.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2688.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -672.3333740234375,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2688.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2732.0,
      "bbox_min": [
        -672.333251953125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2691.5,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2691.5,
      "bbox_min": [
        -672.333251953125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2691.5,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2184.409423828125,
      "bbox_min": [
        -672.333251953125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2691.5,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -824.0071411132812,
      "bbox_min": [
        -672.333251953125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2691.5,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2157.36767578125,
      "bbox_min": [
        -669.300048828125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2691.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 851.048828125,
      "bbox_min": [
        -669.300048828125,
        -2732.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2730.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -672.3333740234375,
        -2802.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2754.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -672.3333740234375,
        -2802.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2798.0,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2758.0,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": 2221.01953125,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        -0.8320502638816833
      ],
      "plane_d": -860.8947143554688,
      "bbox_min": [
        -672.333251953125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        805.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": 887.6589965820312,
      "bbox_min": [
        -669.300048828125,
        -2798.0,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547001957893372,
        0.8320502638816833
      ],
      "plane_d": -2194.25537109375,
      "bbox_min": [
        -669.300048828125,
        -2759.5,
        797.5
      ],
      "bbox_max": [
        -667.666748046875,
        -2758.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2736.0,
      "bbox_min": [
        -673.5,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2690.0,
      "bbox_min": [
        -673.5,
        -2734.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2688.0,
      "bbox_min": [
        -673.5,
        -2688.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2688.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2734.0,
      "bbox_min": [
        -673.5,
        -2734.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -491.69635009765625,
      "bbox_min": [
        -665.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -665.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2729.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2729.5,
      "bbox_min": [
        -665.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2729.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2734.0,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2729.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1090.677001953125,
      "bbox_min": [
        -665.0,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -665.0,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2694.5,
      "bbox_min": [
        -665.0,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2694.5,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2690.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2800.0,
      "bbox_min": [
        -673.5,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2802.0,
      "bbox_min": [
        -673.5,
        -2802.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2802.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2756.0,
      "bbox_min": [
        -673.5,
        -2800.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2754.0,
      "bbox_min": [
        -673.5,
        -2754.0,
        795.0
      ],
      "bbox_max": [
        -656.0,
        -2754.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -484.4078674316406,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2795.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2795.5,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2795.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2800.0,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2795.5,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.11043152958154678,
        0.9938837289810181
      ],
      "plane_d": -1097.9654541015625,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 797.5,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2760.5,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -656.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -665.0,
      "bbox_min": [
        -665.0,
        -2760.5,
        797.5
      ],
      "bbox_max": [
        -665.0,
        -2756.0,
        798.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2647.0,
      "bbox_min": [
        -733.0,
        -2660.000244140625,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -733.0,
        -2647.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        827.0
      ],
      "bbox_max": [
        -723.0,
        -2631.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2631.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        827.0
      ],
      "bbox_max": [
        -723.0,
        -2631.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2641.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        827.0
      ],
      "bbox_max": [
        -723.0,
        -2641.0,
        836.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -733.0,
        -2647.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -733.0,
        -2647.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -733.0,
        -2647.0,
        825.0
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        827.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2631.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -723.0,
        -2631.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": 2641.0,
      "bbox_min": [
        -733.0,
        -2641.0,
        825.0
      ],
      "bbox_max": [
        -723.0,
        -2641.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 825.7999877929688,
      "bbox_min": [
        -733.0,
        -2660.000244140625,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 827.0,
      "bbox_min": [
        -607.0,
        -2659.84033203125,
        825.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2659.84033203125,
        825.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -567.0,
        -2659.84033203125,
        825.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        827.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2653.0,
      "bbox_min": [
        -733.0,
        -2660.000244140625,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2660.000244140625,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2653.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2660.000244140625,
        825.0
      ],
      "bbox_max": [
        -607.0,
        -2653.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -733.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -567.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -607.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2653.0,
        825.0
      ],
      "bbox_max": [
        -733.0,
        -2647.0,
        825.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.6401844024658203,
        -0.7682212591171265
      ],
      "plane_d": -1050.5426025390625,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -607.0,
        -2631.0,
        819.9999389648438
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2631.0,
        819.9999389648438
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2631.0,
        819.9999389648438
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 790.0,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -733.0,
        -2667.0,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -733.0,
        -2662.89990234375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        825.0
      ],
      "face_count": 19
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 733.0,
      "bbox_min": [
        -733.0,
        -2662.89990234375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        825.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -733.0,
        -2662.89990234375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        825.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -652.5,
        -2662.89990234375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        825.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        -610.0,
        -2662.585693359375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.4190581738948822,
        -0.9079594016075134
      ],
      "plane_d": -362.41546630859375,
      "bbox_min": [
        -610.0,
        -2662.585693359375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.35897907614707947,
        0.9333456158638
      ],
      "plane_d": -1704.7198486328125,
      "bbox_min": [
        -610.0,
        -2662.585693359375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.35897907614707947,
        0.9333456158638
      ],
      "plane_d": 197.86924743652344,
      "bbox_min": [
        -610.0,
        -2662.585693359375,
        810.5
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2635.0,
      "bbox_min": [
        -610.0,
        -2661.25439453125,
        813.0
      ],
      "bbox_max": [
        -607.0,
        -2635.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.4190581738948822,
        -0.9079594016075134
      ],
      "plane_d": 1858.5928955078125,
      "bbox_min": [
        -610.0,
        -2661.25439453125,
        818.728759765625
      ],
      "bbox_max": [
        -607.0,
        -2658.5,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2630.0,
      "bbox_min": [
        -652.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        -652.5,
        -2630.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 632.5,
      "bbox_min": [
        -652.5,
        -2630.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -652.5,
      "bbox_min": [
        -652.5,
        -2630.0,
        810.5
      ],
      "bbox_max": [
        -652.5,
        -2625.0,
        820.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -815.0,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 632.5,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -637.5,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2630.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2639.0,
      "bbox_min": [
        -637.5,
        -2639.0,
        810.5
      ],
      "bbox_max": [
        -632.5,
        -2639.0,
        815.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -607.0,
        -2667.0,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -607.0,
        -2667.0,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        825.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 600.0,
      "bbox_min": [
        -607.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        814.2000732421875
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 809.5,
      "bbox_min": [
        -607.0,
        -2663.10009765625,
        809.5
      ],
      "bbox_max": [
        -600.0,
        -2625.0,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -810.5,
      "bbox_min": [
        -607.0,
        -2662.900146484375,
        810.5
      ],
      "bbox_max": [
        -600.0,
        -2625.0,
        814.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": 532.5263061523438,
      "bbox_min": [
        -600.5,
        -2662.900146484375,
        810.5
      ],
      "bbox_max": [
        -600.0,
        -2641.550048828125,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -600.5,
      "bbox_min": [
        -600.5,
        -2662.89990234375,
        810.5
      ],
      "bbox_max": [
        -600.0,
        -2641.550048828125,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -814.2000732421875,
      "bbox_min": [
        -600.5,
        -2662.16015625,
        810.5
      ],
      "bbox_max": [
        -600.0,
        -2641.550048828125,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2641.550048828125,
      "bbox_min": [
        -600.5,
        -2641.550048828125,
        810.5
      ],
      "bbox_max": [
        -600.0,
        -2641.550048828125,
        814.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9967280030250549,
        0.08082867413759232
      ],
      "plane_d": 2561.489013671875,
      "bbox_min": [
        -600.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        812.5672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2635.0,
      "bbox_min": [
        -600.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        812.5672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -806.5,
      "bbox_min": [
        -600.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        812.5672607421875
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -600.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        806.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 801.7999877929688,
      "bbox_min": [
        -600.0,
        -2635.5,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -802.7999877929688,
      "bbox_min": [
        -600.0,
        -2635.5,
        802.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -662.9260864257812,
      "bbox_min": [
        -600.0,
        -2635.5,
        802.7999877929688
      ],
      "bbox_max": [
        -599.699951171875,
        -2635.0,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9967280030250549,
        0.08082867413759232
      ],
      "plane_d": 2562.741943359375,
      "bbox_min": [
        -592.7810668945312,
        -2635.5,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.218994140625,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -791.0,
      "bbox_min": [
        -592.7810668945312,
        -2635.5,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.218994140625,
        791.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -802.7999877929688,
      "bbox_min": [
        -600.0,
        -2657.8701171875,
        801.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2642.0,
      "bbox_min": [
        -600.0,
        -2657.6669921875,
        801.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        802.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -600.0,
        -2657.6669921875,
        801.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        802.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 593.0,
      "bbox_min": [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      "bbox_max": [
        -593.0,
        -2642.0,
        802.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2645.376708984375,
        801.7999877929688
      ],
      "bbox_max": [
        -574.0,
        -2642.0,
        802.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -726.7771606445312,
      "bbox_min": [
        -600.0,
        -2657.666748046875,
        801.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2642.0,
        802.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1531.6590576171875,
      "bbox_min": [
        -599.699951171875,
        -2657.666748046875,
        801.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2654.33349609375,
        802.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.743514965521172e-06,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1528.120849609375,
      "bbox_min": [
        -599.5,
        -2645.333740234375,
        801.7999877929688
      ],
      "bbox_max": [
        -593.5,
        -2642.0,
        802.800048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.220703143189894e-05,
        1.0,
        0.0
      ],
      "plane_d": 2641.44287109375,
      "bbox_min": [
        -600.0,
        -2657.8701171875,
        802.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9967334270477295,
        0.08076200634241104
      ],
      "plane_d": -2698.20556640625,
      "bbox_min": [
        -600.0,
        -2657.8701171875,
        802.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2641.449951171875,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -600.0,
        -2642.000244140625,
        802.7999877929688
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.5,
        -2642.0,
        802.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2641.4501953125,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 18.563335418701172,
      "bbox_min": [
        -574.0,
        -2657.8701171875,
        802.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -19.517065048217773,
      "bbox_min": [
        -574.0,
        -2654.493408203125,
        802.7999877929688
      ],
      "bbox_max": [
        -567.0,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -637.0101318359375,
      "bbox_min": [
        -574.0,
        -2642.000244140625,
        802.7999877929688
      ],
      "bbox_max": [
        -573.699951171875,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -600.0,
        -2654.333740234375,
        802.7999877929688
      ],
      "bbox_max": [
        -593.0,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9964353442192078,
        -0.02424079179763794,
        0.08080200850963593
      ],
      "plane_d": 461.97412109375,
      "bbox_min": [
        -593.5,
        -2654.333740234375,
        802.7999877929688
      ],
      "bbox_max": [
        -593.0,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967281222343445,
        -0.0,
        0.08082734793424606
      ],
      "plane_d": 526.1715698242188,
      "bbox_min": [
        -593.300048828125,
        -2642.000244140625,
        802.7999877929688
      ],
      "bbox_max": [
        -593.0,
        -2641.7001953125,
        806.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -600.0,
        -2654.33349609375,
        802.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2641.700439453125,
        806.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -726.7771606445312,
      "bbox_min": [
        -600.0,
        -2654.33349609375,
        802.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2641.700439453125,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -662.9260864257812,
      "bbox_min": [
        -600.0,
        -2642.0,
        802.7999877929688
      ],
      "bbox_max": [
        -599.699951171875,
        -2641.700439453125,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -662.9260864257812,
      "bbox_min": [
        -600.0,
        -2641.4501953125,
        802.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2635.5,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -599.5,
        -2641.4501953125,
        802.7999877929688
      ],
      "bbox_max": [
        -599.5,
        -2635.5,
        806.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 593.0,
      "bbox_min": [
        -600.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -9.743514965521172e-06,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1528.120849609375,
      "bbox_min": [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      "bbox_max": [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 599.5,
      "bbox_min": [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      "bbox_max": [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -726.7771606445312,
      "bbox_min": [
        -600.0,
        -2665.872314453125,
        795.6383056640625
      ],
      "bbox_max": [
        -599.5,
        -2645.333251953125,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1531.6590576171875,
      "bbox_min": [
        -599.699951171875,
        -2665.085205078125,
        799.574462890625
      ],
      "bbox_max": [
        -599.5,
        -2657.666748046875,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9964353442192078,
        -0.02424079179763794,
        0.08080200850963593
      ],
      "plane_d": 461.97412109375,
      "bbox_min": [
        -593.5,
        -2665.872314453125,
        795.6383056640625
      ],
      "bbox_max": [
        -593.0,
        -2645.333251953125,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -593.5,
      "bbox_min": [
        -593.5,
        -2665.872314453125,
        795.6383666992188
      ],
      "bbox_max": [
        -593.300048828125,
        -2645.333740234375,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2873499393463135,
        0.9578256607055664
      ],
      "plane_d": -1531.6650390625,
      "bbox_min": [
        -593.5,
        -2665.085205078125,
        799.5745239257812
      ],
      "bbox_max": [
        -593.300048828125,
        -2657.6669921875,
        801.7999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -592.7810668945312,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        797.9340209960938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9964426755905151,
        0.023930512368679047,
        0.08080419898033142
      ],
      "plane_d": -572.350830078125,
      "bbox_min": [
        -592.7810668945312,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -573.5,
        -2635.5,
        797.9340209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -8.207984924316406,
      "bbox_min": [
        -574.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        797.9340209960938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        794.4407958984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 3.7013893127441406,
      "bbox_min": [
        -574.0,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        793.4967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.449951171875,
      "bbox_min": [
        -573.767822265625,
        -2641.449951171875,
        790.0
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        790.8372192382812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -791.0000610351562,
      "bbox_min": [
        -573.699951171875,
        -2642.0,
        790.8372192382812
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        791.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.449951171875,
      "bbox_min": [
        -573.6998901367188,
        -2641.449951171875,
        790.8372192382812
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -791.0000610351562,
      "bbox_min": [
        -592.7810668945312,
        -2645.33349609375,
        790.0
      ],
      "bbox_max": [
        -573.6867065429688,
        -2635.5,
        791.0000610351562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.9960445165634155,
        0.08885567635297775
      ],
      "plane_d": -2701.505615234375,
      "bbox_min": [
        -586.5,
        -2645.33349609375,
        790.0
      ],
      "bbox_max": [
        -573.699951171875,
        -2641.669921875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9964352250099182,
        -0.02424122951924801,
        0.08080360293388367
      ],
      "plane_d": 456.2490234375,
      "bbox_min": [
        -586.5,
        -2645.33349609375,
        790.0
      ],
      "bbox_max": [
        -573.699951171875,
        -2641.669921875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.28734952211380005,
        0.957825779914856
      ],
      "plane_d": -1516.817626953125,
      "bbox_min": [
        -586.5,
        -2645.33349609375,
        790.0
      ],
      "bbox_max": [
        -586.2189331054688,
        -2641.669921875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967281222343445,
        -0.0,
        0.08082734793424606
      ],
      "plane_d": 520.4473266601562,
      "bbox_min": [
        -586.300048828125,
        -2642.0,
        790.0
      ],
      "bbox_max": [
        -586.2189331054688,
        -2641.669921875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -635.75732421875,
      "bbox_min": [
        -573.7810668945312,
        -2642.0,
        790.0
      ],
      "bbox_max": [
        -573.699951171875,
        -2641.669921875,
        791.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 592.5,
      "bbox_min": [
        -592.7810668945312,
        -2645.333251953125,
        790.0
      ],
      "bbox_max": [
        -592.5,
        -2641.449951171875,
        791.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -718.5496215820312,
      "bbox_min": [
        -592.7810668945312,
        -2645.333251953125,
        790.0
      ],
      "bbox_max": [
        -592.699951171875,
        -2641.449951171875,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -654.6961059570312,
      "bbox_min": [
        -592.7810668945312,
        -2641.449951171875,
        790.0
      ],
      "bbox_max": [
        -592.5,
        -2635.5,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 592.5,
      "bbox_min": [
        -592.5,
        -2641.449951171875,
        790.0
      ],
      "bbox_max": [
        -592.5,
        -2635.5,
        791.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -4.6551194190979,
      "bbox_min": [
        -573.5,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2651.11669921875,
        794.4408569335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 3.7013893127441406,
      "bbox_min": [
        -573.5,
        -2666.300537109375,
        790.0
      ],
      "bbox_max": [
        -567.0,
        -2654.493408203125,
        793.4967041015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.2839656174182892,
        0.9588344693183899
      ],
      "plane_d": -23.062828063964844,
      "bbox_min": [
        -574.0,
        -2663.3740234375,
        806.5
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        812.5672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964426755905151,
        0.023930735886096954,
        0.08080419898033142
      ],
      "plane_d": -573.6027221679688,
      "bbox_min": [
        -574.0,
        -2663.3740234375,
        806.5
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        812.5672607421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 18.563335418701172,
      "bbox_min": [
        -574.0,
        -2663.3740234375,
        806.5
      ],
      "bbox_max": [
        -573.5,
        -2657.8701171875,
        808.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -19.517065048217773,
      "bbox_min": [
        -573.5,
        -2663.3740234375,
        806.5
      ],
      "bbox_max": [
        -567.0,
        -2654.493408203125,
        809.0741577148438
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 18.563335418701172,
      "bbox_min": [
        -573.5,
        -2663.3740234375,
        806.5
      ],
      "bbox_max": [
        -567.0,
        -2657.8701171875,
        808.1300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -567.0,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2625.0,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9805806875228882,
        -0.1961161345243454
      ],
      "plane_d": -2426.937255859375,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2625.0,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2633.0,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2625.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": 2287.907958984375,
      "bbox_min": [
        -816.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2628.199951171875,
        790.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -806.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -744.0,
        -2667.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 806.0,
      "bbox_min": [
        -806.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -806.0,
        -2667.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": -658.0,
      "bbox_min": [
        -682.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2667.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2667.0,
        774.9995727539062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 682.0,
      "bbox_min": [
        -682.0,
        -2671.7998046875,
        766.0
      ],
      "bbox_max": [
        -682.0,
        -2667.0,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486833214759827,
        0.3162277638912201
      ],
      "plane_d": -2740.11376953125,
      "bbox_min": [
        -816.0,
        -2670.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2628.199951171875,
        790.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -607.0,
        -2633.000244140625,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2628.199951171875,
        775.0001220703125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -610.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2630.0,
        790.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 607.0,
      "bbox_min": [
        -610.0,
        -2670.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2630.0,
        790.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 775.0,
      "bbox_min": [
        -610.0,
        -2662.5,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2662.5,
      "bbox_min": [
        -610.0,
        -2662.5,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2637.5,
      "bbox_min": [
        -610.0,
        -2662.5,
        766.0
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": 2429.618896484375,
      "bbox_min": [
        -610.0,
        -2662.5,
        773.5
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.7071067690849304,
        -0.7071067690849304
      ],
      "plane_d": -1318.0469970703125,
      "bbox_min": [
        -610.0,
        -2639.0,
        773.5
      ],
      "bbox_max": [
        -607.0,
        -2637.5,
        775.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -593.0,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2635.0,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.9967280030250549,
        0.08082867413759232
      ],
      "plane_d": 2562.741943359375,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964351058006287,
        -0.024241438135504723,
        0.08080492168664932
      ],
      "plane_d": -718.5496215820312,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -779.5,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 778.5,
      "bbox_min": [
        -593.0,
        -2669.2998046875,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        779.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": 2668.0,
      "bbox_min": [
        -593.0,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -567.0,
        -2654.717041015625,
        779.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963207244873047,
        0.028588792309165,
        0.0807943120598793
      ],
      "plane_d": -558.5923461914062,
      "bbox_min": [
        -593.0,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -567.0,
        -2654.717041015625,
        779.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -574.0,
        -2665.173828125,
        779.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        8.85218378243735e-06,
        0.33357903361320496,
        0.9427221417427063
      ],
      "plane_d": 155.1419677734375,
      "bbox_min": [
        -573.5,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -567.0,
        -2665.173828125,
        779.5000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2873474657535553,
        -0.9578264355659485
      ],
      "plane_d": 1512.3109130859375,
      "bbox_min": [
        -593.0,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -586.0,
        -2664.666748046875,
        779.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 586.0,
      "bbox_min": [
        -586.0,
        -2668.0,
        778.5
      ],
      "bbox_max": [
        -586.0,
        -2664.666748046875,
        779.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.33357903361320496,
        -0.9427221417427063
      ],
      "plane_d": -156.07968139648438,
      "bbox_min": [
        -586.0,
        -2668.0,
        766.0
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 769.2999877929688,
      "bbox_min": [
        -586.0,
        -2668.0,
        769.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -586.0,
        -2668.0,
        769.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -574.0,
        -2665.173828125,
        770.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        778.5
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9963207244873047,
        0.028588792309165,
        0.0807943120598793
      ],
      "plane_d": -558.5923461914062,
      "bbox_min": [
        -574.0,
        -2665.173828125,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2635.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.33357903361320496,
        0.9427221417427063
      ],
      "plane_d": 151.6488037109375,
      "bbox_min": [
        -574.0,
        -2654.717041015625,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2635.0,
        778.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.2999877929688,
      "bbox_min": [
        -574.0,
        -2642.0,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2635.0,
        773.805419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.449951171875,
      "bbox_min": [
        -573.9841918945312,
        -2641.449951171875,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2635.5,
        773.805419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -573.8134765625,
        -2635.5,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2635.5,
        771.7000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -573.699951171875,
        -2642.0,
        771.7000732421875
      ],
      "bbox_max": [
        -573.5,
        -2635.300048828125,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -573.513427734375,
        -2635.5,
        774.0
      ],
      "bbox_max": [
        -573.5,
        -2635.300048828125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0000610351562,
      "bbox_min": [
        -573.699951171875,
        -2642.0,
        773.805419921875
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        774.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0000610351562,
      "bbox_min": [
        -574.0,
        -2642.0,
        770.2999877929688
      ],
      "bbox_max": [
        -573.6841430664062,
        -2641.449951171875,
        774.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9960445165634155,
        0.08885567635297775
      ],
      "plane_d": -2699.9951171875,
      "bbox_min": [
        -574.0,
        -2642.0,
        770.2999877929688
      ],
      "bbox_max": [
        -573.699951171875,
        -2641.669921875,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -574.0,
        -2635.5,
        770.2999877929688
      ],
      "bbox_max": [
        -573.5076293945312,
        -2635.300048828125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -574.0,
        -2635.5,
        774.0
      ],
      "bbox_max": [
        -573.5076293945312,
        -2635.300048828125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.2999877929688,
      "bbox_min": [
        -573.5,
        -2642.0,
        770.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -573.5,
        -2635.5,
        770.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.300048828125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -573.5,
        -2635.5,
        774.0
      ],
      "bbox_max": [
        -567.0,
        -2635.300048828125,
        774.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -774.0,
      "bbox_min": [
        -586.0,
        -2648.266845703125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.0,
        774.0000610351562
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -646.3449096679688,
      "bbox_min": [
        -586.0,
        -2648.266845703125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.0,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -586.0,
      "bbox_min": [
        -586.0,
        -2648.266845703125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.0,
        774.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.2999877929688,
      "bbox_min": [
        -586.0,
        -2635.5,
        770.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.0,
        770.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9962174296379089,
        -0.03200415149331093,
        0.08078727126121521
      ],
      "plane_d": -730.5687866210938,
      "bbox_min": [
        -586.0,
        -2648.266845703125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.5,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -770.2999877929688,
      "bbox_min": [
        -586.0,
        -2648.266845703125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.5,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2642.0,
      "bbox_min": [
        -579.0,
        -2643.333251953125,
        769.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2642.0,
        770.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 579.0,
      "bbox_min": [
        -579.0,
        -2643.333251953125,
        769.2999877929688
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        770.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9962175488471985,
        -0.03200381249189377,
        0.08078594505786896
      ],
      "plane_d": 430.0264892578125,
      "bbox_min": [
        -579.0907592773438,
        -2644.825927734375,
        769.7717895507812
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        770.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        -585.5,
        -2644.825927734375,
        769.7717895507812
      ],
      "bbox_max": [
        -585.5,
        -2642.0,
        770.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 585.5,
      "bbox_min": [
        -585.5,
        -2648.266845703125,
        770.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2635.5,
        774.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.449951171875,
      "bbox_min": [
        -579.5,
        -2648.266845703125,
        770.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2641.449951171875,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -579.5,
      "bbox_min": [
        -579.5,
        -2648.266845703125,
        770.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2641.449951171875,
        774.0000610351562
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9960445165634155,
        0.08885567635297775
      ],
      "plane_d": -2699.9951171875,
      "bbox_min": [
        -579.300048828125,
        -2648.266845703125,
        770.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2641.669921875,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967281222343445,
        -0.0,
        0.08082734793424606
      ],
      "plane_d": 514.8442993164062,
      "bbox_min": [
        -579.300048828125,
        -2642.0,
        770.2999877929688
      ],
      "bbox_max": [
        -579.0,
        -2641.669921875,
        774.0000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.36830756068229675,
        0.9297040104866028
      ],
      "plane_d": -1692.6595458984375,
      "bbox_min": [
        -586.0,
        -2662.1943359375,
        766.0
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        771.5174560546875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9962175488471985,
        -0.03200381249189377,
        0.08078594505786896
      ],
      "plane_d": 430.0264892578125,
      "bbox_min": [
        -586.0,
        -2662.1943359375,
        766.0
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        771.5174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9962174296379089,
        -0.03200415149331093,
        0.08078727126121521
      ],
      "plane_d": -730.5687866210938,
      "bbox_min": [
        -586.0,
        -2662.1943359375,
        766.0
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        771.5174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -579.5,
      "bbox_min": [
        -586.0,
        -2662.1943359375,
        766.0
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        771.5174560546875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 579.0,
      "bbox_min": [
        -579.5,
        -2652.854248046875,
        766.0
      ],
      "bbox_max": [
        -579.0,
        -2642.0,
        769.7717895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": -586.0,
      "bbox_min": [
        -586.0,
        -2652.854248046875,
        766.0
      ],
      "bbox_max": [
        -585.5,
        -2642.0,
        769.7717895507812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.37346509099006653,
        -0.9276442527770996
      ],
      "plane_d": 1700.33154296875,
      "bbox_min": [
        -585.5,
        -2650.19677734375,
        766.0
      ],
      "bbox_max": [
        -579.5,
        -2642.0,
        769.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": 592.5,
      "bbox_min": [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1516.812744140625,
      "bbox_min": [
        -593.0,
        -2668.35986328125,
        779.5
      ],
      "bbox_max": [
        -592.5,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2873474657535553,
        -0.9578264355659485
      ],
      "plane_d": 1512.3109130859375,
      "bbox_min": [
        -593.0,
        -2664.666748046875,
        779.5
      ],
      "bbox_max": [
        -592.5,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -593.0,
        -2642.0,
        787.2999877929688
      ],
      "bbox_max": [
        -592.5,
        -2638.66650390625,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -654.6961059570312,
      "bbox_min": [
        -593.0,
        -2638.66650390625,
        787.2999877929688
      ],
      "bbox_max": [
        -592.5,
        -2635.0,
        788.3738403320312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -593.0,
        -2638.66650390625,
        787.2999877929688
      ],
      "bbox_max": [
        -592.5,
        -2635.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.2000122070312,
      "bbox_min": [
        -592.699951171875,
        -2668.35986328125,
        783.2000122070312
      ],
      "bbox_max": [
        -592.5,
        -2668.0,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": -2635.5,
      "bbox_min": [
        -592.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.2999877929688,
      "bbox_min": [
        -592.5,
        -2635.5,
        786.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -592.5,
        -2635.5,
        787.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        -0.0
      ],
      "plane_d": -586.5,
      "bbox_min": [
        -592.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        790.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.2873474657535553,
        -0.9578264355659485
      ],
      "plane_d": 1512.3109130859375,
      "bbox_min": [
        -586.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.28734952211380005,
        0.957825779914856
      ],
      "plane_d": -1516.817626953125,
      "bbox_min": [
        -586.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -585.9188842773438,
        -2638.66650390625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 586.0,
      "bbox_min": [
        -586.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -585.9188842773438,
        -2638.66650390625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.5,
      "bbox_min": [
        -586.5,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -586.0121459960938,
        -2668.5,
        782.4993286132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9960445165634155,
        0.08885567635297775
      ],
      "plane_d": -2701.505615234375,
      "bbox_min": [
        -586.2189331054688,
        -2642.0,
        787.2999877929688
      ],
      "bbox_max": [
        -586.0,
        -2641.759033203125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -586.0,
        -2642.0,
        786.2999877929688
      ],
      "bbox_max": [
        -585.9188842773438,
        -2638.66650390625,
        787.4649047851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2642.0,
      "bbox_min": [
        -586.0,
        -2642.0,
        786.2999877929688
      ],
      "bbox_max": [
        -585.9188842773438,
        -2642.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": 2641.449951171875,
      "bbox_min": [
        -586.0,
        -2641.449951171875,
        787.300048828125
      ],
      "bbox_max": [
        -585.9866333007812,
        -2641.449951171875,
        787.4649047851562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -586.308837890625,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2638.66650390625,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2668.5,
      "bbox_min": [
        -586.308837890625,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -4.6950121941335965e-06,
        -4.6950121941335965e-06,
        1.0
      ],
      "plane_d": -783.2152709960938,
      "bbox_min": [
        -586.308837890625,
        -2668.5,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        787.2999877929688
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        779.5
      ],
      "bbox_max": [
        -573.5,
        -2660.8115234375,
        783.2000732421875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -635.1268310546875,
      "bbox_min": [
        -574.0,
        -2668.300048828125,
        779.5
      ],
      "bbox_max": [
        -573.699951171875,
        -2668.0,
        783.2000732421875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": 521.07666015625,
      "bbox_min": [
        -586.300048828125,
        -2668.300048828125,
        779.5
      ],
      "bbox_max": [
        -586.0,
        -2668.0,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": -2642.0,
      "bbox_min": [
        -586.0,
        -2645.37646484375,
        786.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2642.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2645.37646484375,
        786.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2642.0,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2839631736278534,
        -0.9588351845741272
      ],
      "plane_d": 3.7013893127441406,
      "bbox_min": [
        -586.2130737304688,
        -2654.493408203125,
        787.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2641.449951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        9.003485502034891e-06,
        0.2839631736278534,
        0.9588351845741272
      ],
      "plane_d": -4.6551194190979,
      "bbox_min": [
        -586.2130737304688,
        -2654.493408203125,
        787.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2641.449951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": -574.0,
      "bbox_min": [
        -574.0,
        -2654.493408203125,
        787.2999877929688
      ],
      "bbox_max": [
        -574.0,
        -2642.0,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9960445165634155,
        0.08885567635297775
      ],
      "plane_d": -2701.505615234375,
      "bbox_min": [
        -586.2130737304688,
        -2651.116943359375,
        787.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2642.0,
        787.300048828125
      ],
      "bbox_max": [
        -573.5,
        -2641.449951171875,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9964426755905151,
        0.023930512368679047,
        0.08080419898033142
      ],
      "plane_d": -572.350830078125,
      "bbox_min": [
        -574.0,
        -2651.116943359375,
        787.2999877929688
      ],
      "bbox_max": [
        -573.5,
        -2641.759033203125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.5,
        -2651.11669921875,
        787.300048828125
      ],
      "bbox_max": [
        -573.5,
        -2641.759033203125,
        790.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9967281222343445,
        0.0,
        0.08082734793424606
      ],
      "plane_d": -635.75732421875,
      "bbox_min": [
        -574.0,
        -2642.0,
        787.2999877929688
      ],
      "bbox_max": [
        -573.7810668945312,
        -2641.759033203125,
        790.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.2999877929688,
      "bbox_min": [
        -586.5,
        -2664.66650390625,
        779.5
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -586.5,
        -2638.66650390625,
        787.2999877929688
      ],
      "bbox_max": [
        -567.0,
        -2635.5,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9963207244873047,
        0.028588792309165,
        0.0807943120598793
      ],
      "plane_d": -558.5923461914062,
      "bbox_min": [
        -573.9043579101562,
        -2664.66650390625,
        779.5
      ],
      "bbox_max": [
        -573.5,
        -2657.543212890625,
        780.656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 573.5,
      "bbox_min": [
        -573.699951171875,
        -2664.66650390625,
        779.5
      ],
      "bbox_max": [
        -573.5,
        -2657.543212890625,
        780.656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.33357903361320496,
        0.9427221417427063
      ],
      "plane_d": 151.6488037109375,
      "bbox_min": [
        -573.699951171875,
        -2660.8115234375,
        779.5
      ],
      "bbox_max": [
        -573.5,
        -2657.543212890625,
        780.656494140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.2873474657535553,
        0.9578264355659485
      ],
      "plane_d": -1513.268798828125,
      "bbox_min": [
        -592.5,
        -2668.0,
        779.5
      ],
      "bbox_max": [
        -586.5,
        -2635.5,
        787.300048828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.2873474657535553,
        -0.9578264355659485
      ],
      "plane_d": 1512.3109130859375,
      "bbox_min": [
        -592.5,
        -2664.666748046875,
        779.5
      ],
      "bbox_max": [
        -586.5,
        -2635.5,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -592.5,
        -2642.0,
        787.2999877929688
      ],
      "bbox_max": [
        -586.5,
        -2638.66650390625,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 786.2999877929688,
      "bbox_min": [
        -592.5,
        -2642.0,
        786.2999877929688
      ],
      "bbox_max": [
        -586.5,
        -2635.5,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -787.2999877929688,
      "bbox_min": [
        -592.5,
        -2638.66650390625,
        787.2999877929688
      ],
      "bbox_max": [
        -586.5,
        -2635.5,
        787.2999877929688
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9967280030250549,
        0.0,
        0.08082867413759232
      ],
      "plane_d": -654.065673828125,
      "bbox_min": [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      "bbox_max": [
        -592.691162109375,
        -2668.0,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -779.5,
      "bbox_min": [
        -593.0,
        -2669.10009765625,
        779.5
      ],
      "bbox_max": [
        -592.691162109375,
        -2668.0,
        783.2000122070312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -783.2000122070312,
      "bbox_min": [
        -592.699951171875,
        -2668.35986328125,
        783.2000122070312
      ],
      "bbox_max": [
        -592.691162109375,
        -2668.0,
        783.2000122070312
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CGameArea piece: mt04a",
      "entity_class": "CGameArea",
      "piece_name": "mt04a",
      "offset": 54,
      "centroid": [
        -672.0997314453125,
        -2697.375,
        803.0
      ],
      "bbox_min": [
        -700.0,
        -2802.0,
        760.0
      ],
      "bbox_max": [
        -640.0,
        -2625.0,
        833.3766479492188
      ],
      "dimensions_source": {
        "span_x": 60.0,
        "span_y": 177.0,
        "height_z": 73.37664794921875,
        "door_width": 177.0,
        "door_depth": 60.0,
        "leaf_depth": 60.0,
        "clearance_margin": 0.0,
        "slide_axis": "z",
        "slide_vector": [
          1.0,
          0.0,
          -0.0
        ]
      },
      "vertices": [
        [
          -640.0,
          -2628.0,
          790.0
        ],
        [
          -640.0,
          -2628.0,
          760.0
        ],
        [
          -640.0,
          -2671.0,
          760.0
        ],
        [
          -640.0,
          -2671.0,
          790.0
        ],
        [
          -700.0,
          -2675.0,
          810.0
        ],
        [
          -700.0,
          -2675.0,
          826.0
        ],
        [
          -700.0,
          -2625.0,
          826.0
        ],
        [
          -700.0,
          -2625.0,
          810.0
        ],
        [
          -661.6666870117188,
          -2802.0,
          782.6233520507812
        ],
        [
          -674.89892578125,
          -2802.0,
          811.0
        ],
        [
          -674.89892578125,
          -2688.0,
          811.0
        ],
        [
          -661.6666870117188,
          -2688.0,
          782.6233520507812
        ],
        [
          -685.3333129882812,
          -2688.0,
          833.3766479492188
        ],
        [
          -674.89892578125,
          -2688.0,
          811.0
        ],
        [
          -674.89892578125,
          -2802.0,
          811.0
        ],
        [
          -685.3333129882812,
          -2802.0,
          833.3766479492188
        ]
      ],
      "plane_distance": 640.0
    },
    {
      "tag": "CSlidingDoor piece: m4ad3l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad3l",
      "offset": 2432,
      "centroid": [
        -582.1000061035156,
        -2675.5,
        800.0
      ],
      "bbox_min": [
        -585.0,
        -2675.800048828125,
        795.0
      ],
      "bbox_max": [
        -579.2000122070312,
        -2675.199951171875,
        805.0
      ],
      "dimensions_source": {
        "span_x": 5.79998779296875,
        "span_y": 0.60009765625,
        "height_z": 10.0,
        "door_width": 5.79998779296875,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -585.0,
          -2675.800048828125,
          795.0
        ],
        [
          -585.0,
          -2675.199951171875,
          805.0
        ],
        [
          -585.0,
          -2675.800048828125,
          805.0
        ],
        [
          -585.0,
          -2675.199951171875,
          795.0
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          795.0
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          805.0
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          805.0
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          795.0
        ]
      ],
      "plane_distance": -2675.8,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad3r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad3r",
      "offset": 3679,
      "centroid": [
        -576.3500061035156,
        -2675.5,
        800.0
      ],
      "bbox_min": [
        -579.2000122070312,
        -2675.800048828125,
        795.0
      ],
      "bbox_max": [
        -573.5,
        -2675.199951171875,
        805.0
      ],
      "dimensions_source": {
        "span_x": 5.70001220703125,
        "span_y": 0.60009765625,
        "height_z": 10.0,
        "door_width": 5.70001220703125,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -579.2000122070312,
          -2675.800048828125,
          795.0
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          805.0
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          805.0
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          795.0
        ],
        [
          -573.5,
          -2675.800048828125,
          795.0
        ],
        [
          -573.5,
          -2675.199951171875,
          805.0
        ],
        [
          -573.5,
          -2675.800048828125,
          805.0
        ],
        [
          -573.5,
          -2675.199951171875,
          795.0
        ]
      ],
      "plane_distance": -579.2,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad4l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad4l",
      "offset": 4926,
      "centroid": [
        -596.0,
        -2701.5,
        799.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2704.0,
        795.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2699.0,
        803.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2704.0,
          795.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2704.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2704.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2704.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          795.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad4r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad4r",
      "offset": 6171,
      "centroid": [
        -596.0,
        -2696.5,
        799.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2699.0,
        795.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2694.0,
        803.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2699.0,
          795.0
        ],
        [
          -596.5999755859375,
          -2694.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2694.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2694.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2694.0,
          795.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad5l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad5l",
      "offset": 7418,
      "centroid": [
        -596.0,
        -2767.5,
        799.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2770.0,
        795.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2765.0,
        803.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2770.0,
          795.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2770.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2770.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2770.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          795.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad5r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad5r",
      "offset": 8663,
      "centroid": [
        -596.0,
        -2762.5,
        799.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2765.0,
        795.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2760.0,
        803.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2765.0,
          795.0
        ],
        [
          -596.5999755859375,
          -2760.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          803.0
        ],
        [
          -596.5999755859375,
          -2760.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          795.0
        ],
        [
          -595.4000244140625,
          -2760.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          803.0
        ],
        [
          -595.4000244140625,
          -2760.0,
          795.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad6l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad6l",
      "offset": 9910,
      "centroid": [
        -582.1000061035156,
        -2675.5,
        815.5
      ],
      "bbox_min": [
        -585.0,
        -2675.800048828125,
        810.5
      ],
      "bbox_max": [
        -579.2000122070312,
        -2675.199951171875,
        820.5
      ],
      "dimensions_source": {
        "span_x": 5.79998779296875,
        "span_y": 0.60009765625,
        "height_z": 10.0,
        "door_width": 5.79998779296875,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          -1.0,
          0.0
        ]
      },
      "vertices": [
        [
          -585.0,
          -2675.800048828125,
          810.5
        ],
        [
          -585.0,
          -2675.199951171875,
          820.5
        ],
        [
          -585.0,
          -2675.800048828125,
          820.5
        ],
        [
          -585.0,
          -2675.199951171875,
          810.5
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          810.5
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          820.5
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          820.5
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          810.5
        ]
      ],
      "plane_distance": -2675.8,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad6r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad6r",
      "offset": 11157,
      "centroid": [
        -576.3500061035156,
        -2675.5,
        815.5
      ],
      "bbox_min": [
        -579.2000122070312,
        -2675.800048828125,
        810.5
      ],
      "bbox_max": [
        -573.5,
        -2675.199951171875,
        820.5
      ],
      "dimensions_source": {
        "span_x": 5.70001220703125,
        "span_y": 0.60009765625,
        "height_z": 10.0,
        "door_width": 5.70001220703125,
        "door_depth": 0.60009765625,
        "leaf_depth": 0.56009765625,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -579.2000122070312,
          -2675.800048828125,
          810.5
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          820.5
        ],
        [
          -579.2000122070312,
          -2675.800048828125,
          820.5
        ],
        [
          -579.2000122070312,
          -2675.199951171875,
          810.5
        ],
        [
          -573.5,
          -2675.800048828125,
          810.5
        ],
        [
          -573.5,
          -2675.199951171875,
          820.5
        ],
        [
          -573.5,
          -2675.800048828125,
          820.5
        ],
        [
          -573.5,
          -2675.199951171875,
          810.5
        ]
      ],
      "plane_distance": -579.2,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad7l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad7l",
      "offset": 12404,
      "centroid": [
        -596.0,
        -2701.5,
        816.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2704.0,
        812.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2699.0,
        820.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2704.0,
          812.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2704.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2704.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2704.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          812.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad7r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad7r",
      "offset": 13649,
      "centroid": [
        -596.0,
        -2696.5,
        816.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2699.0,
        812.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2694.0,
        820.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2699.0,
          812.0
        ],
        [
          -596.5999755859375,
          -2694.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2699.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2694.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2694.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2699.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2694.0,
          812.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad8l",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad8l",
      "offset": 14896,
      "centroid": [
        -596.0,
        -2767.5,
        816.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2770.0,
        812.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2765.0,
        820.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2770.0,
          812.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2770.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2770.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2770.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          812.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad8r",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad8r",
      "offset": 16141,
      "centroid": [
        -596.0,
        -2762.5,
        816.0
      ],
      "bbox_min": [
        -596.5999755859375,
        -2765.0,
        812.0
      ],
      "bbox_max": [
        -595.4000244140625,
        -2760.0,
        820.0
      ],
      "dimensions_source": {
        "span_x": 1.199951171875,
        "span_y": 5.0,
        "height_z": 8.0,
        "door_width": 5.0,
        "door_depth": 1.199951171875,
        "leaf_depth": 1.159951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -596.5999755859375,
          -2765.0,
          812.0
        ],
        [
          -596.5999755859375,
          -2760.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2765.0,
          820.0
        ],
        [
          -596.5999755859375,
          -2760.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          812.0
        ],
        [
          -595.4000244140625,
          -2760.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2765.0,
          820.0
        ],
        [
          -595.4000244140625,
          -2760.0,
          812.0
        ]
      ],
      "plane_distance": -596.6,
      "authentic_texture": "chkrooftrak_h"
    },
    {
      "tag": "CSlidingDoor piece: m4ad10",
      "entity_class": "CSlidingDoor",
      "piece_name": "m4ad10",
      "offset": 17388,
      "centroid": [
        -608.5,
        -2650.0,
        815.25
      ],
      "bbox_min": [
        -609.3499755859375,
        -2665.0,
        810.5
      ],
      "bbox_max": [
        -607.6500244140625,
        -2635.0,
        820.0
      ],
      "dimensions_source": {
        "span_x": 1.699951171875,
        "span_y": 30.0,
        "height_z": 9.5,
        "door_width": 30.0,
        "door_depth": 1.699951171875,
        "leaf_depth": 1.659951171875,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          -609.3499755859375,
          -2665.0,
          810.5
        ],
        [
          -609.3499755859375,
          -2635.0,
          820.0
        ],
        [
          -609.3499755859375,
          -2665.0,
          820.0
        ],
        [
          -609.3499755859375,
          -2635.0,
          810.5
        ],
        [
          -607.6500244140625,
          -2665.0,
          810.5
        ],
        [
          -607.6500244140625,
          -2635.0,
          820.0
        ],
        [
          -607.6500244140625,
          -2665.0,
          820.0
        ],
        [
          -607.6500244140625,
          -2635.0,
          810.5
        ]
      ],
      "plane_distance": -609.35,
      "authentic_texture": "chkrooftrak_h"
    }
  ],
  "tutorial_messages": []
}